<template>
  <div>
    <div class="column">
      <div class="custom_table_filters column">
        <div class="component_normal_input_block dis_inb main_white_bg">
          <datepicker
            class="dis_inb"
            v-model="filterStartDate"
            name="uniquename"
            :placeholder="$t('msg.start_date')"
          ></datepicker>
        </div>
        <div class="component_normal_input_block dis_inb main_white_bg">
          <datepicker
            class="dis_inb"
            v-model="filterEndDate"
            name="uniquename"
            :placeholder="$t('msg.end_date')"
          ></datepicker>
        </div>

        <div class="component_normal_input_block dis_inb main_white_bg">
          <select v-model="statusFilter">
            <option value="all">{{ $tc("msg.all", 1) }}</option>
            <option value="cancelled">{{ $tc("msg.cancelled", 1) }}</option>
            <option value="done">{{ $tc("msg.status_done") }}</option>
            <option value="expired">{{ $tc("msg.status_expired") }}</option>
            <option value="failed">{{ $tc("msg.failed", 1) }}</option>
            <option value="new">{{ $tc("msg.new") }}</option>
            <option value="waiting">{{ $tc("msg.waiting", 1) }}</option>
          </select>
        </div>

        <button
          class="
            main_blue_lt_bg main_blue_lt_bg_hover
            component_main_button
            upper
          "
          @click="applyFilter()"
        >
          {{ $tc("msg.apply_filter", 1) }}
        </button>
        <button
          class="
            main_blue_lt_bg main_blue_lt_bg_hover
            component_main_button
            upper
          "
          @click="clearFilter()"
        >
          {{ $tc("msg.clear_filter", 1) }}
        </button>
      </div>
    </div>
    <div class="column tal_r">
      <input
        v-model="searchBox"
        class="custom_input_white"
        :placeholder="$t('msg.global_search')"
      />
    </div>
    <div class="column">
      <vue-good-table
        class="tables_transactions"
        :columns="columns"
        :rows="purchasesOnPage"
        :select-options="{ enabled: false }"
        :search-options="{
          enabled: true,
          searchFn: customSearch,
          externalQuery: searchBox,
        }"
        ref="historytable"
        :line-numbers="true"
        :sort-options="{
          enabled: true,
          initialSortBy: { field: 'createdAt', type: 'desc' },
        }"
        :pagination-options="{
          enabled: true,
          mode: 'records',
          perPage: '5',
          position: 'down',
          perPageDropdown: [10, 15, 20],
          dropdownAllowAll: false,
          nextLabel: 'next',
          prevLabel: 'prev',
          rowsPerPageLabel: 'per page',
          ofLabel: 'of',
          pageLabel: 'page', // for 'pages' mode
          allLabel: 'All',
        }"
      >
        <template slot="table-column" slot-scope="props">
          <span v-if="props.column.label == 'id'">{{ $t("msg.txid") }}</span>
          <span v-if="props.column.label == 'createdAt'">{{
            $t("msg.createdAt")
          }}</span>
          <span v-if="props.column.label == 'updatedAt'">{{
            $t("msg.updatedAt")
          }}</span>
          <span v-if="props.column.label == 'targetPrice'">{{
            $t("msg.price")
          }}</span>
          <span v-if="props.column.label == 'targetAmount'">{{
            $t("msg.quantity")
          }}</span>
          <span v-if="props.column.label == 'fee'">{{
            $tc(`msg.fee`, 1)
          }}</span>
          <span v-if="props.column.label == 'subTotal'">Subtotal</span>
          <span v-if="props.column.label == 'total'">{{
            $t("msg.total")
          }}</span>
          <span v-if="props.column.label == 'status'">{{
            $t("msg.status")
          }}</span>
          <span v-if="props.column.label == 'actions'">{{
            $t("msg.actions")
          }}</span>
        </template>

        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field == 'tokenTxid'">
            <span v-if="props.row.tokenTxid">
              <a
                :title="$t('msg.details')"
                :href="
                  'https://bscscan.com/tx/' +
                  props.formattedRow[props.column.field]
                "
                target="blank_"
              >
                {{ ajustTokenID(props.formattedRow[props.column.field]) }}
              </a>
            </span>
            <span v-else> ----- </span>
          </span>
          <span v-if="props.column.field == 'createdAt'">
            {{ formatDate(props.formattedRow[props.column.field]) }}
          </span>
          <span v-if="props.column.field == 'updatedAt'">
            {{ formatDate(props.formattedRow[props.column.field]) }}
          </span>
          <span v-if="props.column.field == 'targetPrice'">
            <span v-if="props.formattedRow[props.column.field] > 0"
              >{{ props.formattedRow[props.column.field].toFixed(6) }}
              {{ props.formattedRow.sourceCurrency.symbol }}</span
            >
            <span v-else>-</span>
          </span>
          <span v-if="props.column.field == 'targetAmount'">
            <span v-if="props.formattedRow[props.column.field] > 0"
              >{{
                (
                  (props.formattedRow.targetAmount *
                    props.formattedRow.targetPrice -
                    props.formattedRow.sourceFee) /
                  props.formattedRow.targetPrice
                ).toFixed(6)
              }}
              BLUE</span
            >
            <span v-else>-</span>
          </span>
          <span v-if="props.column.field == 'sourceFee'">
            <span v-if="props.formattedRow[props.column.field] > 0"
              >{{ props.formattedRow[props.column.field].toFixed(6) }}
              {{ props.formattedRow.sourceCurrency.symbol }}</span
            >
            <span v-else>-</span>
          </span>
          <span v-if="props.column.field == 'subTotal'">
            <span v-if="props.formattedRow.targetPrice > 0">
              <!-- {{
                subTotalBlue(
                  props.formattedRow.targetPrice,
                  props.formattedRow.targetAmount,
                  props.formattedRow.sourceCurrency.symbol
                )
              }} -->

              {{
                (
                  props.formattedRow.targetAmount *
                    props.formattedRow.targetPrice -
                  props.formattedRow.sourceFee
                ).toFixed(6)
              }}
              {{ props.formattedRow.sourceCurrency.symbol }}
            </span>
          </span>
          <span v-if="props.column.field == 'total'">
            <span
              v-if="
                props.formattedRow.targetPrice &&
                props.formattedRow.targetAmount &&
                props.formattedRow.sourceFee
              "
            >
              <!-- {{
                totalBlue(
                  props.formattedRow.targetPrice,
                  props.formattedRow.targetAmount,
                  props.formattedRow.sourceFee
                )
              }} -->
              {{
                (
                  props.formattedRow.targetAmount *
                  props.formattedRow.targetPrice
                ).toFixed(6)
              }}
              {{ props.formattedRow.sourceCurrency.symbol }}
            </span>
            <span v-else> -- </span>
          </span>
          <span v-if="props.column.field == 'status'">
            {{ $t("msg.status_" + props.formattedRow[props.column.field]) }}
          </span>
          <span v-if="props.column.field == 'actions'">
            <a
              class="icon_class_1"
              @click="getDetails(props.row)"
              v-html="iconSets.plus"
              >Get Details</a
            >
            <span
              v-if="props.row.type == 'purchase' && props.row.status == 'done'"
            >
              <a
                class="icon_class_1"
                @click="getCertificateByID(props.row.id, props.row.type)"
                v-html="iconSets.download"
                >Get Certificate</a
              >
              <!-- {{props.row.type}} -->
            </span>
          </span>
        </template>

        <div slot="emptystate">
          <p class="tac">{{ $tc("msg.no_data_found", 1) }}</p>
        </div>
      </vue-good-table>
      <div v-if="transactionData" class="page_history_full_data">
        <div class="cointainer_lg combo_1 tal_r">
          <a
            class="page_history_full_data_close"
            @click="clearTransactionData()"
            >X</a
          >
        </div>
        <div class="cointainer_lg combo_1">
          <transaction-details
            :transactionData="transactionData"
            @updateCancelled="updateCancelled"
            class
          ></transaction-details>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import Datepicker from "vuejs-datepicker";
import TransactionDetails from "./TransactionDetails";
import spacetime from "spacetime";

export default {
  created() {
    this.getPurchases();
  },
  mounted() {},
  data: () => ({
    searchBox: "",
    statusFilter: "all",
    filterStartDate: "",
    filterEndDate: "",
    purchases: [],
    purchasesOnPage: [],
    transactionData: "",
    columns: [
      {
        label: "sourceCurrency",
        field: "sourceCurrency",
        hidden: true,
      },
      {
        label: "id",
        field: "tokenTxid",
        filterable: true,
      },
      {
        label: "createdAt",
        field: "createdAt",
      },
      {
        label: "updatedAt",
        field: "updatedAt",
      },
      {
        label: "targetAmount",
        field: "targetAmount",
        type: "number",
        filterable: true,
      },
      {
        label: "targetPrice",
        field: "targetPrice",
        type: "number",
        filterable: true,
      },
      {
        label: "subTotal",
        field: "subTotal",
        filterable: true,
      },
      {
        label: "fee",
        field: "sourceFee",
        filterable: true,
      },
      {
        label: "total",
        field: "total",
        filterable: true,
      },
      {
        label: "status",
        field: "status",
        filterable: true,
      },
      {
        label: "actions",
        field: "actions",
        filterable: false,
      },
    ],
  }),
  components: {
    Datepicker,
    TransactionDetails,
  },
  methods: {
    totalBlue(price, amount, fee) {
      let total = 0;

      if (price > 0 && amount > 0 && fee > 0) {
        total = price * amount + fee;
        return total.toFixed(8);
      } else {
        return "-";
      }
    },

    symbAjust(el) {
      if (el == "BLU") {
        return "BLUE";
      } else {
        return el;
      }
    },

    subTotalBlue(price, amount, symbol) {
      let total = 0;

      if (price > 0 && amount > 0) {
        total = price * amount;
        return total.toFixed(8) + " " + symbol;
      } else {
        return "--";
      }
    },
    async getPurchases() {
      try {
        let resp = await this.$store.dispatch("getPurchases");
        this.purchases = resp.data;

        this.purchasesOnPage = this.sortByCreatedAt(this.purchases);
        // let teste = [
        //   {
        //     createdAt: "2021-05-26T16:27:41.314Z",
        //     expiresIn: 604800000,
        //     id: "702a59e4-be58-11eb-826c-0ff4922e1cc5",
        //     insertTime: "0001-01-01T00:00:00.000Z",
        //     ip: "170.82.175.4",
        //     lastUpdate: "0001-01-01T00:00:00.000Z",
        //     memberId: "733ca8e0-b434-11eb-af16-73f8bb15f4d6",
        //     pinId: "00000000-0000-0000-0000-000000000000",
        //     sellerId: "b118d17a-b411-11eb-9450-47e1e1615544",
        //     settledAt: "0001-01-01T00:00:00.000Z",
        //     sourceAccountId: "8b514a80-b434-11eb-83c1-7b96f50b7d53",
        //     sourceAmount: 0.00009433962264150944,
        //     sourceCurrency: {
        //       id: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
        //       isAvailable: true,
        //       marketPercent: 22.5,
        //       name: "Ethereum",
        //       onlyAsset: false,
        //       precision: 8,
        //       symbol: "ETH",
        //       taxes: [
        //         {
        //           bonusRefer: 1,
        //           charityReferred: 3,
        //           charitySimple: 1,
        //           createdAt: "2021-02-01T00:00:00.000Z",
        //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "e53001f0-6aff-11eb-b011-e7f585edc40d",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.25,
        //           rewardAmbassador: 2.75,
        //           rewardReferred: 2,
        //           startAt: "2021-02-01T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusRefer: 1,
        //           bonusReferrer: 1,
        //           charityReferred: 1,
        //           charitySimple: 3,
        //           createdAt: "2019-08-01T16:37:25.014Z",
        //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "a47cb226-b47a-11e9-9d96-73a1ce6e16f1",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 3,
        //           rewardReferred: 2,
        //           startAt: "2019-03-16T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusReferrer: 1,
        //           charityReferred: 1,
        //           charitySimple: 3,
        //           createdAt: "2021-02-09T15:27:01.495Z",
        //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 0.002,
        //           id: "a47cc2ac-b47a-11e9-9d97-cbb9a5578da5",
        //           math: "absolut",
        //           revenue: 2,
        //           rewardAmbassador: 3,
        //           startAt: "2018-11-01T00:00:00.000Z",
        //           type: "redeem",
        //         },
        //       ],
        //       tradeMinimal: 1e-7,
        //     },
        //     sourceFee: 0.0000056604,
        //     status: "expired",
        //     step: 1,
        //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
        //     targetAddress: "0x3474f6a9be8dce93c556e3d34df0752489c27ed1",
        //     targetAmount: 0.0005729432556363258,
        //     targetCurrency: {
        //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
        //       isAvailable: true,
        //       name: "Stratumblue",
        //       onlyAsset: false,
        //       precision: 6,
        //       symbol: "BLU",
        //       taxes: null,
        //       tradeMinimal: 2,
        //       withdrawMinimal: 0.01,
        //     },
        //     targetPrice: 0.16465788141049567,
        //     type: "purchase",
        //     updatedAt: "2021-05-28T18:18:40.049Z",
        //   },
        //   {
        //     createdAt: "2021-05-13T15:12:25.202Z",
        //     expiresIn: 604800000,
        //     id: "c4fbb126-b416-11eb-92a7-530ef5acc9ef",
        //     insertTime: "0001-01-01T00:00:00.000Z",
        //     ip: "187.85.159.181",
        //     lastUpdate: "0001-01-01T00:00:00.000Z",
        //     memberId: "0c8bc172-5c1d-11eb-85e9-5be84782a906",
        //     pinId: "00000000-0000-0000-0000-000000000000",
        //     sellerId: "b118d17a-b411-11eb-9450-47e1e1615544",
        //     settledAt: "0001-01-01T00:00:00.000Z",
        //     sourceAccountId: "93dbe750-5c1e-11eb-85eb-630bdf68589d",
        //     sourceCurrency: {
        //       id: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //       isAvailable: true,
        //       marketPercent: 22.5,
        //       name: "Bitcoin",
        //       onlyAsset: false,
        //       precision: 8,
        //       symbol: "BTC",
        //       taxes: [
        //         {
        //           bonusRefer: 1,
        //           charityReferred: 3,
        //           charitySimple: 1,
        //           createdAt: "2021-02-01T00:00:00.000Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "e52fa818-6aff-11eb-b00d-8ff92bf3258e",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.25,
        //           rewardAmbassador: 2.75,
        //           rewardReferred: 2,
        //           startAt: "2021-02-01T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusRefer: 1,
        //           charityReferred: 3,
        //           charitySimple: 1,
        //           createdAt: "2020-07-14T00:00:00.000Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "b520ae4a-d065-11ea-b9f2-ab57e2ffff62",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 2.4,
        //           rewardReferred: 2,
        //           startAt: "2020-07-14T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusRefer: 1,
        //           bonusReferrer: 1,
        //           charityReferred: 1,
        //           charitySimple: 3,
        //           createdAt: "2019-03-31T18:17:57.882Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "4f8c3baa-53e1-11e9-a9df-b77dd05ebe45",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 3,
        //           rewardReferred: 2,
        //           startAt: "2019-04-11T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusReferrer: 1,
        //           charityReferred: 1,
        //           charitySimple: 3,
        //           createdAt: "2019-06-19T01:14:00.371Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 0.0010000000474974513,
        //           id: "84fbc814-922f-11e9-9877-1fee431c43ef",
        //           math: "absolut",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 3,
        //           startAt: "2018-11-01T00:00:00.000Z",
        //           type: "redeem",
        //         },
        //       ],
        //       tradeMinimal: 0.002,
        //       withdrawMinimal: 0.02,
        //     },
        //     status: "expired",
        //     step: 1,
        //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
        //     targetAddress: "12XZSEzFJPv7XVSFCA384Me3pq9JxLuEKx",
        //     targetCurrency: {
        //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
        //       isAvailable: true,
        //       name: "Stratumblue",
        //       onlyAsset: false,
        //       precision: 6,
        //       symbol: "BLU",
        //       taxes: null,
        //       tradeMinimal: 2,
        //       withdrawMinimal: 0.01,
        //     },
        //     targetPrice: 0.012438444330022735,
        //     type: "purchase",
        //     updatedAt: "2021-05-13T15:13:50.133Z",
        //   },
        //   {
        //     createdAt: "2021-05-13T17:17:19.975Z",
        //     expiresIn: 604800000,
        //     id: "38373afa-b428-11eb-96a5-2bea9f8b9f27",
        //     insertTime: "0001-01-01T00:00:00.000Z",
        //     ip: "187.85.159.181",
        //     lastUpdate: "0001-01-01T00:00:00.000Z",
        //     memberId: "0c8bc172-5c1d-11eb-85e9-5be84782a906",
        //     pinId: "00000000-0000-0000-0000-000000000000",
        //     sellerId: "b118d17a-b411-11eb-9450-47e1e1615544",
        //     settledAt: "0001-01-01T00:00:00.000Z",
        //     sourceAccountId: "93dbe750-5c1e-11eb-85eb-630bdf68589d",
        //     sourceCurrency: {
        //       id: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //       isAvailable: true,
        //       marketPercent: 22.5,
        //       name: "Bitcoin",
        //       onlyAsset: false,
        //       precision: 8,
        //       symbol: "BTC",
        //       taxes: [
        //         {
        //           bonusRefer: 1,
        //           charityReferred: 3,
        //           charitySimple: 1,
        //           createdAt: "2021-02-01T00:00:00.000Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "e52fa818-6aff-11eb-b00d-8ff92bf3258e",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.25,
        //           rewardAmbassador: 2.75,
        //           rewardReferred: 2,
        //           startAt: "2021-02-01T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusRefer: 1,
        //           charityReferred: 3,
        //           charitySimple: 1,
        //           createdAt: "2020-07-14T00:00:00.000Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "b520ae4a-d065-11ea-b9f2-ab57e2ffff62",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 2.4,
        //           rewardReferred: 2,
        //           startAt: "2020-07-14T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusRefer: 1,
        //           bonusReferrer: 1,
        //           charityReferred: 1,
        //           charitySimple: 3,
        //           createdAt: "2019-03-31T18:17:57.882Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "4f8c3baa-53e1-11e9-a9df-b77dd05ebe45",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 3,
        //           rewardReferred: 2,
        //           startAt: "2019-04-11T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusReferrer: 1,
        //           charityReferred: 1,
        //           charitySimple: 3,
        //           createdAt: "2019-06-19T01:14:00.371Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 0.0010000000474974513,
        //           id: "84fbc814-922f-11e9-9877-1fee431c43ef",
        //           math: "absolut",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 3,
        //           startAt: "2018-11-01T00:00:00.000Z",
        //           type: "redeem",
        //         },
        //       ],
        //       tradeMinimal: 0.002,
        //       withdrawMinimal: 0.02,
        //     },
        //     status: "expired",
        //     step: 1,
        //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
        //     targetAddress: "1DCzm3phcSW4ML1Ca4hRnh49oGys98i89A",
        //     targetCurrency: {
        //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
        //       isAvailable: true,
        //       name: "Stratumblue",
        //       onlyAsset: false,
        //       precision: 6,
        //       symbol: "BLU",
        //       taxes: null,
        //       tradeMinimal: 2,
        //       withdrawMinimal: 0.01,
        //     },
        //     targetPrice: 0.01231585600187841,
        //     type: "purchase",
        //     updatedAt: "2021-05-13T17:39:50.193Z",
        //   },
        //   {
        //     createdAt: "2021-05-25T14:16:17.922Z",
        //     expiresIn: 604800000,
        //     id: "eae276bc-bd7c-11eb-b92b-2fbe058ee326",
        //     insertTime: "0001-01-01T00:00:00.000Z",
        //     ip: "187.85.159.181",
        //     lastUpdate: "0001-01-01T00:00:00.000Z",
        //     memberId: "733ca8e0-b434-11eb-af16-73f8bb15f4d6",
        //     pinId: "00000000-0000-0000-0000-000000000000",
        //     sellerId: "b118d17a-b411-11eb-9450-47e1e1615544",
        //     settledAt: "0001-01-01T00:00:00.000Z",
        //     sourceAccountId: "8b514a80-b434-11eb-83c1-7b96f50b7d53",
        //     sourceCurrency: {
        //       id: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
        //       isAvailable: true,
        //       marketPercent: 22.5,
        //       name: "Ethereum",
        //       onlyAsset: false,
        //       precision: 8,
        //       symbol: "ETH",
        //       taxes: [
        //         {
        //           bonusRefer: 1,
        //           charityReferred: 3,
        //           charitySimple: 1,
        //           createdAt: "2021-02-01T00:00:00.000Z",
        //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "e53001f0-6aff-11eb-b011-e7f585edc40d",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.25,
        //           rewardAmbassador: 2.75,
        //           rewardReferred: 2,
        //           startAt: "2021-02-01T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusRefer: 1,
        //           bonusReferrer: 1,
        //           charityReferred: 1,
        //           charitySimple: 3,
        //           createdAt: "2019-08-01T16:37:25.014Z",
        //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "a47cb226-b47a-11e9-9d96-73a1ce6e16f1",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 3,
        //           rewardReferred: 2,
        //           startAt: "2019-03-16T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusReferrer: 1,
        //           charityReferred: 1,
        //           charitySimple: 3,
        //           createdAt: "2021-02-09T15:27:01.495Z",
        //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 0.002,
        //           id: "a47cc2ac-b47a-11e9-9d97-cbb9a5578da5",
        //           math: "absolut",
        //           revenue: 2,
        //           rewardAmbassador: 3,
        //           startAt: "2018-11-01T00:00:00.000Z",
        //           type: "redeem",
        //         },
        //       ],
        //       tradeMinimal: 1e-7,
        //     },
        //     status: "expired",
        //     step: 1,
        //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
        //     targetAddress: "0x0df1227eae30065e07470eb3d2f4eebe2843f97b",
        //     targetCurrency: {
        //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
        //       isAvailable: true,
        //       name: "Stratumblue",
        //       onlyAsset: false,
        //       precision: 6,
        //       symbol: "BLU",
        //       taxes: null,
        //       tradeMinimal: 2,
        //       withdrawMinimal: 0.01,
        //     },
        //     targetPrice: 0.16214683570086755,
        //     type: "purchase",
        //     updatedAt: "2021-05-25T14:18:31.223Z",
        //   },
        //   {
        //     createdAt: "2021-05-25T14:18:35.679Z",
        //     expiresIn: 604800000,
        //     id: "3cfe8b84-bd7d-11eb-b642-e7599156ce8b",
        //     insertTime: "0001-01-01T00:00:00.000Z",
        //     ip: "187.85.159.181",
        //     lastUpdate: "0001-01-01T00:00:00.000Z",
        //     memberId: "733ca8e0-b434-11eb-af16-73f8bb15f4d6",
        //     pinId: "00000000-0000-0000-0000-000000000000",
        //     sellerId: "b118d17a-b411-11eb-9450-47e1e1615544",
        //     settledAt: "0001-01-01T00:00:00.000Z",
        //     sourceAccountId: "8b514a80-b434-11eb-83c1-7b96f50b7d53",
        //     sourceCurrency: {
        //       id: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
        //       isAvailable: true,
        //       marketPercent: 22.5,
        //       name: "Ethereum",
        //       onlyAsset: false,
        //       precision: 8,
        //       symbol: "ETH",
        //       taxes: [
        //         {
        //           bonusRefer: 1,
        //           charityReferred: 3,
        //           charitySimple: 1,
        //           createdAt: "2021-02-01T00:00:00.000Z",
        //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "e53001f0-6aff-11eb-b011-e7f585edc40d",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.25,
        //           rewardAmbassador: 2.75,
        //           rewardReferred: 2,
        //           startAt: "2021-02-01T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusRefer: 1,
        //           bonusReferrer: 1,
        //           charityReferred: 1,
        //           charitySimple: 3,
        //           createdAt: "2019-08-01T16:37:25.014Z",
        //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "a47cb226-b47a-11e9-9d96-73a1ce6e16f1",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 3,
        //           rewardReferred: 2,
        //           startAt: "2019-03-16T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusReferrer: 1,
        //           charityReferred: 1,
        //           charitySimple: 3,
        //           createdAt: "2021-02-09T15:27:01.495Z",
        //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 0.002,
        //           id: "a47cc2ac-b47a-11e9-9d97-cbb9a5578da5",
        //           math: "absolut",
        //           revenue: 2,
        //           rewardAmbassador: 3,
        //           startAt: "2018-11-01T00:00:00.000Z",
        //           type: "redeem",
        //         },
        //       ],
        //       tradeMinimal: 1e-7,
        //     },
        //     status: "expired",
        //     step: 1,
        //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
        //     targetAddress: "0x135097ba8d50664fd71411b0dbba4f8119df9093",
        //     targetCurrency: {
        //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
        //       isAvailable: true,
        //       name: "Stratumblue",
        //       onlyAsset: false,
        //       precision: 6,
        //       symbol: "BLU",
        //       taxes: null,
        //       tradeMinimal: 2,
        //       withdrawMinimal: 0.01,
        //     },
        //     targetPrice: 0.16308946921348916,
        //     type: "purchase",
        //     updatedAt: "2021-05-25T14:20:37.730Z",
        //   },
        //   {
        //     createdAt: "2021-05-25T14:20:23.995Z",
        //     expiresIn: 604800000,
        //     id: "7d8e481a-bd7d-11eb-95e9-ffc60395ebcb",
        //     insertTime: "0001-01-01T00:00:00.000Z",
        //     ip: "170.82.175.4",
        //     lastUpdate: "0001-01-01T00:00:00.000Z",
        //     memberId: "733ca8e0-b434-11eb-af16-73f8bb15f4d6",
        //     pinId: "00000000-0000-0000-0000-000000000000",
        //     sellerId: "b118d17a-b411-11eb-9450-47e1e1615544",
        //     settled: true,
        //     settledAt: "2021-05-27T00:12:20.822Z",
        //     sourceAccountId: "8b514a80-b434-11eb-83c1-7b96f50b7d53",
        //     sourceAmount: 0.0000679245283018868,
        //     sourceCurrency: {
        //       id: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
        //       isAvailable: true,
        //       marketPercent: 22.5,
        //       name: "Ethereum",
        //       onlyAsset: false,
        //       precision: 8,
        //       symbol: "ETH",
        //       taxes: [
        //         {
        //           bonusRefer: 1,
        //           charityReferred: 3,
        //           charitySimple: 1,
        //           createdAt: "2021-02-01T00:00:00.000Z",
        //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "e53001f0-6aff-11eb-b011-e7f585edc40d",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.25,
        //           rewardAmbassador: 2.75,
        //           rewardReferred: 2,
        //           startAt: "2021-02-01T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusRefer: 1,
        //           bonusReferrer: 1,
        //           charityReferred: 1,
        //           charitySimple: 3,
        //           createdAt: "2019-08-01T16:37:25.014Z",
        //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "a47cb226-b47a-11e9-9d96-73a1ce6e16f1",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 3,
        //           rewardReferred: 2,
        //           startAt: "2019-03-16T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusReferrer: 1,
        //           charityReferred: 1,
        //           charitySimple: 3,
        //           createdAt: "2021-02-09T15:27:01.495Z",
        //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 0.002,
        //           id: "a47cc2ac-b47a-11e9-9d97-cbb9a5578da5",
        //           math: "absolut",
        //           revenue: 2,
        //           rewardAmbassador: 3,
        //           startAt: "2018-11-01T00:00:00.000Z",
        //           type: "redeem",
        //         },
        //       ],
        //       tradeMinimal: 1e-7,
        //     },
        //     sourceFee: 0.0000040755,
        //     status: "done",
        //     step: 4,
        //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
        //     targetAddress: "0x0fad125042af4325489349d0a595bd7224709b36",
        //     targetAmount: 0.00041653325893218685,
        //     targetCurrency: {
        //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
        //       isAvailable: true,
        //       name: "Stratumblue",
        //       onlyAsset: false,
        //       precision: 6,
        //       symbol: "BLU",
        //       taxes: null,
        //       tradeMinimal: 2,
        //       withdrawMinimal: 0.01,
        //     },
        //     targetPrice: 0.16307107978848134,
        //     tokenStatus: "done",
        //     tokenStep: "steps_done",
        //     tokenTxid:
        //       "d414a31cd24840bc1e54e4018b21c90fb5eff390f9facab07e7d770aea8a0dbb",
        //     type: "purchase",
        //     updatedAt: "2021-05-25T14:39:27.627Z",
        //   },
        //   {
        //     createdAt: "2021-05-25T14:47:13.683Z",
        //     expiresIn: 604800000,
        //     id: "3d0137d6-bd81-11eb-9236-732c3a40e35a",
        //     insertTime: "0001-01-01T00:00:00.000Z",
        //     ip: "187.85.159.181",
        //     lastUpdate: "0001-01-01T00:00:00.000Z",
        //     memberId: "733ca8e0-b434-11eb-af16-73f8bb15f4d6",
        //     pinId: "00000000-0000-0000-0000-000000000000",
        //     sellerId: "b118d17a-b411-11eb-9450-47e1e1615544",
        //     settledAt: "0001-01-01T00:00:00.000Z",
        //     sourceAccountId: "8b266b08-b434-11eb-9c89-bfdce0d587b5",
        //     sourceCurrency: {
        //       id: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //       isAvailable: true,
        //       marketPercent: 22.5,
        //       name: "Bitcoin",
        //       onlyAsset: false,
        //       precision: 8,
        //       symbol: "BTC",
        //       taxes: [
        //         {
        //           bonusRefer: 1,
        //           charityReferred: 3,
        //           charitySimple: 1,
        //           createdAt: "2021-02-01T00:00:00.000Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "e52fa818-6aff-11eb-b00d-8ff92bf3258e",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.25,
        //           rewardAmbassador: 2.75,
        //           rewardReferred: 2,
        //           startAt: "2021-02-01T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusRefer: 1,
        //           charityReferred: 3,
        //           charitySimple: 1,
        //           createdAt: "2020-07-14T00:00:00.000Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "b520ae4a-d065-11ea-b9f2-ab57e2ffff62",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 2.4,
        //           rewardReferred: 2,
        //           startAt: "2020-07-14T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusRefer: 1,
        //           bonusReferrer: 1,
        //           charityReferred: 1,
        //           charitySimple: 3,
        //           createdAt: "2019-03-31T18:17:57.882Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "4f8c3baa-53e1-11e9-a9df-b77dd05ebe45",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 3,
        //           rewardReferred: 2,
        //           startAt: "2019-04-11T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusReferrer: 1,
        //           charityReferred: 1,
        //           charitySimple: 3,
        //           createdAt: "2019-06-19T01:14:00.371Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 0.0010000000474974513,
        //           id: "84fbc814-922f-11e9-9877-1fee431c43ef",
        //           math: "absolut",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 3,
        //           startAt: "2018-11-01T00:00:00.000Z",
        //           type: "redeem",
        //         },
        //       ],
        //       tradeMinimal: 0.002,
        //       withdrawMinimal: 0.02,
        //     },
        //     status: "expired",
        //     step: 1,
        //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
        //     targetAddress: "18svbuBgtzDHdxXhkVNbpGh96f7PSHMuYp",
        //     targetCurrency: {
        //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
        //       isAvailable: true,
        //       name: "Stratumblue",
        //       onlyAsset: false,
        //       precision: 6,
        //       symbol: "BLU",
        //       taxes: null,
        //       tradeMinimal: 2,
        //       withdrawMinimal: 0.01,
        //     },
        //     targetPrice: 0.011030473532582262,
        //     type: "purchase",
        //     updatedAt: "2021-05-26T16:14:02.382Z",
        //   },
        //   {
        //     createdAt: "2021-05-26T16:13:29.282Z",
        //     expiresIn: 604800000,
        //     id: "7450b7ea-be56-11eb-a48c-c3bf7242a49f",
        //     insertTime: "0001-01-01T00:00:00.000Z",
        //     ip: "170.82.175.4",
        //     lastUpdate: "0001-01-01T00:00:00.000Z",
        //     memberId: "733ca8e0-b434-11eb-af16-73f8bb15f4d6",
        //     pinId: "00000000-0000-0000-0000-000000000000",
        //     sellerId: "b118d17a-b411-11eb-9450-47e1e1615544",
        //     settledAt: "0001-01-01T00:00:00.000Z",
        //     sourceAccountId: "8b266b08-b434-11eb-9c89-bfdce0d587b5",
        //     sourceCurrency: {
        //       id: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //       isAvailable: true,
        //       marketPercent: 22.5,
        //       name: "Bitcoin",
        //       onlyAsset: false,
        //       precision: 8,
        //       symbol: "BTC",
        //       taxes: [
        //         {
        //           bonusRefer: 1,
        //           charityReferred: 3,
        //           charitySimple: 1,
        //           createdAt: "2021-02-01T00:00:00.000Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "e52fa818-6aff-11eb-b00d-8ff92bf3258e",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.25,
        //           rewardAmbassador: 2.75,
        //           rewardReferred: 2,
        //           startAt: "2021-02-01T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusRefer: 1,
        //           charityReferred: 3,
        //           charitySimple: 1,
        //           createdAt: "2020-07-14T00:00:00.000Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "b520ae4a-d065-11ea-b9f2-ab57e2ffff62",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 2.4,
        //           rewardReferred: 2,
        //           startAt: "2020-07-14T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusRefer: 1,
        //           bonusReferrer: 1,
        //           charityReferred: 1,
        //           charitySimple: 3,
        //           createdAt: "2019-03-31T18:17:57.882Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "4f8c3baa-53e1-11e9-a9df-b77dd05ebe45",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 3,
        //           rewardReferred: 2,
        //           startAt: "2019-04-11T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusReferrer: 1,
        //           charityReferred: 1,
        //           charitySimple: 3,
        //           createdAt: "2019-06-19T01:14:00.371Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 0.0010000000474974513,
        //           id: "84fbc814-922f-11e9-9877-1fee431c43ef",
        //           math: "absolut",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 3,
        //           startAt: "2018-11-01T00:00:00.000Z",
        //           type: "redeem",
        //         },
        //       ],
        //       tradeMinimal: 0.002,
        //       withdrawMinimal: 0.02,
        //     },
        //     status: "expired",
        //     step: 1,
        //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
        //     targetAddress: "12xkguRYSqCPgZeLwwmDAXsYNxpnSeSQ9n",
        //     targetCurrency: {
        //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
        //       isAvailable: true,
        //       name: "Stratumblue",
        //       onlyAsset: false,
        //       precision: 6,
        //       symbol: "BLU",
        //       taxes: null,
        //       tradeMinimal: 2,
        //       withdrawMinimal: 0.01,
        //     },
        //     targetPrice: 0.011630928598504307,
        //     type: "purchase",
        //     updatedAt: "2021-05-26T16:24:31.755Z",
        //   },
        //   {
        //     createdAt: "2021-05-26T16:25:52.337Z",
        //     expiresIn: 604800000,
        //     id: "2f35c61c-be58-11eb-b374-373755d74cd1",
        //     insertTime: "0001-01-01T00:00:00.000Z",
        //     ip: "170.82.175.4",
        //     lastUpdate: "0001-01-01T00:00:00.000Z",
        //     memberId: "733ca8e0-b434-11eb-af16-73f8bb15f4d6",
        //     pinId: "00000000-0000-0000-0000-000000000000",
        //     sellerId: "b118d17a-b411-11eb-9450-47e1e1615544",
        //     settledAt: "0001-01-01T00:00:00.000Z",
        //     sourceAccountId: "8b514a80-b434-11eb-83c1-7b96f50b7d53",
        //     sourceCurrency: {
        //       id: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
        //       isAvailable: true,
        //       marketPercent: 22.5,
        //       name: "Ethereum",
        //       onlyAsset: false,
        //       precision: 8,
        //       symbol: "ETH",
        //       taxes: [
        //         {
        //           bonusRefer: 1,
        //           charityReferred: 3,
        //           charitySimple: 1,
        //           createdAt: "2021-02-01T00:00:00.000Z",
        //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "e53001f0-6aff-11eb-b011-e7f585edc40d",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.25,
        //           rewardAmbassador: 2.75,
        //           rewardReferred: 2,
        //           startAt: "2021-02-01T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusRefer: 1,
        //           bonusReferrer: 1,
        //           charityReferred: 1,
        //           charitySimple: 3,
        //           createdAt: "2019-08-01T16:37:25.014Z",
        //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "a47cb226-b47a-11e9-9d96-73a1ce6e16f1",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 3,
        //           rewardReferred: 2,
        //           startAt: "2019-03-16T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusReferrer: 1,
        //           charityReferred: 1,
        //           charitySimple: 3,
        //           createdAt: "2021-02-09T15:27:01.495Z",
        //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 0.002,
        //           id: "a47cc2ac-b47a-11e9-9d97-cbb9a5578da5",
        //           math: "absolut",
        //           revenue: 2,
        //           rewardAmbassador: 3,
        //           startAt: "2018-11-01T00:00:00.000Z",
        //           type: "redeem",
        //         },
        //       ],
        //       tradeMinimal: 1e-7,
        //     },
        //     status: "expired",
        //     step: 1,
        //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
        //     targetAddress: "0x342a8b92597793eb9d3ff2df6354fc93e10aa4bd",
        //     targetCurrency: {
        //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
        //       isAvailable: true,
        //       name: "Stratumblue",
        //       onlyAsset: false,
        //       precision: 6,
        //       symbol: "BLU",
        //       taxes: null,
        //       tradeMinimal: 2,
        //       withdrawMinimal: 0.01,
        //     },
        //     targetPrice: 0.1640864917994793,
        //     type: "purchase",
        //     updatedAt: "2021-05-26T16:27:41.191Z",
        //   },
        //   {
        //     createdAt: "2021-10-22T12:19:38.836Z",
        //     expiresIn: 604800000,
        //     id: "791143fc-334b-11ec-aff2-c75cc5b026c8",
        //     insertTime: "0001-01-01T00:00:00.000Z",
        //     ip: "200.25.56.71",
        //     lastUpdate: "0001-01-01T00:00:00.000Z",
        //     memberId: "b118d17a-b411-11eb-9450-47e1e1615544",
        //     pinId: "00000000-0000-0000-0000-000000000000",
        //     settledAt: "0001-01-01T00:00:00.000Z",
        //     sourceAccountId: "c3b0db20-b411-11eb-a8c0-d792be390a4b",
        //     sourceCurrency: {
        //       id: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //       isAvailable: true,
        //       marketPercent: 22.5,
        //       name: "Bitcoin",
        //       onlyAsset: false,
        //       precision: 8,
        //       symbol: "BTC",
        //       taxes: [
        //         {
        //           bonusRefer: 1,
        //           charityReferred: 3,
        //           charitySimple: 1,
        //           createdAt: "2021-02-01T00:00:00.000Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "e52fa818-6aff-11eb-b00d-8ff92bf3258e",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.25,
        //           rewardAmbassador: 2.75,
        //           rewardReferred: 2,
        //           startAt: "2021-02-01T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusRefer: 1,
        //           charityReferred: 3,
        //           charitySimple: 1,
        //           createdAt: "2020-07-14T00:00:00.000Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "b520ae4a-d065-11ea-b9f2-ab57e2ffff62",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 2.4,
        //           rewardReferred: 2,
        //           startAt: "2020-07-14T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusRefer: 1,
        //           bonusReferrer: 1,
        //           charityReferred: 1,
        //           charitySimple: 3,
        //           createdAt: "2019-03-31T18:17:57.882Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "4f8c3baa-53e1-11e9-a9df-b77dd05ebe45",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 3,
        //           rewardReferred: 2,
        //           startAt: "2019-04-11T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusReferrer: 1,
        //           charityReferred: 1,
        //           charitySimple: 3,
        //           createdAt: "2019-06-19T01:14:00.371Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 0.0010000000474974513,
        //           id: "84fbc814-922f-11e9-9877-1fee431c43ef",
        //           math: "absolut",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 3,
        //           startAt: "2018-11-01T00:00:00.000Z",
        //           type: "redeem",
        //         },
        //       ],
        //       tradeMinimal: 0.002,
        //       withdrawMinimal: 0.02,
        //     },
        //     status: "expired",
        //     step: 1,
        //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
        //     targetAddress: "1KVBKdMS17AbA7wFmkqsEnm7VGmHdQHkzw",
        //     targetCurrency: {
        //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
        //       isAvailable: true,
        //       name: "Stratumblue",
        //       onlyAsset: false,
        //       precision: 6,
        //       symbol: "BLU",
        //       taxes: null,
        //       tradeMinimal: 2,
        //       withdrawMinimal: 0.01,
        //     },
        //     targetPrice: 0.010945565125877747,
        //     type: "purchase",
        //     updatedAt: "2021-10-22T14:57:12.435Z",
        //   },
        //   {
        //     createdAt: "2021-12-23T19:39:28.687Z",
        //     expiresIn: 604800000,
        //     id: "30415f6e-6441-11ec-ae53-b72d5834fe4e",
        //     insertTime: "0001-01-01T00:00:00.000Z",
        //     ip: "187.49.237.178",
        //     lastUpdate: "0001-01-01T00:00:00.000Z",
        //     memberId: "b118d17a-b411-11eb-9450-47e1e1615544",
        //     pinId: "00000000-0000-0000-0000-000000000000",
        //     settled: true,
        //     settledAt: "2021-12-28T04:03:56.802Z",
        //     sourceAccountId: "a1add374-e32e-11eb-8160-d79ba51bf6fd",
        //     sourceAmount: 9.433962264150944,
        //     sourceCurrency: {
        //       id: "1820a89a-0745-11eb-9412-6ffc5759940f",
        //       isAvailable: true,
        //       name: "Tether",
        //       onlyAsset: false,
        //       precision: 8,
        //       symbol: "USDT",
        //       taxes: [
        //         {
        //           createdAt: "2022-02-01T12:12:40.394Z",
        //           currencyId: "1820a89a-0745-11eb-9412-6ffc5759940f",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 50,
        //           id: "407d59ce-8358-11ec-b72f-0b95b1c736fd",
        //           math: "absolut",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 3,
        //           startAt: "2022-01-30T00:00:00.000Z",
        //           type: "redeem",
        //         },
        //         {
        //           createdAt: "2022-02-01T12:12:40.394Z",
        //           currencyId: "1820a89a-0745-11eb-9412-6ffc5759940f",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 100,
        //           id: "407d530c-8358-11ec-b72e-775b917068b1",
        //           math: "rush",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 3,
        //           startAt: "2022-01-30T00:00:00.000Z",
        //           type: "redeem",
        //         },
        //         {
        //           createdAt: "2022-02-01T12:12:40.394Z",
        //           currencyId: "1820a89a-0745-11eb-9412-6ffc5759940f",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 1,
        //           id: "407d48b2-8358-11ec-b72d-5fb7bcf7f02a",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 3,
        //           startAt: "2022-01-30T00:00:00.000Z",
        //           type: "redeem",
        //         },
        //         {
        //           createdAt: "2022-01-28T11:26:32.367Z",
        //           currencyId: "1820a89a-0745-11eb-9412-6ffc5759940f",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 100,
        //           id: "a47cddb3-b47b-1139-9d8b-c79bcd37f815",
        //           math: "rush",
        //           startAt: "2022-01-20T00:00:00.000Z",
        //           type: "redeem",
        //         },
        //         {
        //           createdAt: "2022-01-28T11:26:27.948Z",
        //           currencyId: "1820a89a-0745-11eb-9412-6ffc5759940f",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 50,
        //           id: "a47cddbe-b47a-1139-9d8b-c79bcd37f815",
        //           math: "absolut",
        //           startAt: "2022-01-20T00:00:00.000Z",
        //           type: "redeem",
        //         },
        //         {
        //           createdAt: "2022-01-31T12:38:42.208Z",
        //           currencyId: "1820a89a-0745-11eb-9412-6ffc5759940f",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 1,
        //           id: "a47cddbe-b47a-11e9-9d9b-c79bcd37f815",
        //           math: "percent",
        //           startAt: "2022-01-20T00:00:00.000Z",
        //           type: "redeem",
        //         },
        //         {
        //           bonusReferrer: 1,
        //           charityReferred: 1,
        //           charitySimple: 3,
        //           createdAt: "2021-06-14T00:00:00.000Z",
        //           currencyId: "1820a89a-0745-11eb-9412-6ffc5759940f",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 0.001,
        //           id: "709de17e-cf7f-11eb-8b26-731f225dfe92",
        //           math: "absolut",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 3,
        //           startAt: "2021-06-14T00:00:00.000Z",
        //           type: "redeem",
        //         },
        //         {
        //           bonusRefer: 25,
        //           bonusReferrer: 50,
        //           charityReferred: 3,
        //           charitySimple: 50,
        //           createdAt: "2022-02-18T14:47:59.152Z",
        //           currencyId: "1820a89a-0745-11eb-9412-6ffc5759940f",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 2,
        //           id: "709d9746-cf7f-11eb-8b25-8f42d2b0e61d",
        //           math: "percent",
        //           revenue: 50,
        //           revenueAmbassador: 25,
        //           rewardAmbassador: 2.75,
        //           rewardReferred: 2,
        //           startAt: "2021-06-14T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //       ],
        //     },
        //     sourceFee: 0.5660377358,
        //     status: "done",
        //     step: 4,
        //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
        //     targetAddress: "TU2bnUaaPb3jZ4HYqHoQPMwqowxMPSpcF6",
        //     targetAmount: 0.014326310041645592,
        //     targetCurrency: {
        //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
        //       isAvailable: true,
        //       name: "Stratumblue",
        //       onlyAsset: false,
        //       precision: 6,
        //       symbol: "BLU",
        //       taxes: null,
        //       tradeMinimal: 2,
        //       withdrawMinimal: 0.01,
        //     },
        //     targetPrice: 658.5060798438027,
        //     tokenStatus: "processing",
        //     tokenStep: "waiting_publish",
        //     tokenTxid:
        //       "0x7b2c8d66cceb4bce67937bc0d3f5726d557b1f4d56b8753bb383936d5da05255",
        //     type: "purchase",
        //     updatedAt: "2022-01-25T16:17:42.724Z",
        //   },
        //   {
        //     createdAt: "2021-12-23T19:56:59.383Z",
        //     expiresIn: 604800000,
        //     id: "a284dc0c-6443-11ec-843f-075192fb3e54",
        //     insertTime: "0001-01-01T00:00:00.000Z",
        //     ip: "187.49.237.178",
        //     lastUpdate: "0001-01-01T00:00:00.000Z",
        //     memberId: "b118d17a-b411-11eb-9450-47e1e1615544",
        //     pinId: "00000000-0000-0000-0000-000000000000",
        //     settledAt: "0001-01-01T00:00:00.000Z",
        //     sourceAccountId: "c3b0db20-b411-11eb-a8c0-d792be390a4b",
        //     sourceCurrency: {
        //       id: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //       isAvailable: true,
        //       marketPercent: 22.5,
        //       name: "Bitcoin",
        //       onlyAsset: false,
        //       precision: 8,
        //       symbol: "BTC",
        //       taxes: [
        //         {
        //           bonusRefer: 1,
        //           charityReferred: 3,
        //           charitySimple: 1,
        //           createdAt: "2021-02-01T00:00:00.000Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "e52fa818-6aff-11eb-b00d-8ff92bf3258e",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.25,
        //           rewardAmbassador: 2.75,
        //           rewardReferred: 2,
        //           startAt: "2021-02-01T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusRefer: 1,
        //           charityReferred: 3,
        //           charitySimple: 1,
        //           createdAt: "2020-07-14T00:00:00.000Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "b520ae4a-d065-11ea-b9f2-ab57e2ffff62",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 2.4,
        //           rewardReferred: 2,
        //           startAt: "2020-07-14T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusRefer: 1,
        //           bonusReferrer: 1,
        //           charityReferred: 1,
        //           charitySimple: 3,
        //           createdAt: "2019-03-31T18:17:57.882Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "4f8c3baa-53e1-11e9-a9df-b77dd05ebe45",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 3,
        //           rewardReferred: 2,
        //           startAt: "2019-04-11T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusReferrer: 1,
        //           charityReferred: 1,
        //           charitySimple: 3,
        //           createdAt: "2019-06-19T01:14:00.371Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 0.0010000000474974513,
        //           id: "84fbc814-922f-11e9-9877-1fee431c43ef",
        //           math: "absolut",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 3,
        //           startAt: "2018-11-01T00:00:00.000Z",
        //           type: "redeem",
        //         },
        //       ],
        //       tradeMinimal: 0.002,
        //       withdrawMinimal: 0.02,
        //     },
        //     status: "expired",
        //     step: 1,
        //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
        //     targetAddress: "13aPWdJiZxRcbmFJZYcVcLzxvtE7uL1Eeh",
        //     targetCurrency: {
        //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
        //       isAvailable: true,
        //       name: "Stratumblue",
        //       onlyAsset: false,
        //       precision: 6,
        //       symbol: "BLU",
        //       taxes: null,
        //       tradeMinimal: 2,
        //       withdrawMinimal: 0.01,
        //     },
        //     targetPrice: 0.012966031147237446,
        //     type: "purchase",
        //     updatedAt: "2021-12-23T21:05:04.905Z",
        //   },
        //   {
        //     createdAt: "2021-12-23T19:48:46.024Z",
        //     expiresIn: 604800000,
        //     id: "7c744b84-6442-11ec-9b1a-9ba8c8f7cef0",
        //     insertTime: "0001-01-01T00:00:00.000Z",
        //     ip: "187.49.237.178",
        //     lastUpdate: "0001-01-01T00:00:00.000Z",
        //     memberId: "404f1146-a6c1-11eb-952b-67d61dfa915c",
        //     pinId: "00000000-0000-0000-0000-000000000000",
        //     sellerId: "b118d17a-b411-11eb-9450-47e1e1615544",
        //     settledAt: "0001-01-01T00:00:00.000Z",
        //     sourceAccountId: "48fa41bc-a6c1-11eb-b559-cb2fe2effb5e",
        //     sourceCurrency: {
        //       id: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //       isAvailable: true,
        //       marketPercent: 22.5,
        //       name: "Bitcoin",
        //       onlyAsset: false,
        //       precision: 8,
        //       symbol: "BTC",
        //       taxes: [
        //         {
        //           bonusRefer: 1,
        //           charityReferred: 3,
        //           charitySimple: 1,
        //           createdAt: "2021-02-01T00:00:00.000Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "e52fa818-6aff-11eb-b00d-8ff92bf3258e",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.25,
        //           rewardAmbassador: 2.75,
        //           rewardReferred: 2,
        //           startAt: "2021-02-01T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusRefer: 1,
        //           charityReferred: 3,
        //           charitySimple: 1,
        //           createdAt: "2020-07-14T00:00:00.000Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "b520ae4a-d065-11ea-b9f2-ab57e2ffff62",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 2.4,
        //           rewardReferred: 2,
        //           startAt: "2020-07-14T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusRefer: 1,
        //           bonusReferrer: 1,
        //           charityReferred: 1,
        //           charitySimple: 3,
        //           createdAt: "2019-03-31T18:17:57.882Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "4f8c3baa-53e1-11e9-a9df-b77dd05ebe45",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 3,
        //           rewardReferred: 2,
        //           startAt: "2019-04-11T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusReferrer: 1,
        //           charityReferred: 1,
        //           charitySimple: 3,
        //           createdAt: "2019-06-19T01:14:00.371Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 0.0010000000474974513,
        //           id: "84fbc814-922f-11e9-9877-1fee431c43ef",
        //           math: "absolut",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 3,
        //           startAt: "2018-11-01T00:00:00.000Z",
        //           type: "redeem",
        //         },
        //       ],
        //       tradeMinimal: 0.002,
        //       withdrawMinimal: 0.02,
        //     },
        //     status: "expired",
        //     step: 1,
        //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
        //     targetAddress: "12xWeoKuDkVN6aN96pDC7nycFSn6uuihip",
        //     targetCurrency: {
        //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
        //       isAvailable: true,
        //       name: "Stratumblue",
        //       onlyAsset: false,
        //       precision: 6,
        //       symbol: "BLU",
        //       taxes: null,
        //       tradeMinimal: 2,
        //       withdrawMinimal: 0.01,
        //     },
        //     targetPrice: 0.012933205956875624,
        //     type: "purchase",
        //     updatedAt: "2021-12-30T19:49:58.136Z",
        //   },
        //   {
        //     createdAt: "2021-12-23T19:43:59.153Z",
        //     expiresIn: 604800000,
        //     id: "d1774902-6441-11ec-a284-4f36eb3028e3",
        //     insertTime: "0001-01-01T00:00:00.000Z",
        //     ip: "187.49.237.178",
        //     lastUpdate: "0001-01-01T00:00:00.000Z",
        //     memberId: "b118d17a-b411-11eb-9450-47e1e1615544",
        //     pinId: "00000000-0000-0000-0000-000000000000",
        //     settled: true,
        //     settledAt: "2021-12-28T04:03:56.783Z",
        //     sourceAccountId: "c3d2a25a-b411-11eb-bbe9-17219b0ca111",
        //     sourceAmount: 0.00010566037735849057,
        //     sourceCurrency: {
        //       id: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
        //       isAvailable: true,
        //       marketPercent: 22.5,
        //       name: "Ethereum",
        //       onlyAsset: false,
        //       precision: 8,
        //       symbol: "ETH",
        //       taxes: [
        //         {
        //           bonusRefer: 1,
        //           charityReferred: 3,
        //           charitySimple: 1,
        //           createdAt: "2021-02-01T00:00:00.000Z",
        //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "e53001f0-6aff-11eb-b011-e7f585edc40d",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.25,
        //           rewardAmbassador: 2.75,
        //           rewardReferred: 2,
        //           startAt: "2021-02-01T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusRefer: 1,
        //           bonusReferrer: 1,
        //           charityReferred: 1,
        //           charitySimple: 3,
        //           createdAt: "2019-08-01T16:37:25.014Z",
        //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "a47cb226-b47a-11e9-9d96-73a1ce6e16f1",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 3,
        //           rewardReferred: 2,
        //           startAt: "2019-03-16T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusReferrer: 1,
        //           charityReferred: 1,
        //           charitySimple: 3,
        //           createdAt: "2021-02-09T15:27:01.495Z",
        //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 0.002,
        //           id: "a47cc2ac-b47a-11e9-9d97-cbb9a5578da5",
        //           math: "absolut",
        //           revenue: 2,
        //           rewardAmbassador: 3,
        //           startAt: "2018-11-01T00:00:00.000Z",
        //           type: "redeem",
        //         },
        //       ],
        //       tradeMinimal: 1e-7,
        //     },
        //     sourceFee: 0.0000063396,
        //     status: "done",
        //     step: 4,
        //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
        //     targetAddress: "0x0a65b2d82453da3001974b99d3fbde07e1753f9d",
        //     targetAmount: 0.0006597559177007448,
        //     targetCurrency: {
        //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
        //       isAvailable: true,
        //       name: "Stratumblue",
        //       onlyAsset: false,
        //       precision: 6,
        //       symbol: "BLU",
        //       taxes: null,
        //       tradeMinimal: 2,
        //       withdrawMinimal: 0.01,
        //     },
        //     targetPrice: 0.1601507080477852,
        //     tokenStatus: "processing",
        //     tokenStep: "waiting_publish",
        //     tokenTxid:
        //       "0x7907d423c960acf940d35aa41bd8adffb0ed0bfc11ccd8011b71b7808f217108",
        //     type: "purchase",
        //     updatedAt: "2022-01-25T16:17:43.795Z",
        //   },
        //   {
        //     createdAt: "2021-12-23T19:48:47.221Z",
        //     expiresIn: 604800000,
        //     id: "7d2ae3e4-6442-11ec-be88-03c585a6fee0",
        //     insertTime: "0001-01-01T00:00:00.000Z",
        //     ip: "187.49.237.178",
        //     lastUpdate: "0001-01-01T00:00:00.000Z",
        //     memberId: "404f1146-a6c1-11eb-952b-67d61dfa915c",
        //     pinId: "00000000-0000-0000-0000-000000000000",
        //     sellerId: "b118d17a-b411-11eb-9450-47e1e1615544",
        //     settledAt: "0001-01-01T00:00:00.000Z",
        //     sourceAccountId: "48fa41bc-a6c1-11eb-b559-cb2fe2effb5e",
        //     sourceCurrency: {
        //       id: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //       isAvailable: true,
        //       marketPercent: 22.5,
        //       name: "Bitcoin",
        //       onlyAsset: false,
        //       precision: 8,
        //       symbol: "BTC",
        //       taxes: [
        //         {
        //           bonusRefer: 1,
        //           charityReferred: 3,
        //           charitySimple: 1,
        //           createdAt: "2021-02-01T00:00:00.000Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "e52fa818-6aff-11eb-b00d-8ff92bf3258e",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.25,
        //           rewardAmbassador: 2.75,
        //           rewardReferred: 2,
        //           startAt: "2021-02-01T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusRefer: 1,
        //           charityReferred: 3,
        //           charitySimple: 1,
        //           createdAt: "2020-07-14T00:00:00.000Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "b520ae4a-d065-11ea-b9f2-ab57e2ffff62",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 2.4,
        //           rewardReferred: 2,
        //           startAt: "2020-07-14T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusRefer: 1,
        //           bonusReferrer: 1,
        //           charityReferred: 1,
        //           charitySimple: 3,
        //           createdAt: "2019-03-31T18:17:57.882Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "4f8c3baa-53e1-11e9-a9df-b77dd05ebe45",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 3,
        //           rewardReferred: 2,
        //           startAt: "2019-04-11T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusReferrer: 1,
        //           charityReferred: 1,
        //           charitySimple: 3,
        //           createdAt: "2019-06-19T01:14:00.371Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 0.0010000000474974513,
        //           id: "84fbc814-922f-11e9-9877-1fee431c43ef",
        //           math: "absolut",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 3,
        //           startAt: "2018-11-01T00:00:00.000Z",
        //           type: "redeem",
        //         },
        //       ],
        //       tradeMinimal: 0.002,
        //       withdrawMinimal: 0.02,
        //     },
        //     status: "expired",
        //     step: 1,
        //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
        //     targetAddress: "12yJCGdDtHD7GadR9fxk1TuazuBt2EiNEb",
        //     targetCurrency: {
        //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
        //       isAvailable: true,
        //       name: "Stratumblue",
        //       onlyAsset: false,
        //       precision: 6,
        //       symbol: "BLU",
        //       taxes: null,
        //       tradeMinimal: 2,
        //       withdrawMinimal: 0.01,
        //     },
        //     targetPrice: 0.012933205956875624,
        //     type: "purchase",
        //     updatedAt: "2021-12-23T19:48:58.561Z",
        //   },
        //   {
        //     createdAt: "2021-12-23T19:49:21.140Z",
        //     expiresIn: 604800000,
        //     id: "916271ba-6442-11ec-bdee-fb7e3de44752",
        //     insertTime: "0001-01-01T00:00:00.000Z",
        //     ip: "187.49.237.178",
        //     lastUpdate: "0001-01-01T00:00:00.000Z",
        //     memberId: "404f1146-a6c1-11eb-952b-67d61dfa915c",
        //     pinId: "00000000-0000-0000-0000-000000000000",
        //     sellerId: "b118d17a-b411-11eb-9450-47e1e1615544",
        //     settledAt: "0001-01-01T00:00:00.000Z",
        //     sourceAccountId: "48fa41bc-a6c1-11eb-b559-cb2fe2effb5e",
        //     sourceCurrency: {
        //       id: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //       isAvailable: true,
        //       marketPercent: 22.5,
        //       name: "Bitcoin",
        //       onlyAsset: false,
        //       precision: 8,
        //       symbol: "BTC",
        //       taxes: [
        //         {
        //           bonusRefer: 1,
        //           charityReferred: 3,
        //           charitySimple: 1,
        //           createdAt: "2021-02-01T00:00:00.000Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "e52fa818-6aff-11eb-b00d-8ff92bf3258e",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.25,
        //           rewardAmbassador: 2.75,
        //           rewardReferred: 2,
        //           startAt: "2021-02-01T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusRefer: 1,
        //           charityReferred: 3,
        //           charitySimple: 1,
        //           createdAt: "2020-07-14T00:00:00.000Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "b520ae4a-d065-11ea-b9f2-ab57e2ffff62",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 2.4,
        //           rewardReferred: 2,
        //           startAt: "2020-07-14T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusRefer: 1,
        //           bonusReferrer: 1,
        //           charityReferred: 1,
        //           charitySimple: 3,
        //           createdAt: "2019-03-31T18:17:57.882Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "4f8c3baa-53e1-11e9-a9df-b77dd05ebe45",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 3,
        //           rewardReferred: 2,
        //           startAt: "2019-04-11T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusReferrer: 1,
        //           charityReferred: 1,
        //           charitySimple: 3,
        //           createdAt: "2019-06-19T01:14:00.371Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 0.0010000000474974513,
        //           id: "84fbc814-922f-11e9-9877-1fee431c43ef",
        //           math: "absolut",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 3,
        //           startAt: "2018-11-01T00:00:00.000Z",
        //           type: "redeem",
        //         },
        //       ],
        //       tradeMinimal: 0.002,
        //       withdrawMinimal: 0.02,
        //     },
        //     status: "expired",
        //     step: 1,
        //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
        //     targetAddress: "12yngmW2SRKbk2t7SvtsaYSY7yE7hkPVvB",
        //     targetCurrency: {
        //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
        //       isAvailable: true,
        //       name: "Stratumblue",
        //       onlyAsset: false,
        //       precision: 6,
        //       symbol: "BLU",
        //       taxes: null,
        //       tradeMinimal: 2,
        //       withdrawMinimal: 0.01,
        //     },
        //     targetPrice: 0.012933205956875624,
        //     type: "purchase",
        //     updatedAt: "2021-12-23T19:55:11.232Z",
        //   },
        //   {
        //     createdAt: "2021-12-23T21:04:02.924Z",
        //     expiresIn: 604800000,
        //     id: "00bcdc76-644d-11ec-a060-af1189fc5638",
        //     insertTime: "0001-01-01T00:00:00.000Z",
        //     ip: "187.49.237.178",
        //     lastUpdate: "0001-01-01T00:00:00.000Z",
        //     memberId: "b118d17a-b411-11eb-9450-47e1e1615544",
        //     pinId: "00000000-0000-0000-0000-000000000000",
        //     settled: true,
        //     settledAt: "2021-12-28T04:03:09.917Z",
        //     sourceAccountId: "a1add374-e32e-11eb-8160-d79ba51bf6fd",
        //     sourceAmount: 11.320754726415096,
        //     sourceCurrency: {
        //       id: "1820a89a-0745-11eb-9412-6ffc5759940f",
        //       isAvailable: true,
        //       name: "Tether",
        //       onlyAsset: false,
        //       precision: 8,
        //       symbol: "USDT",
        //       taxes: [
        //         {
        //           createdAt: "2022-02-01T12:12:40.394Z",
        //           currencyId: "1820a89a-0745-11eb-9412-6ffc5759940f",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 50,
        //           id: "407d59ce-8358-11ec-b72f-0b95b1c736fd",
        //           math: "absolut",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 3,
        //           startAt: "2022-01-30T00:00:00.000Z",
        //           type: "redeem",
        //         },
        //         {
        //           createdAt: "2022-02-01T12:12:40.394Z",
        //           currencyId: "1820a89a-0745-11eb-9412-6ffc5759940f",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 100,
        //           id: "407d530c-8358-11ec-b72e-775b917068b1",
        //           math: "rush",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 3,
        //           startAt: "2022-01-30T00:00:00.000Z",
        //           type: "redeem",
        //         },
        //         {
        //           createdAt: "2022-02-01T12:12:40.394Z",
        //           currencyId: "1820a89a-0745-11eb-9412-6ffc5759940f",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 1,
        //           id: "407d48b2-8358-11ec-b72d-5fb7bcf7f02a",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 3,
        //           startAt: "2022-01-30T00:00:00.000Z",
        //           type: "redeem",
        //         },
        //         {
        //           createdAt: "2022-01-28T11:26:32.367Z",
        //           currencyId: "1820a89a-0745-11eb-9412-6ffc5759940f",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 100,
        //           id: "a47cddb3-b47b-1139-9d8b-c79bcd37f815",
        //           math: "rush",
        //           startAt: "2022-01-20T00:00:00.000Z",
        //           type: "redeem",
        //         },
        //         {
        //           createdAt: "2022-01-28T11:26:27.948Z",
        //           currencyId: "1820a89a-0745-11eb-9412-6ffc5759940f",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 50,
        //           id: "a47cddbe-b47a-1139-9d8b-c79bcd37f815",
        //           math: "absolut",
        //           startAt: "2022-01-20T00:00:00.000Z",
        //           type: "redeem",
        //         },
        //         {
        //           createdAt: "2022-01-31T12:38:42.208Z",
        //           currencyId: "1820a89a-0745-11eb-9412-6ffc5759940f",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 1,
        //           id: "a47cddbe-b47a-11e9-9d9b-c79bcd37f815",
        //           math: "percent",
        //           startAt: "2022-01-20T00:00:00.000Z",
        //           type: "redeem",
        //         },
        //         {
        //           bonusReferrer: 1,
        //           charityReferred: 1,
        //           charitySimple: 3,
        //           createdAt: "2021-06-14T00:00:00.000Z",
        //           currencyId: "1820a89a-0745-11eb-9412-6ffc5759940f",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 0.001,
        //           id: "709de17e-cf7f-11eb-8b26-731f225dfe92",
        //           math: "absolut",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 3,
        //           startAt: "2021-06-14T00:00:00.000Z",
        //           type: "redeem",
        //         },
        //         {
        //           bonusRefer: 25,
        //           bonusReferrer: 50,
        //           charityReferred: 3,
        //           charitySimple: 50,
        //           createdAt: "2022-02-18T14:47:59.152Z",
        //           currencyId: "1820a89a-0745-11eb-9412-6ffc5759940f",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 2,
        //           id: "709d9746-cf7f-11eb-8b25-8f42d2b0e61d",
        //           math: "percent",
        //           revenue: 50,
        //           revenueAmbassador: 25,
        //           rewardAmbassador: 2.75,
        //           rewardReferred: 2,
        //           startAt: "2021-06-14T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //       ],
        //     },
        //     sourceFee: 0.6792452836,
        //     status: "done",
        //     step: 4,
        //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
        //     targetAddress: "TMS9dw1wavkEpFNp9nej6qEyw39oEWCrYq",
        //     targetAmount: 0.017183835346580786,
        //     targetCurrency: {
        //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
        //       isAvailable: true,
        //       name: "Stratumblue",
        //       onlyAsset: false,
        //       precision: 6,
        //       symbol: "BLU",
        //       taxes: null,
        //       tradeMinimal: 2,
        //       withdrawMinimal: 0.01,
        //     },
        //     targetPrice: 658.802560551052,
        //     tokenStatus: "done",
        //     tokenStep: "steps_done",
        //     tokenTxid:
        //       "0x65e312b44dc774fac4acbb80a6b55e6ec6f83a60ac034c62372aa4163b56943b",
        //     type: "purchase",
        //     updatedAt: "2021-12-23T21:18:05.792Z",
        //   },
        //   {
        //     createdAt: "2022-01-25T16:07:34.506Z",
        //     id: "0da25d24-7e12-11ec-9cac-8359caea2aec",
        //     insertTime: "0001-01-01T00:00:00.000Z",
        //     ip: "187.49.237.178",
        //     lastUpdate: "0001-01-01T00:00:00.000Z",
        //     memberId: "b118d17a-b411-11eb-9450-47e1e1615544",
        //     pinId: "00000000-0000-0000-0000-000000000000",
        //     settledAt: "0001-01-01T00:00:00.000Z",
        //     sourceAccountId: "c3b0db20-b411-11eb-a8c0-d792be390a4b",
        //     sourceCurrency: {
        //       id: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //       isAvailable: true,
        //       marketPercent: 22.5,
        //       name: "Bitcoin",
        //       onlyAsset: false,
        //       precision: 8,
        //       symbol: "BTC",
        //       taxes: [
        //         {
        //           bonusRefer: 1,
        //           charityReferred: 3,
        //           charitySimple: 1,
        //           createdAt: "2021-02-01T00:00:00.000Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "e52fa818-6aff-11eb-b00d-8ff92bf3258e",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.25,
        //           rewardAmbassador: 2.75,
        //           rewardReferred: 2,
        //           startAt: "2021-02-01T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusRefer: 1,
        //           charityReferred: 3,
        //           charitySimple: 1,
        //           createdAt: "2020-07-14T00:00:00.000Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "b520ae4a-d065-11ea-b9f2-ab57e2ffff62",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 2.4,
        //           rewardReferred: 2,
        //           startAt: "2020-07-14T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusRefer: 1,
        //           bonusReferrer: 1,
        //           charityReferred: 1,
        //           charitySimple: 3,
        //           createdAt: "2019-03-31T18:17:57.882Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "4f8c3baa-53e1-11e9-a9df-b77dd05ebe45",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 3,
        //           rewardReferred: 2,
        //           startAt: "2019-04-11T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusReferrer: 1,
        //           charityReferred: 1,
        //           charitySimple: 3,
        //           createdAt: "2019-06-19T01:14:00.371Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 0.0010000000474974513,
        //           id: "84fbc814-922f-11e9-9877-1fee431c43ef",
        //           math: "absolut",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 3,
        //           startAt: "2018-11-01T00:00:00.000Z",
        //           type: "redeem",
        //         },
        //       ],
        //       tradeMinimal: 0.002,
        //       withdrawMinimal: 0.02,
        //     },
        //     status: "failed",
        //     step: 1,
        //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
        //     targetCurrency: {
        //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
        //       isAvailable: true,
        //       name: "Stratumblue",
        //       onlyAsset: false,
        //       precision: 6,
        //       symbol: "BLU",
        //       taxes: null,
        //       tradeMinimal: 2,
        //       withdrawMinimal: 0.01,
        //     },
        //     targetPrice: 0.011579060224284751,
        //     type: "purchase",
        //     updatedAt: "2022-01-25T16:07:37.880Z",
        //   },
        //   {
        //     createdAt: "2022-01-25T16:08:23.167Z",
        //     id: "2aa3b0bc-7e12-11ec-b166-077c5abe9a16",
        //     insertTime: "0001-01-01T00:00:00.000Z",
        //     ip: "187.49.237.178",
        //     lastUpdate: "0001-01-01T00:00:00.000Z",
        //     memberId: "b118d17a-b411-11eb-9450-47e1e1615544",
        //     pinId: "00000000-0000-0000-0000-000000000000",
        //     settledAt: "0001-01-01T00:00:00.000Z",
        //     sourceAccountId: "c3b0db20-b411-11eb-a8c0-d792be390a4b",
        //     sourceCurrency: {
        //       id: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //       isAvailable: true,
        //       marketPercent: 22.5,
        //       name: "Bitcoin",
        //       onlyAsset: false,
        //       precision: 8,
        //       symbol: "BTC",
        //       taxes: [
        //         {
        //           bonusRefer: 1,
        //           charityReferred: 3,
        //           charitySimple: 1,
        //           createdAt: "2021-02-01T00:00:00.000Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "e52fa818-6aff-11eb-b00d-8ff92bf3258e",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.25,
        //           rewardAmbassador: 2.75,
        //           rewardReferred: 2,
        //           startAt: "2021-02-01T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusRefer: 1,
        //           charityReferred: 3,
        //           charitySimple: 1,
        //           createdAt: "2020-07-14T00:00:00.000Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "b520ae4a-d065-11ea-b9f2-ab57e2ffff62",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 2.4,
        //           rewardReferred: 2,
        //           startAt: "2020-07-14T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusRefer: 1,
        //           bonusReferrer: 1,
        //           charityReferred: 1,
        //           charitySimple: 3,
        //           createdAt: "2019-03-31T18:17:57.882Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "4f8c3baa-53e1-11e9-a9df-b77dd05ebe45",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 3,
        //           rewardReferred: 2,
        //           startAt: "2019-04-11T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusReferrer: 1,
        //           charityReferred: 1,
        //           charitySimple: 3,
        //           createdAt: "2019-06-19T01:14:00.371Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 0.0010000000474974513,
        //           id: "84fbc814-922f-11e9-9877-1fee431c43ef",
        //           math: "absolut",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 3,
        //           startAt: "2018-11-01T00:00:00.000Z",
        //           type: "redeem",
        //         },
        //       ],
        //       tradeMinimal: 0.002,
        //       withdrawMinimal: 0.02,
        //     },
        //     status: "failed",
        //     step: 1,
        //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
        //     targetCurrency: {
        //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
        //       isAvailable: true,
        //       name: "Stratumblue",
        //       onlyAsset: false,
        //       precision: 6,
        //       symbol: "BLU",
        //       taxes: null,
        //       tradeMinimal: 2,
        //       withdrawMinimal: 0.01,
        //     },
        //     targetPrice: 0.011579060224284751,
        //     type: "purchase",
        //     updatedAt: "2022-01-25T16:08:25.792Z",
        //   },
        //   {
        //     createdAt: "2022-01-25T16:11:25.741Z",
        //     id: "9775fa2e-7e12-11ec-9130-638eaf871e39",
        //     insertTime: "0001-01-01T00:00:00.000Z",
        //     ip: "187.49.237.178",
        //     lastUpdate: "0001-01-01T00:00:00.000Z",
        //     memberId: "b118d17a-b411-11eb-9450-47e1e1615544",
        //     pinId: "00000000-0000-0000-0000-000000000000",
        //     settledAt: "0001-01-01T00:00:00.000Z",
        //     sourceAccountId: "c3b0db20-b411-11eb-a8c0-d792be390a4b",
        //     sourceCurrency: {
        //       id: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //       isAvailable: true,
        //       marketPercent: 22.5,
        //       name: "Bitcoin",
        //       onlyAsset: false,
        //       precision: 8,
        //       symbol: "BTC",
        //       taxes: [
        //         {
        //           bonusRefer: 1,
        //           charityReferred: 3,
        //           charitySimple: 1,
        //           createdAt: "2021-02-01T00:00:00.000Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "e52fa818-6aff-11eb-b00d-8ff92bf3258e",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.25,
        //           rewardAmbassador: 2.75,
        //           rewardReferred: 2,
        //           startAt: "2021-02-01T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusRefer: 1,
        //           charityReferred: 3,
        //           charitySimple: 1,
        //           createdAt: "2020-07-14T00:00:00.000Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "b520ae4a-d065-11ea-b9f2-ab57e2ffff62",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 2.4,
        //           rewardReferred: 2,
        //           startAt: "2020-07-14T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusRefer: 1,
        //           bonusReferrer: 1,
        //           charityReferred: 1,
        //           charitySimple: 3,
        //           createdAt: "2019-03-31T18:17:57.882Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "4f8c3baa-53e1-11e9-a9df-b77dd05ebe45",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 3,
        //           rewardReferred: 2,
        //           startAt: "2019-04-11T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusReferrer: 1,
        //           charityReferred: 1,
        //           charitySimple: 3,
        //           createdAt: "2019-06-19T01:14:00.371Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 0.0010000000474974513,
        //           id: "84fbc814-922f-11e9-9877-1fee431c43ef",
        //           math: "absolut",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 3,
        //           startAt: "2018-11-01T00:00:00.000Z",
        //           type: "redeem",
        //         },
        //       ],
        //       tradeMinimal: 0.002,
        //       withdrawMinimal: 0.02,
        //     },
        //     status: "failed",
        //     step: 1,
        //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
        //     targetCurrency: {
        //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
        //       isAvailable: true,
        //       name: "Stratumblue",
        //       onlyAsset: false,
        //       precision: 6,
        //       symbol: "BLU",
        //       taxes: null,
        //       tradeMinimal: 2,
        //       withdrawMinimal: 0.01,
        //     },
        //     targetPrice: 0.011552460913745542,
        //     type: "purchase",
        //     updatedAt: "2022-01-25T16:11:29.302Z",
        //   },
        //   {
        //     createdAt: "2022-01-25T16:15:59.631Z",
        //     id: "3ab65a58-7e13-11ec-8ee6-7733ae2039c7",
        //     insertTime: "0001-01-01T00:00:00.000Z",
        //     ip: "187.49.237.178",
        //     lastUpdate: "0001-01-01T00:00:00.000Z",
        //     memberId: "b118d17a-b411-11eb-9450-47e1e1615544",
        //     pinId: "00000000-0000-0000-0000-000000000000",
        //     settledAt: "0001-01-01T00:00:00.000Z",
        //     sourceAccountId: "c3b0db20-b411-11eb-a8c0-d792be390a4b",
        //     sourceCurrency: {
        //       id: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //       isAvailable: true,
        //       marketPercent: 22.5,
        //       name: "Bitcoin",
        //       onlyAsset: false,
        //       precision: 8,
        //       symbol: "BTC",
        //       taxes: [
        //         {
        //           bonusRefer: 1,
        //           charityReferred: 3,
        //           charitySimple: 1,
        //           createdAt: "2021-02-01T00:00:00.000Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "e52fa818-6aff-11eb-b00d-8ff92bf3258e",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.25,
        //           rewardAmbassador: 2.75,
        //           rewardReferred: 2,
        //           startAt: "2021-02-01T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusRefer: 1,
        //           charityReferred: 3,
        //           charitySimple: 1,
        //           createdAt: "2020-07-14T00:00:00.000Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "b520ae4a-d065-11ea-b9f2-ab57e2ffff62",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 2.4,
        //           rewardReferred: 2,
        //           startAt: "2020-07-14T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusRefer: 1,
        //           bonusReferrer: 1,
        //           charityReferred: 1,
        //           charitySimple: 3,
        //           createdAt: "2019-03-31T18:17:57.882Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "4f8c3baa-53e1-11e9-a9df-b77dd05ebe45",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 3,
        //           rewardReferred: 2,
        //           startAt: "2019-04-11T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusReferrer: 1,
        //           charityReferred: 1,
        //           charitySimple: 3,
        //           createdAt: "2019-06-19T01:14:00.371Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 0.0010000000474974513,
        //           id: "84fbc814-922f-11e9-9877-1fee431c43ef",
        //           math: "absolut",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 3,
        //           startAt: "2018-11-01T00:00:00.000Z",
        //           type: "redeem",
        //         },
        //       ],
        //       tradeMinimal: 0.002,
        //       withdrawMinimal: 0.02,
        //     },
        //     status: "failed",
        //     step: 1,
        //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
        //     targetCurrency: {
        //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
        //       isAvailable: true,
        //       name: "Stratumblue",
        //       onlyAsset: false,
        //       precision: 6,
        //       symbol: "BLU",
        //       taxes: null,
        //       tradeMinimal: 2,
        //       withdrawMinimal: 0.01,
        //     },
        //     targetPrice: 0.011529030746038869,
        //     type: "purchase",
        //     updatedAt: "2022-01-25T16:16:03.479Z",
        //   },
        //   {
        //     createdAt: "2022-01-25T16:18:36.974Z",
        //     id: "987ee90c-7e13-11ec-8fa6-2752dd816a6c",
        //     insertTime: "0001-01-01T00:00:00.000Z",
        //     ip: "187.49.237.178",
        //     lastUpdate: "0001-01-01T00:00:00.000Z",
        //     memberId: "b118d17a-b411-11eb-9450-47e1e1615544",
        //     pinId: "00000000-0000-0000-0000-000000000000",
        //     settledAt: "0001-01-01T00:00:00.000Z",
        //     sourceAccountId: "c3b0db20-b411-11eb-a8c0-d792be390a4b",
        //     sourceCurrency: {
        //       id: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //       isAvailable: true,
        //       marketPercent: 22.5,
        //       name: "Bitcoin",
        //       onlyAsset: false,
        //       precision: 8,
        //       symbol: "BTC",
        //       taxes: [
        //         {
        //           bonusRefer: 1,
        //           charityReferred: 3,
        //           charitySimple: 1,
        //           createdAt: "2021-02-01T00:00:00.000Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "e52fa818-6aff-11eb-b00d-8ff92bf3258e",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.25,
        //           rewardAmbassador: 2.75,
        //           rewardReferred: 2,
        //           startAt: "2021-02-01T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusRefer: 1,
        //           charityReferred: 3,
        //           charitySimple: 1,
        //           createdAt: "2020-07-14T00:00:00.000Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "b520ae4a-d065-11ea-b9f2-ab57e2ffff62",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 2.4,
        //           rewardReferred: 2,
        //           startAt: "2020-07-14T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusRefer: 1,
        //           bonusReferrer: 1,
        //           charityReferred: 1,
        //           charitySimple: 3,
        //           createdAt: "2019-03-31T18:17:57.882Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "4f8c3baa-53e1-11e9-a9df-b77dd05ebe45",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 3,
        //           rewardReferred: 2,
        //           startAt: "2019-04-11T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusReferrer: 1,
        //           charityReferred: 1,
        //           charitySimple: 3,
        //           createdAt: "2019-06-19T01:14:00.371Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 0.0010000000474974513,
        //           id: "84fbc814-922f-11e9-9877-1fee431c43ef",
        //           math: "absolut",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 3,
        //           startAt: "2018-11-01T00:00:00.000Z",
        //           type: "redeem",
        //         },
        //       ],
        //       tradeMinimal: 0.002,
        //       withdrawMinimal: 0.02,
        //     },
        //     status: "failed",
        //     step: 1,
        //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
        //     targetCurrency: {
        //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
        //       isAvailable: true,
        //       name: "Stratumblue",
        //       onlyAsset: false,
        //       precision: 6,
        //       symbol: "BLU",
        //       taxes: null,
        //       tradeMinimal: 2,
        //       withdrawMinimal: 0.01,
        //     },
        //     targetPrice: 0.011528734557363432,
        //     type: "purchase",
        //     updatedAt: "2022-01-25T16:18:40.008Z",
        //   },
        //   {
        //     createdAt: "2022-01-25T16:18:56.322Z",
        //     id: "a4073c66-7e13-11ec-88a2-079879b4ed5d",
        //     insertTime: "0001-01-01T00:00:00.000Z",
        //     ip: "187.49.237.178",
        //     lastUpdate: "0001-01-01T00:00:00.000Z",
        //     memberId: "b118d17a-b411-11eb-9450-47e1e1615544",
        //     pinId: "00000000-0000-0000-0000-000000000000",
        //     settledAt: "0001-01-01T00:00:00.000Z",
        //     sourceAccountId: "c3b0db20-b411-11eb-a8c0-d792be390a4b",
        //     sourceCurrency: {
        //       id: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //       isAvailable: true,
        //       marketPercent: 22.5,
        //       name: "Bitcoin",
        //       onlyAsset: false,
        //       precision: 8,
        //       symbol: "BTC",
        //       taxes: [
        //         {
        //           bonusRefer: 1,
        //           charityReferred: 3,
        //           charitySimple: 1,
        //           createdAt: "2021-02-01T00:00:00.000Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "e52fa818-6aff-11eb-b00d-8ff92bf3258e",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.25,
        //           rewardAmbassador: 2.75,
        //           rewardReferred: 2,
        //           startAt: "2021-02-01T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusRefer: 1,
        //           charityReferred: 3,
        //           charitySimple: 1,
        //           createdAt: "2020-07-14T00:00:00.000Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "b520ae4a-d065-11ea-b9f2-ab57e2ffff62",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 2.4,
        //           rewardReferred: 2,
        //           startAt: "2020-07-14T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusRefer: 1,
        //           bonusReferrer: 1,
        //           charityReferred: 1,
        //           charitySimple: 3,
        //           createdAt: "2019-03-31T18:17:57.882Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "4f8c3baa-53e1-11e9-a9df-b77dd05ebe45",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 3,
        //           rewardReferred: 2,
        //           startAt: "2019-04-11T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusReferrer: 1,
        //           charityReferred: 1,
        //           charitySimple: 3,
        //           createdAt: "2019-06-19T01:14:00.371Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 0.0010000000474974513,
        //           id: "84fbc814-922f-11e9-9877-1fee431c43ef",
        //           math: "absolut",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 3,
        //           startAt: "2018-11-01T00:00:00.000Z",
        //           type: "redeem",
        //         },
        //       ],
        //       tradeMinimal: 0.002,
        //       withdrawMinimal: 0.02,
        //     },
        //     status: "failed",
        //     step: 1,
        //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
        //     targetCurrency: {
        //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
        //       isAvailable: true,
        //       name: "Stratumblue",
        //       onlyAsset: false,
        //       precision: 6,
        //       symbol: "BLU",
        //       taxes: null,
        //       tradeMinimal: 2,
        //       withdrawMinimal: 0.01,
        //     },
        //     targetPrice: 0.011528734557363432,
        //     type: "purchase",
        //     updatedAt: "2022-01-25T16:18:58.861Z",
        //   },
        //   {
        //     createdAt: "2022-01-26T16:25:25.332Z",
        //     id: "b650252a-7edd-11ec-ab83-8ff8cd1af139",
        //     insertTime: "0001-01-01T00:00:00.000Z",
        //     ip: "187.49.237.178",
        //     lastUpdate: "0001-01-01T00:00:00.000Z",
        //     memberId: "b118d17a-b411-11eb-9450-47e1e1615544",
        //     pinId: "00000000-0000-0000-0000-000000000000",
        //     settledAt: "0001-01-01T00:00:00.000Z",
        //     sourceAccountId: "c3b0db20-b411-11eb-a8c0-d792be390a4b",
        //     sourceCurrency: {
        //       id: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //       isAvailable: true,
        //       marketPercent: 22.5,
        //       name: "Bitcoin",
        //       onlyAsset: false,
        //       precision: 8,
        //       symbol: "BTC",
        //       taxes: [
        //         {
        //           bonusRefer: 1,
        //           charityReferred: 3,
        //           charitySimple: 1,
        //           createdAt: "2021-02-01T00:00:00.000Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "e52fa818-6aff-11eb-b00d-8ff92bf3258e",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.25,
        //           rewardAmbassador: 2.75,
        //           rewardReferred: 2,
        //           startAt: "2021-02-01T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusRefer: 1,
        //           charityReferred: 3,
        //           charitySimple: 1,
        //           createdAt: "2020-07-14T00:00:00.000Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "b520ae4a-d065-11ea-b9f2-ab57e2ffff62",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 2.4,
        //           rewardReferred: 2,
        //           startAt: "2020-07-14T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusRefer: 1,
        //           bonusReferrer: 1,
        //           charityReferred: 1,
        //           charitySimple: 3,
        //           createdAt: "2019-03-31T18:17:57.882Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "4f8c3baa-53e1-11e9-a9df-b77dd05ebe45",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 3,
        //           rewardReferred: 2,
        //           startAt: "2019-04-11T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusReferrer: 1,
        //           charityReferred: 1,
        //           charitySimple: 3,
        //           createdAt: "2019-06-19T01:14:00.371Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 0.0010000000474974513,
        //           id: "84fbc814-922f-11e9-9877-1fee431c43ef",
        //           math: "absolut",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 3,
        //           startAt: "2018-11-01T00:00:00.000Z",
        //           type: "redeem",
        //         },
        //       ],
        //       tradeMinimal: 0.002,
        //       withdrawMinimal: 0.02,
        //     },
        //     status: "failed",
        //     step: 1,
        //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
        //     targetCurrency: {
        //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
        //       isAvailable: true,
        //       name: "Stratumblue",
        //       onlyAsset: false,
        //       precision: 6,
        //       symbol: "BLU",
        //       taxes: null,
        //       tradeMinimal: 2,
        //       withdrawMinimal: 0.01,
        //     },
        //     targetPrice: 0.011544857616739606,
        //     type: "purchase",
        //     updatedAt: "2022-01-26T16:25:29.099Z",
        //   },
        //   {
        //     createdAt: "2022-01-26T16:26:20.780Z",
        //     id: "d75cea1e-7edd-11ec-b9ab-1b1bf5577935",
        //     insertTime: "0001-01-01T00:00:00.000Z",
        //     ip: "187.49.237.178",
        //     lastUpdate: "0001-01-01T00:00:00.000Z",
        //     memberId: "b118d17a-b411-11eb-9450-47e1e1615544",
        //     pinId: "00000000-0000-0000-0000-000000000000",
        //     settledAt: "0001-01-01T00:00:00.000Z",
        //     sourceAccountId: "c3b0db20-b411-11eb-a8c0-d792be390a4b",
        //     sourceCurrency: {
        //       id: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //       isAvailable: true,
        //       marketPercent: 22.5,
        //       name: "Bitcoin",
        //       onlyAsset: false,
        //       precision: 8,
        //       symbol: "BTC",
        //       taxes: [
        //         {
        //           bonusRefer: 1,
        //           charityReferred: 3,
        //           charitySimple: 1,
        //           createdAt: "2021-02-01T00:00:00.000Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "e52fa818-6aff-11eb-b00d-8ff92bf3258e",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.25,
        //           rewardAmbassador: 2.75,
        //           rewardReferred: 2,
        //           startAt: "2021-02-01T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusRefer: 1,
        //           charityReferred: 3,
        //           charitySimple: 1,
        //           createdAt: "2020-07-14T00:00:00.000Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "b520ae4a-d065-11ea-b9f2-ab57e2ffff62",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 2.4,
        //           rewardReferred: 2,
        //           startAt: "2020-07-14T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusRefer: 1,
        //           bonusReferrer: 1,
        //           charityReferred: 1,
        //           charitySimple: 3,
        //           createdAt: "2019-03-31T18:17:57.882Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "4f8c3baa-53e1-11e9-a9df-b77dd05ebe45",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 3,
        //           rewardReferred: 2,
        //           startAt: "2019-04-11T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusReferrer: 1,
        //           charityReferred: 1,
        //           charitySimple: 3,
        //           createdAt: "2019-06-19T01:14:00.371Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 0.0010000000474974513,
        //           id: "84fbc814-922f-11e9-9877-1fee431c43ef",
        //           math: "absolut",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 3,
        //           startAt: "2018-11-01T00:00:00.000Z",
        //           type: "redeem",
        //         },
        //       ],
        //       tradeMinimal: 0.002,
        //       withdrawMinimal: 0.02,
        //     },
        //     status: "failed",
        //     step: 1,
        //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
        //     targetCurrency: {
        //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
        //       isAvailable: true,
        //       name: "Stratumblue",
        //       onlyAsset: false,
        //       precision: 6,
        //       symbol: "BLU",
        //       taxes: null,
        //       tradeMinimal: 2,
        //       withdrawMinimal: 0.01,
        //     },
        //     targetPrice: 0.01152178147967622,
        //     type: "purchase",
        //     updatedAt: "2022-01-26T16:26:23.360Z",
        //   },
        //   {
        //     createdAt: "2022-01-26T16:27:02.828Z",
        //     id: "f06d809a-7edd-11ec-a8e8-63db4f5bb9f0",
        //     insertTime: "0001-01-01T00:00:00.000Z",
        //     ip: "187.49.237.178",
        //     lastUpdate: "0001-01-01T00:00:00.000Z",
        //     memberId: "b118d17a-b411-11eb-9450-47e1e1615544",
        //     pinId: "00000000-0000-0000-0000-000000000000",
        //     settledAt: "0001-01-01T00:00:00.000Z",
        //     sourceAccountId: "c3b0db20-b411-11eb-a8c0-d792be390a4b",
        //     sourceCurrency: {
        //       id: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //       isAvailable: true,
        //       marketPercent: 22.5,
        //       name: "Bitcoin",
        //       onlyAsset: false,
        //       precision: 8,
        //       symbol: "BTC",
        //       taxes: [
        //         {
        //           bonusRefer: 1,
        //           charityReferred: 3,
        //           charitySimple: 1,
        //           createdAt: "2021-02-01T00:00:00.000Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "e52fa818-6aff-11eb-b00d-8ff92bf3258e",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.25,
        //           rewardAmbassador: 2.75,
        //           rewardReferred: 2,
        //           startAt: "2021-02-01T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusRefer: 1,
        //           charityReferred: 3,
        //           charitySimple: 1,
        //           createdAt: "2020-07-14T00:00:00.000Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "b520ae4a-d065-11ea-b9f2-ab57e2ffff62",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 2.4,
        //           rewardReferred: 2,
        //           startAt: "2020-07-14T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusRefer: 1,
        //           bonusReferrer: 1,
        //           charityReferred: 1,
        //           charitySimple: 3,
        //           createdAt: "2019-03-31T18:17:57.882Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "4f8c3baa-53e1-11e9-a9df-b77dd05ebe45",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 3,
        //           rewardReferred: 2,
        //           startAt: "2019-04-11T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusReferrer: 1,
        //           charityReferred: 1,
        //           charitySimple: 3,
        //           createdAt: "2019-06-19T01:14:00.371Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 0.0010000000474974513,
        //           id: "84fbc814-922f-11e9-9877-1fee431c43ef",
        //           math: "absolut",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 3,
        //           startAt: "2018-11-01T00:00:00.000Z",
        //           type: "redeem",
        //         },
        //       ],
        //       tradeMinimal: 0.002,
        //       withdrawMinimal: 0.02,
        //     },
        //     status: "failed",
        //     step: 1,
        //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
        //     targetCurrency: {
        //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
        //       isAvailable: true,
        //       name: "Stratumblue",
        //       onlyAsset: false,
        //       precision: 6,
        //       symbol: "BLU",
        //       taxes: null,
        //       tradeMinimal: 2,
        //       withdrawMinimal: 0.01,
        //     },
        //     targetPrice: 0.01152178147967622,
        //     type: "purchase",
        //     updatedAt: "2022-01-26T16:27:05.444Z",
        //   },
        //   {
        //     createdAt: "2022-01-26T16:33:38.362Z",
        //     id: "dc2de326-7ede-11ec-a793-ffb7af90ea1f",
        //     insertTime: "0001-01-01T00:00:00.000Z",
        //     ip: "187.49.237.178",
        //     lastUpdate: "0001-01-01T00:00:00.000Z",
        //     memberId: "b118d17a-b411-11eb-9450-47e1e1615544",
        //     pinId: "00000000-0000-0000-0000-000000000000",
        //     settledAt: "0001-01-01T00:00:00.000Z",
        //     sourceAccountId: "c3b0db20-b411-11eb-a8c0-d792be390a4b",
        //     sourceCurrency: {
        //       id: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //       isAvailable: true,
        //       marketPercent: 22.5,
        //       name: "Bitcoin",
        //       onlyAsset: false,
        //       precision: 8,
        //       symbol: "BTC",
        //       taxes: [
        //         {
        //           bonusRefer: 1,
        //           charityReferred: 3,
        //           charitySimple: 1,
        //           createdAt: "2021-02-01T00:00:00.000Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "e52fa818-6aff-11eb-b00d-8ff92bf3258e",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.25,
        //           rewardAmbassador: 2.75,
        //           rewardReferred: 2,
        //           startAt: "2021-02-01T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusRefer: 1,
        //           charityReferred: 3,
        //           charitySimple: 1,
        //           createdAt: "2020-07-14T00:00:00.000Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "b520ae4a-d065-11ea-b9f2-ab57e2ffff62",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 2.4,
        //           rewardReferred: 2,
        //           startAt: "2020-07-14T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusRefer: 1,
        //           bonusReferrer: 1,
        //           charityReferred: 1,
        //           charitySimple: 3,
        //           createdAt: "2019-03-31T18:17:57.882Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "4f8c3baa-53e1-11e9-a9df-b77dd05ebe45",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 3,
        //           rewardReferred: 2,
        //           startAt: "2019-04-11T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusReferrer: 1,
        //           charityReferred: 1,
        //           charitySimple: 3,
        //           createdAt: "2019-06-19T01:14:00.371Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 0.0010000000474974513,
        //           id: "84fbc814-922f-11e9-9877-1fee431c43ef",
        //           math: "absolut",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 3,
        //           startAt: "2018-11-01T00:00:00.000Z",
        //           type: "redeem",
        //         },
        //       ],
        //       tradeMinimal: 0.002,
        //       withdrawMinimal: 0.02,
        //     },
        //     status: "failed",
        //     step: 1,
        //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
        //     targetCurrency: {
        //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
        //       isAvailable: true,
        //       name: "Stratumblue",
        //       onlyAsset: false,
        //       precision: 6,
        //       symbol: "BLU",
        //       taxes: null,
        //       tradeMinimal: 2,
        //       withdrawMinimal: 0.01,
        //     },
        //     targetPrice: 0.011668909159847704,
        //     type: "purchase",
        //     updatedAt: "2022-01-26T16:33:41.511Z",
        //   },
        //   {
        //     createdAt: "2022-01-26T16:36:16.582Z",
        //     id: "3a7bd0f0-7edf-11ec-96cd-7bf813ca8d81",
        //     insertTime: "0001-01-01T00:00:00.000Z",
        //     ip: "187.49.237.178",
        //     lastUpdate: "0001-01-01T00:00:00.000Z",
        //     memberId: "b118d17a-b411-11eb-9450-47e1e1615544",
        //     pinId: "00000000-0000-0000-0000-000000000000",
        //     settledAt: "0001-01-01T00:00:00.000Z",
        //     sourceAccountId: "c3b0db20-b411-11eb-a8c0-d792be390a4b",
        //     sourceCurrency: {
        //       id: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //       isAvailable: true,
        //       marketPercent: 22.5,
        //       name: "Bitcoin",
        //       onlyAsset: false,
        //       precision: 8,
        //       symbol: "BTC",
        //       taxes: [
        //         {
        //           bonusRefer: 1,
        //           charityReferred: 3,
        //           charitySimple: 1,
        //           createdAt: "2021-02-01T00:00:00.000Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "e52fa818-6aff-11eb-b00d-8ff92bf3258e",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.25,
        //           rewardAmbassador: 2.75,
        //           rewardReferred: 2,
        //           startAt: "2021-02-01T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusRefer: 1,
        //           charityReferred: 3,
        //           charitySimple: 1,
        //           createdAt: "2020-07-14T00:00:00.000Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "b520ae4a-d065-11ea-b9f2-ab57e2ffff62",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 2.4,
        //           rewardReferred: 2,
        //           startAt: "2020-07-14T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusRefer: 1,
        //           bonusReferrer: 1,
        //           charityReferred: 1,
        //           charitySimple: 3,
        //           createdAt: "2019-03-31T18:17:57.882Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "4f8c3baa-53e1-11e9-a9df-b77dd05ebe45",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 3,
        //           rewardReferred: 2,
        //           startAt: "2019-04-11T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusReferrer: 1,
        //           charityReferred: 1,
        //           charitySimple: 3,
        //           createdAt: "2019-06-19T01:14:00.371Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 0.0010000000474974513,
        //           id: "84fbc814-922f-11e9-9877-1fee431c43ef",
        //           math: "absolut",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 3,
        //           startAt: "2018-11-01T00:00:00.000Z",
        //           type: "redeem",
        //         },
        //       ],
        //       tradeMinimal: 0.002,
        //       withdrawMinimal: 0.02,
        //     },
        //     status: "failed",
        //     step: 1,
        //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
        //     targetCurrency: {
        //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
        //       isAvailable: true,
        //       name: "Stratumblue",
        //       onlyAsset: false,
        //       precision: 6,
        //       symbol: "BLU",
        //       taxes: null,
        //       tradeMinimal: 2,
        //       withdrawMinimal: 0.01,
        //     },
        //     targetPrice: 0.011632091079697536,
        //     type: "purchase",
        //     updatedAt: "2022-01-26T16:36:19.711Z",
        //   },
        //   {
        //     createdAt: "2022-01-26T16:36:35.693Z",
        //     id: "45dff174-7edf-11ec-9feb-93fb82f48b52",
        //     insertTime: "0001-01-01T00:00:00.000Z",
        //     ip: "187.49.237.178",
        //     lastUpdate: "0001-01-01T00:00:00.000Z",
        //     memberId: "b118d17a-b411-11eb-9450-47e1e1615544",
        //     pinId: "00000000-0000-0000-0000-000000000000",
        //     settledAt: "0001-01-01T00:00:00.000Z",
        //     sourceAccountId: "c3b0db20-b411-11eb-a8c0-d792be390a4b",
        //     sourceCurrency: {
        //       id: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //       isAvailable: true,
        //       marketPercent: 22.5,
        //       name: "Bitcoin",
        //       onlyAsset: false,
        //       precision: 8,
        //       symbol: "BTC",
        //       taxes: [
        //         {
        //           bonusRefer: 1,
        //           charityReferred: 3,
        //           charitySimple: 1,
        //           createdAt: "2021-02-01T00:00:00.000Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "e52fa818-6aff-11eb-b00d-8ff92bf3258e",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.25,
        //           rewardAmbassador: 2.75,
        //           rewardReferred: 2,
        //           startAt: "2021-02-01T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusRefer: 1,
        //           charityReferred: 3,
        //           charitySimple: 1,
        //           createdAt: "2020-07-14T00:00:00.000Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "b520ae4a-d065-11ea-b9f2-ab57e2ffff62",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 2.4,
        //           rewardReferred: 2,
        //           startAt: "2020-07-14T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusRefer: 1,
        //           bonusReferrer: 1,
        //           charityReferred: 1,
        //           charitySimple: 3,
        //           createdAt: "2019-03-31T18:17:57.882Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "4f8c3baa-53e1-11e9-a9df-b77dd05ebe45",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 3,
        //           rewardReferred: 2,
        //           startAt: "2019-04-11T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusReferrer: 1,
        //           charityReferred: 1,
        //           charitySimple: 3,
        //           createdAt: "2019-06-19T01:14:00.371Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 0.0010000000474974513,
        //           id: "84fbc814-922f-11e9-9877-1fee431c43ef",
        //           math: "absolut",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 3,
        //           startAt: "2018-11-01T00:00:00.000Z",
        //           type: "redeem",
        //         },
        //       ],
        //       tradeMinimal: 0.002,
        //       withdrawMinimal: 0.02,
        //     },
        //     status: "failed",
        //     step: 1,
        //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
        //     targetCurrency: {
        //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
        //       isAvailable: true,
        //       name: "Stratumblue",
        //       onlyAsset: false,
        //       precision: 6,
        //       symbol: "BLU",
        //       taxes: null,
        //       tradeMinimal: 2,
        //       withdrawMinimal: 0.01,
        //     },
        //     targetPrice: 0.011632091079697536,
        //     type: "purchase",
        //     updatedAt: "2022-01-26T16:36:38.632Z",
        //   },
        //   {
        //     createdAt: "2022-01-26T17:27:57.661Z",
        //     id: "72d8e1fc-7ee6-11ec-8020-7376b5dcbd21",
        //     insertTime: "0001-01-01T00:00:00.000Z",
        //     ip: "187.49.237.178",
        //     lastUpdate: "0001-01-01T00:00:00.000Z",
        //     memberId: "b118d17a-b411-11eb-9450-47e1e1615544",
        //     pinId: "00000000-0000-0000-0000-000000000000",
        //     settledAt: "0001-01-01T00:00:00.000Z",
        //     sourceAccountId: "c3b0db20-b411-11eb-a8c0-d792be390a4b",
        //     sourceCurrency: {
        //       id: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //       isAvailable: true,
        //       marketPercent: 22.5,
        //       name: "Bitcoin",
        //       onlyAsset: false,
        //       precision: 8,
        //       symbol: "BTC",
        //       taxes: [
        //         {
        //           bonusRefer: 1,
        //           charityReferred: 3,
        //           charitySimple: 1,
        //           createdAt: "2021-02-01T00:00:00.000Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "e52fa818-6aff-11eb-b00d-8ff92bf3258e",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.25,
        //           rewardAmbassador: 2.75,
        //           rewardReferred: 2,
        //           startAt: "2021-02-01T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusRefer: 1,
        //           charityReferred: 3,
        //           charitySimple: 1,
        //           createdAt: "2020-07-14T00:00:00.000Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "b520ae4a-d065-11ea-b9f2-ab57e2ffff62",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 2.4,
        //           rewardReferred: 2,
        //           startAt: "2020-07-14T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusRefer: 1,
        //           bonusReferrer: 1,
        //           charityReferred: 1,
        //           charitySimple: 3,
        //           createdAt: "2019-03-31T18:17:57.882Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "4f8c3baa-53e1-11e9-a9df-b77dd05ebe45",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 3,
        //           rewardReferred: 2,
        //           startAt: "2019-04-11T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusReferrer: 1,
        //           charityReferred: 1,
        //           charitySimple: 3,
        //           createdAt: "2019-06-19T01:14:00.371Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 0.0010000000474974513,
        //           id: "84fbc814-922f-11e9-9877-1fee431c43ef",
        //           math: "absolut",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 3,
        //           startAt: "2018-11-01T00:00:00.000Z",
        //           type: "redeem",
        //         },
        //       ],
        //       tradeMinimal: 0.002,
        //       withdrawMinimal: 0.02,
        //     },
        //     status: "failed",
        //     step: 1,
        //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
        //     targetCurrency: {
        //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
        //       isAvailable: true,
        //       name: "Stratumblue",
        //       onlyAsset: false,
        //       precision: 6,
        //       symbol: "BLU",
        //       taxes: null,
        //       tradeMinimal: 2,
        //       withdrawMinimal: 0.01,
        //     },
        //     targetPrice: 0.011430673576903541,
        //     type: "purchase",
        //     updatedAt: "2022-01-26T17:28:01.533Z",
        //   },
        //   {
        //     createdAt: "2022-01-26T17:31:30.364Z",
        //     id: "f1a0991c-7ee6-11ec-8901-7b81dc0f3361",
        //     insertTime: "0001-01-01T00:00:00.000Z",
        //     ip: "187.49.237.178",
        //     lastUpdate: "0001-01-01T00:00:00.000Z",
        //     memberId: "b118d17a-b411-11eb-9450-47e1e1615544",
        //     pinId: "00000000-0000-0000-0000-000000000000",
        //     settledAt: "0001-01-01T00:00:00.000Z",
        //     sourceAccountId: "c3b0db20-b411-11eb-a8c0-d792be390a4b",
        //     sourceCurrency: {
        //       id: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //       isAvailable: true,
        //       marketPercent: 22.5,
        //       name: "Bitcoin",
        //       onlyAsset: false,
        //       precision: 8,
        //       symbol: "BTC",
        //       taxes: [
        //         {
        //           bonusRefer: 1,
        //           charityReferred: 3,
        //           charitySimple: 1,
        //           createdAt: "2021-02-01T00:00:00.000Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "e52fa818-6aff-11eb-b00d-8ff92bf3258e",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.25,
        //           rewardAmbassador: 2.75,
        //           rewardReferred: 2,
        //           startAt: "2021-02-01T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusRefer: 1,
        //           charityReferred: 3,
        //           charitySimple: 1,
        //           createdAt: "2020-07-14T00:00:00.000Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "b520ae4a-d065-11ea-b9f2-ab57e2ffff62",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 2.4,
        //           rewardReferred: 2,
        //           startAt: "2020-07-14T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusRefer: 1,
        //           bonusReferrer: 1,
        //           charityReferred: 1,
        //           charitySimple: 3,
        //           createdAt: "2019-03-31T18:17:57.882Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "4f8c3baa-53e1-11e9-a9df-b77dd05ebe45",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 3,
        //           rewardReferred: 2,
        //           startAt: "2019-04-11T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusReferrer: 1,
        //           charityReferred: 1,
        //           charitySimple: 3,
        //           createdAt: "2019-06-19T01:14:00.371Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 0.0010000000474974513,
        //           id: "84fbc814-922f-11e9-9877-1fee431c43ef",
        //           math: "absolut",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 3,
        //           startAt: "2018-11-01T00:00:00.000Z",
        //           type: "redeem",
        //         },
        //       ],
        //       tradeMinimal: 0.002,
        //       withdrawMinimal: 0.02,
        //     },
        //     status: "failed",
        //     step: 1,
        //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
        //     targetCurrency: {
        //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
        //       isAvailable: true,
        //       name: "Stratumblue",
        //       onlyAsset: false,
        //       precision: 6,
        //       symbol: "BLU",
        //       taxes: null,
        //       tradeMinimal: 2,
        //       withdrawMinimal: 0.01,
        //     },
        //     targetPrice: 0.011466869331457978,
        //     type: "purchase",
        //     updatedAt: "2022-01-26T17:31:33.677Z",
        //   },
        //   {
        //     createdAt: "2022-02-03T17:37:17.253Z",
        //     expiresIn: 7200000,
        //     id: "13ba4cb4-8531-11ec-801e-b70c74c53e0f",
        //     insertTime: "0001-01-01T00:00:00.000Z",
        //     ip: "187.49.237.178",
        //     lastUpdate: "0001-01-01T00:00:00.000Z",
        //     memberId: "b118d17a-b411-11eb-9450-47e1e1615544",
        //     pinId: "00000000-0000-0000-0000-000000000000",
        //     settledAt: "0001-01-01T00:00:00.000Z",
        //     sourceAccountId: "c3b0db20-b411-11eb-a8c0-d792be390a4b",
        //     sourceAmount: 0.0004716981132075472,
        //     sourceCurrency: {
        //       id: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //       isAvailable: true,
        //       marketPercent: 22.5,
        //       name: "Bitcoin",
        //       onlyAsset: false,
        //       precision: 8,
        //       symbol: "BTC",
        //       taxes: [
        //         {
        //           bonusRefer: 1,
        //           charityReferred: 3,
        //           charitySimple: 1,
        //           createdAt: "2021-02-01T00:00:00.000Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "e52fa818-6aff-11eb-b00d-8ff92bf3258e",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.25,
        //           rewardAmbassador: 2.75,
        //           rewardReferred: 2,
        //           startAt: "2021-02-01T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusRefer: 1,
        //           charityReferred: 3,
        //           charitySimple: 1,
        //           createdAt: "2020-07-14T00:00:00.000Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "b520ae4a-d065-11ea-b9f2-ab57e2ffff62",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 2.4,
        //           rewardReferred: 2,
        //           startAt: "2020-07-14T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusRefer: 1,
        //           bonusReferrer: 1,
        //           charityReferred: 1,
        //           charitySimple: 3,
        //           createdAt: "2019-03-31T18:17:57.882Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "4f8c3baa-53e1-11e9-a9df-b77dd05ebe45",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 3,
        //           rewardReferred: 2,
        //           startAt: "2019-04-11T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusReferrer: 1,
        //           charityReferred: 1,
        //           charitySimple: 3,
        //           createdAt: "2019-06-19T01:14:00.371Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 0.0010000000474974513,
        //           id: "84fbc814-922f-11e9-9877-1fee431c43ef",
        //           math: "absolut",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 3,
        //           startAt: "2018-11-01T00:00:00.000Z",
        //           type: "redeem",
        //         },
        //       ],
        //       tradeMinimal: 0.002,
        //       withdrawMinimal: 0.02,
        //     },
        //     sourceFee: 0.0000283019,
        //     status: "done",
        //     step: 4,
        //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
        //     targetAddress: "1Ckcf533hQxrcd1okSDspWqGipA5ZY1JoV",
        //     targetAmount: 0.043058635898780076,
        //     targetCurrency: {
        //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
        //       isAvailable: true,
        //       name: "Stratumblue",
        //       onlyAsset: false,
        //       precision: 6,
        //       symbol: "BLU",
        //       taxes: null,
        //       tradeMinimal: 2,
        //       withdrawMinimal: 0.01,
        //     },
        //     targetPrice: 0.010954785337751752,
        //     tokenStatus: "processing",
        //     tokenStep: "waiting_publish",
        //     tokenTxid:
        //       "0x425d7085ae1d3b6d64e3815347153648564fedb0894ddf228b6e181199ee618f",
        //     type: "purchase",
        //     updatedAt: "2022-02-03T17:44:03.704Z",
        //   },
        //   {
        //     createdAt: "2022-02-03T17:50:38.640Z",
        //     expiresIn: 7200000,
        //     id: "f1646c1a-8532-11ec-b6b4-77792b3f8dd7",
        //     insertTime: "0001-01-01T00:00:00.000Z",
        //     ip: "187.49.237.178",
        //     lastUpdate: "0001-01-01T00:00:00.000Z",
        //     memberId: "b118d17a-b411-11eb-9450-47e1e1615544",
        //     pinId: "00000000-0000-0000-0000-000000000000",
        //     settledAt: "0001-01-01T00:00:00.000Z",
        //     sourceAccountId: "c3d2a25a-b411-11eb-bbe9-17219b0ca111",
        //     sourceAmount: 0.00009623584905660377,
        //     sourceCurrency: {
        //       id: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
        //       isAvailable: true,
        //       marketPercent: 22.5,
        //       name: "Ethereum",
        //       onlyAsset: false,
        //       precision: 8,
        //       symbol: "ETH",
        //       taxes: [
        //         {
        //           bonusRefer: 1,
        //           charityReferred: 3,
        //           charitySimple: 1,
        //           createdAt: "2021-02-01T00:00:00.000Z",
        //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "e53001f0-6aff-11eb-b011-e7f585edc40d",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.25,
        //           rewardAmbassador: 2.75,
        //           rewardReferred: 2,
        //           startAt: "2021-02-01T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusRefer: 1,
        //           bonusReferrer: 1,
        //           charityReferred: 1,
        //           charitySimple: 3,
        //           createdAt: "2019-08-01T16:37:25.014Z",
        //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "a47cb226-b47a-11e9-9d96-73a1ce6e16f1",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 3,
        //           rewardReferred: 2,
        //           startAt: "2019-03-16T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusReferrer: 1,
        //           charityReferred: 1,
        //           charitySimple: 3,
        //           createdAt: "2021-02-09T15:27:01.495Z",
        //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 0.002,
        //           id: "a47cc2ac-b47a-11e9-9d97-cbb9a5578da5",
        //           math: "absolut",
        //           revenue: 2,
        //           rewardAmbassador: 3,
        //           startAt: "2018-11-01T00:00:00.000Z",
        //           type: "redeem",
        //         },
        //       ],
        //       tradeMinimal: 1e-7,
        //     },
        //     sourceFee: 0.0000057742,
        //     status: "done",
        //     step: 4,
        //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
        //     targetAddress: "0x452d598056aa21c9388ee7543536fd9cd853cc9c",
        //     targetAmount: 0.0006255795319207052,
        //     targetCurrency: {
        //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
        //       isAvailable: true,
        //       name: "Stratumblue",
        //       onlyAsset: false,
        //       precision: 6,
        //       symbol: "BLU",
        //       taxes: null,
        //       tradeMinimal: 2,
        //       withdrawMinimal: 0.01,
        //     },
        //     targetPrice: 0.15383471508591823,
        //     tokenStatus: "processing",
        //     tokenStep: "waiting_publish",
        //     tokenTxid:
        //       "0x59f1f319c6c949b73ba5030c4989183649a026cf0edf9cda53b83ddc71dfcc81",
        //     type: "purchase",
        //     updatedAt: "2022-02-03T17:55:26.645Z",
        //   },
        //   {
        //     createdAt: "2022-02-03T17:58:48.831Z",
        //     expiresIn: 7200000,
        //     id: "1591bcc2-8534-11ec-8e16-7fae56adedf3",
        //     insertTime: "0001-01-01T00:00:00.000Z",
        //     ip: "187.49.237.178",
        //     lastUpdate: "0001-01-01T00:00:00.000Z",
        //     memberId: "b118d17a-b411-11eb-9450-47e1e1615544",
        //     pinId: "00000000-0000-0000-0000-000000000000",
        //     settledAt: "0001-01-01T00:00:00.000Z",
        //     sourceAccountId: "a1add374-e32e-11eb-8160-d79ba51bf6fd",
        //     sourceAmount: 8.49056603773585,
        //     sourceCurrency: {
        //       id: "1820a89a-0745-11eb-9412-6ffc5759940f",
        //       isAvailable: true,
        //       name: "Tether",
        //       onlyAsset: false,
        //       precision: 8,
        //       symbol: "USDT",
        //       taxes: [
        //         {
        //           createdAt: "2022-02-01T12:12:40.394Z",
        //           currencyId: "1820a89a-0745-11eb-9412-6ffc5759940f",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 50,
        //           id: "407d59ce-8358-11ec-b72f-0b95b1c736fd",
        //           math: "absolut",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 3,
        //           startAt: "2022-01-30T00:00:00.000Z",
        //           type: "redeem",
        //         },
        //         {
        //           createdAt: "2022-02-01T12:12:40.394Z",
        //           currencyId: "1820a89a-0745-11eb-9412-6ffc5759940f",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 100,
        //           id: "407d530c-8358-11ec-b72e-775b917068b1",
        //           math: "rush",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 3,
        //           startAt: "2022-01-30T00:00:00.000Z",
        //           type: "redeem",
        //         },
        //         {
        //           createdAt: "2022-02-01T12:12:40.394Z",
        //           currencyId: "1820a89a-0745-11eb-9412-6ffc5759940f",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 1,
        //           id: "407d48b2-8358-11ec-b72d-5fb7bcf7f02a",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 3,
        //           startAt: "2022-01-30T00:00:00.000Z",
        //           type: "redeem",
        //         },
        //         {
        //           createdAt: "2022-01-28T11:26:32.367Z",
        //           currencyId: "1820a89a-0745-11eb-9412-6ffc5759940f",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 100,
        //           id: "a47cddb3-b47b-1139-9d8b-c79bcd37f815",
        //           math: "rush",
        //           startAt: "2022-01-20T00:00:00.000Z",
        //           type: "redeem",
        //         },
        //         {
        //           createdAt: "2022-01-28T11:26:27.948Z",
        //           currencyId: "1820a89a-0745-11eb-9412-6ffc5759940f",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 50,
        //           id: "a47cddbe-b47a-1139-9d8b-c79bcd37f815",
        //           math: "absolut",
        //           startAt: "2022-01-20T00:00:00.000Z",
        //           type: "redeem",
        //         },
        //         {
        //           createdAt: "2022-01-31T12:38:42.208Z",
        //           currencyId: "1820a89a-0745-11eb-9412-6ffc5759940f",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 1,
        //           id: "a47cddbe-b47a-11e9-9d9b-c79bcd37f815",
        //           math: "percent",
        //           startAt: "2022-01-20T00:00:00.000Z",
        //           type: "redeem",
        //         },
        //         {
        //           bonusReferrer: 1,
        //           charityReferred: 1,
        //           charitySimple: 3,
        //           createdAt: "2021-06-14T00:00:00.000Z",
        //           currencyId: "1820a89a-0745-11eb-9412-6ffc5759940f",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 0.001,
        //           id: "709de17e-cf7f-11eb-8b26-731f225dfe92",
        //           math: "absolut",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 3,
        //           startAt: "2021-06-14T00:00:00.000Z",
        //           type: "redeem",
        //         },
        //         {
        //           bonusRefer: 25,
        //           bonusReferrer: 50,
        //           charityReferred: 3,
        //           charitySimple: 50,
        //           createdAt: "2022-02-18T14:47:59.152Z",
        //           currencyId: "1820a89a-0745-11eb-9412-6ffc5759940f",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 2,
        //           id: "709d9746-cf7f-11eb-8b25-8f42d2b0e61d",
        //           math: "percent",
        //           revenue: 50,
        //           revenueAmbassador: 25,
        //           rewardAmbassador: 2.75,
        //           rewardReferred: 2,
        //           startAt: "2021-06-14T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //       ],
        //     },
        //     sourceFee: 0.5094339623,
        //     status: "done",
        //     step: 4,
        //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
        //     targetAddress: "TGMAXQPaQEW6SPe1nKAEEevfJTE44hVAQo",
        //     targetAmount: 0.02131295070091143,
        //     targetCurrency: {
        //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
        //       isAvailable: true,
        //       name: "Stratumblue",
        //       onlyAsset: false,
        //       precision: 6,
        //       symbol: "BLU",
        //       taxes: null,
        //       tradeMinimal: 2,
        //       withdrawMinimal: 0.01,
        //     },
        //     targetPrice: 398.3759056587485,
        //     tokenStatus: "processing",
        //     tokenStep: "waiting_publish",
        //     tokenTxid:
        //       "0x6c03ac5c816e1f95fa6bd78b49711e4632a280044519d39cb3693d4ddef4c055",
        //     type: "purchase",
        //     updatedAt: "2022-02-03T18:02:47.883Z",
        //   },
        //   {
        //     createdAt: "2022-02-24T11:38:56.937Z",
        //     expiresIn: 7200000,
        //     id: "7f32c0da-957f-11ec-bd99-abbfd43ec26f",
        //     insertTime: "0001-01-01T00:00:00.000Z",
        //     ip: "187.49.237.178",
        //     lastUpdate: "0001-01-01T00:00:00.000Z",
        //     memberId: "b118d17a-b411-11eb-9450-47e1e1615544",
        //     pinId: "00000000-0000-0000-0000-000000000000",
        //     settledAt: "0001-01-01T00:00:00.000Z",
        //     sourceAccountId: "a1add374-e32e-11eb-8160-d79ba51bf6fd",
        //     sourceAmount: 8.823529411764707,
        //     sourceCurrency: {
        //       id: "1820a89a-0745-11eb-9412-6ffc5759940f",
        //       isAvailable: true,
        //       name: "Tether",
        //       onlyAsset: false,
        //       precision: 8,
        //       symbol: "USDT",
        //       taxes: [
        //         {
        //           createdAt: "2022-02-01T12:12:40.394Z",
        //           currencyId: "1820a89a-0745-11eb-9412-6ffc5759940f",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 50,
        //           id: "407d59ce-8358-11ec-b72f-0b95b1c736fd",
        //           math: "absolut",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 3,
        //           startAt: "2022-01-30T00:00:00.000Z",
        //           type: "redeem",
        //         },
        //         {
        //           createdAt: "2022-02-01T12:12:40.394Z",
        //           currencyId: "1820a89a-0745-11eb-9412-6ffc5759940f",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 100,
        //           id: "407d530c-8358-11ec-b72e-775b917068b1",
        //           math: "rush",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 3,
        //           startAt: "2022-01-30T00:00:00.000Z",
        //           type: "redeem",
        //         },
        //         {
        //           createdAt: "2022-02-01T12:12:40.394Z",
        //           currencyId: "1820a89a-0745-11eb-9412-6ffc5759940f",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 1,
        //           id: "407d48b2-8358-11ec-b72d-5fb7bcf7f02a",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 3,
        //           startAt: "2022-01-30T00:00:00.000Z",
        //           type: "redeem",
        //         },
        //         {
        //           createdAt: "2022-01-28T11:26:32.367Z",
        //           currencyId: "1820a89a-0745-11eb-9412-6ffc5759940f",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 100,
        //           id: "a47cddb3-b47b-1139-9d8b-c79bcd37f815",
        //           math: "rush",
        //           startAt: "2022-01-20T00:00:00.000Z",
        //           type: "redeem",
        //         },
        //         {
        //           createdAt: "2022-01-28T11:26:27.948Z",
        //           currencyId: "1820a89a-0745-11eb-9412-6ffc5759940f",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 50,
        //           id: "a47cddbe-b47a-1139-9d8b-c79bcd37f815",
        //           math: "absolut",
        //           startAt: "2022-01-20T00:00:00.000Z",
        //           type: "redeem",
        //         },
        //         {
        //           createdAt: "2022-01-31T12:38:42.208Z",
        //           currencyId: "1820a89a-0745-11eb-9412-6ffc5759940f",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 1,
        //           id: "a47cddbe-b47a-11e9-9d9b-c79bcd37f815",
        //           math: "percent",
        //           startAt: "2022-01-20T00:00:00.000Z",
        //           type: "redeem",
        //         },
        //         {
        //           bonusReferrer: 1,
        //           charityReferred: 1,
        //           charitySimple: 3,
        //           createdAt: "2021-06-14T00:00:00.000Z",
        //           currencyId: "1820a89a-0745-11eb-9412-6ffc5759940f",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 0.001,
        //           id: "709de17e-cf7f-11eb-8b26-731f225dfe92",
        //           math: "absolut",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 3,
        //           startAt: "2021-06-14T00:00:00.000Z",
        //           type: "redeem",
        //         },
        //         {
        //           bonusRefer: 25,
        //           bonusReferrer: 50,
        //           charityReferred: 3,
        //           charitySimple: 50,
        //           createdAt: "2022-02-18T14:47:59.152Z",
        //           currencyId: "1820a89a-0745-11eb-9412-6ffc5759940f",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 2,
        //           id: "709d9746-cf7f-11eb-8b25-8f42d2b0e61d",
        //           math: "percent",
        //           revenue: 50,
        //           revenueAmbassador: 25,
        //           rewardAmbassador: 2.75,
        //           rewardReferred: 2,
        //           startAt: "2021-06-14T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //       ],
        //     },
        //     sourceFee: 0.1764705882,
        //     status: "done",
        //     step: 4,
        //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
        //     targetAddress: "TKNrv3wg6nLjNvjUze9cj4rBx7uqe4ea8U",
        //     targetAmount: 0.023774966489100244,
        //     targetCurrency: {
        //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
        //       isAvailable: true,
        //       name: "Stratumblue",
        //       onlyAsset: false,
        //       precision: 6,
        //       symbol: "BLU",
        //       taxes: null,
        //       tradeMinimal: 2,
        //       withdrawMinimal: 0.01,
        //     },
        //     targetPrice: 371.1268916324193,
        //     tokenStatus: "done",
        //     tokenStep: "steps_done",
        //     tokenTxid:
        //       "0xd89a5cf8a8815ae3edd5f0f700998d7b66a9760915887363c36e1183c766651e",
        //     type: "purchase",
        //     updatedAt: "2022-02-24T12:33:25.995Z",
        //   },
        //   {
        //     createdAt: "2022-03-04T16:31:17.476Z",
        //     expiresIn: 7200000,
        //     id: "a97f9930-9bf1-11ec-9067-8ba37f180cbb",
        //     insertTime: "0001-01-01T00:00:00.000Z",
        //     ip: "187.49.237.178",
        //     lastUpdate: "0001-01-01T00:00:00.000Z",
        //     memberId: "b118d17a-b411-11eb-9450-47e1e1615544",
        //     pinId: "00000000-0000-0000-0000-000000000000",
        //     settledAt: "0001-01-01T00:00:00.000Z",
        //     sourceAccountId: "a1add374-e32e-11eb-8160-d79ba51bf6fd",
        //     sourceAmount: 98.03921569607843,
        //     sourceCurrency: {
        //       id: "1820a89a-0745-11eb-9412-6ffc5759940f",
        //       isAvailable: true,
        //       name: "Tether",
        //       onlyAsset: false,
        //       precision: 8,
        //       symbol: "USDT",
        //       taxes: [
        //         {
        //           createdAt: "2022-02-01T12:12:40.394Z",
        //           currencyId: "1820a89a-0745-11eb-9412-6ffc5759940f",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 50,
        //           id: "407d59ce-8358-11ec-b72f-0b95b1c736fd",
        //           math: "absolut",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 3,
        //           startAt: "2022-01-30T00:00:00.000Z",
        //           type: "redeem",
        //         },
        //         {
        //           createdAt: "2022-02-01T12:12:40.394Z",
        //           currencyId: "1820a89a-0745-11eb-9412-6ffc5759940f",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 100,
        //           id: "407d530c-8358-11ec-b72e-775b917068b1",
        //           math: "rush",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 3,
        //           startAt: "2022-01-30T00:00:00.000Z",
        //           type: "redeem",
        //         },
        //         {
        //           createdAt: "2022-02-01T12:12:40.394Z",
        //           currencyId: "1820a89a-0745-11eb-9412-6ffc5759940f",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 1,
        //           id: "407d48b2-8358-11ec-b72d-5fb7bcf7f02a",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 3,
        //           startAt: "2022-01-30T00:00:00.000Z",
        //           type: "redeem",
        //         },
        //         {
        //           createdAt: "2022-01-28T11:26:32.367Z",
        //           currencyId: "1820a89a-0745-11eb-9412-6ffc5759940f",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 100,
        //           id: "a47cddb3-b47b-1139-9d8b-c79bcd37f815",
        //           math: "rush",
        //           startAt: "2022-01-20T00:00:00.000Z",
        //           type: "redeem",
        //         },
        //         {
        //           createdAt: "2022-01-28T11:26:27.948Z",
        //           currencyId: "1820a89a-0745-11eb-9412-6ffc5759940f",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 50,
        //           id: "a47cddbe-b47a-1139-9d8b-c79bcd37f815",
        //           math: "absolut",
        //           startAt: "2022-01-20T00:00:00.000Z",
        //           type: "redeem",
        //         },
        //         {
        //           createdAt: "2022-01-31T12:38:42.208Z",
        //           currencyId: "1820a89a-0745-11eb-9412-6ffc5759940f",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 1,
        //           id: "a47cddbe-b47a-11e9-9d9b-c79bcd37f815",
        //           math: "percent",
        //           startAt: "2022-01-20T00:00:00.000Z",
        //           type: "redeem",
        //         },
        //         {
        //           bonusReferrer: 1,
        //           charityReferred: 1,
        //           charitySimple: 3,
        //           createdAt: "2021-06-14T00:00:00.000Z",
        //           currencyId: "1820a89a-0745-11eb-9412-6ffc5759940f",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 0.001,
        //           id: "709de17e-cf7f-11eb-8b26-731f225dfe92",
        //           math: "absolut",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 3,
        //           startAt: "2021-06-14T00:00:00.000Z",
        //           type: "redeem",
        //         },
        //         {
        //           bonusRefer: 25,
        //           bonusReferrer: 50,
        //           charityReferred: 3,
        //           charitySimple: 50,
        //           createdAt: "2022-02-18T14:47:59.152Z",
        //           currencyId: "1820a89a-0745-11eb-9412-6ffc5759940f",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 2,
        //           id: "709d9746-cf7f-11eb-8b25-8f42d2b0e61d",
        //           math: "percent",
        //           revenue: 50,
        //           revenueAmbassador: 25,
        //           rewardAmbassador: 2.75,
        //           rewardReferred: 2,
        //           startAt: "2021-06-14T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //       ],
        //     },
        //     sourceFee: 1.9607843139,
        //     status: "done",
        //     step: 4,
        //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
        //     targetAddress: "TWwNX6BPLJmNHSWKFCwaaUDZtUk8DF2Zuo",
        //     targetAmount: 0.23146369297611374,
        //     targetCurrency: {
        //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
        //       isAvailable: true,
        //       name: "Stratumblue",
        //       onlyAsset: false,
        //       precision: 6,
        //       symbol: "BLU",
        //       taxes: null,
        //       tradeMinimal: 2,
        //       withdrawMinimal: 0.01,
        //     },
        //     targetPrice: 432.03320021467937,
        //     tokenStatus: "done",
        //     tokenStep: "steps_done",
        //     tokenTxid:
        //       "0xb94bc177f413b649938c4ab0e7d2431e6d2ca573b54e5cadc6ee79b624e8ccf4",
        //     type: "purchase",
        //     updatedAt: "2022-03-04T16:34:53.031Z",
        //   },
        //   {
        //     createdAt: "2022-03-04T18:10:44.502Z",
        //     expiresIn: 7200000,
        //     id: "8e1f6ec8-9bff-11ec-a2a4-dfd5d7b250f0",
        //     insertTime: "0001-01-01T00:00:00.000Z",
        //     ip: "187.49.237.178",
        //     lastUpdate: "0001-01-01T00:00:00.000Z",
        //     memberId: "d0868c22-852c-11ec-99bb-6b710ca8c37e",
        //     pinId: "00000000-0000-0000-0000-000000000000",
        //     sellerId: "b118d17a-b411-11eb-9450-47e1e1615544",
        //     settledAt: "0001-01-01T00:00:00.000Z",
        //     sourceAccountId: "04389204-852d-11ec-8c07-2f53be981bd9",
        //     sourceCurrency: {
        //       id: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
        //       isAvailable: true,
        //       marketPercent: 22.5,
        //       name: "Ethereum",
        //       onlyAsset: false,
        //       precision: 8,
        //       symbol: "ETH",
        //       taxes: [
        //         {
        //           bonusRefer: 1,
        //           charityReferred: 3,
        //           charitySimple: 1,
        //           createdAt: "2021-02-01T00:00:00.000Z",
        //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "e53001f0-6aff-11eb-b011-e7f585edc40d",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.25,
        //           rewardAmbassador: 2.75,
        //           rewardReferred: 2,
        //           startAt: "2021-02-01T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusRefer: 1,
        //           bonusReferrer: 1,
        //           charityReferred: 1,
        //           charitySimple: 3,
        //           createdAt: "2019-08-01T16:37:25.014Z",
        //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "a47cb226-b47a-11e9-9d96-73a1ce6e16f1",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 3,
        //           rewardReferred: 2,
        //           startAt: "2019-03-16T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusReferrer: 1,
        //           charityReferred: 1,
        //           charitySimple: 3,
        //           createdAt: "2021-02-09T15:27:01.495Z",
        //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 0.002,
        //           id: "a47cc2ac-b47a-11e9-9d97-cbb9a5578da5",
        //           math: "absolut",
        //           revenue: 2,
        //           rewardAmbassador: 3,
        //           startAt: "2018-11-01T00:00:00.000Z",
        //           type: "redeem",
        //         },
        //       ],
        //       tradeMinimal: 1e-7,
        //     },
        //     status: "expired",
        //     step: 1,
        //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
        //     targetAddress: "0xbdf98dd22c106feec93a4a872ed126bca4441f8b",
        //     targetCurrency: {
        //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
        //       isAvailable: true,
        //       name: "Stratumblue",
        //       onlyAsset: false,
        //       precision: 6,
        //       symbol: "BLU",
        //       taxes: null,
        //       tradeMinimal: 2,
        //       withdrawMinimal: 0.01,
        //     },
        //     targetPrice: 0.16294389571789933,
        //     type: "purchase",
        //     updatedAt: "2022-03-04T20:11:56.064Z",
        //   },
        //   {
        //     createdAt: "2022-03-04T18:10:45.721Z",
        //     expiresIn: 7200000,
        //     id: "8ed97250-9bff-11ec-ab62-e314ab249af6",
        //     insertTime: "0001-01-01T00:00:00.000Z",
        //     ip: "187.49.237.178",
        //     lastUpdate: "0001-01-01T00:00:00.000Z",
        //     memberId: "d0868c22-852c-11ec-99bb-6b710ca8c37e",
        //     pinId: "00000000-0000-0000-0000-000000000000",
        //     sellerId: "b118d17a-b411-11eb-9450-47e1e1615544",
        //     settledAt: "0001-01-01T00:00:00.000Z",
        //     sourceAccountId: "04389204-852d-11ec-8c07-2f53be981bd9",
        //     sourceCurrency: {
        //       id: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
        //       isAvailable: true,
        //       marketPercent: 22.5,
        //       name: "Ethereum",
        //       onlyAsset: false,
        //       precision: 8,
        //       symbol: "ETH",
        //       taxes: [
        //         {
        //           bonusRefer: 1,
        //           charityReferred: 3,
        //           charitySimple: 1,
        //           createdAt: "2021-02-01T00:00:00.000Z",
        //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "e53001f0-6aff-11eb-b011-e7f585edc40d",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.25,
        //           rewardAmbassador: 2.75,
        //           rewardReferred: 2,
        //           startAt: "2021-02-01T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusRefer: 1,
        //           bonusReferrer: 1,
        //           charityReferred: 1,
        //           charitySimple: 3,
        //           createdAt: "2019-08-01T16:37:25.014Z",
        //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "a47cb226-b47a-11e9-9d96-73a1ce6e16f1",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 3,
        //           rewardReferred: 2,
        //           startAt: "2019-03-16T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusReferrer: 1,
        //           charityReferred: 1,
        //           charitySimple: 3,
        //           createdAt: "2021-02-09T15:27:01.495Z",
        //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 0.002,
        //           id: "a47cc2ac-b47a-11e9-9d97-cbb9a5578da5",
        //           math: "absolut",
        //           revenue: 2,
        //           rewardAmbassador: 3,
        //           startAt: "2018-11-01T00:00:00.000Z",
        //           type: "redeem",
        //         },
        //       ],
        //       tradeMinimal: 1e-7,
        //     },
        //     status: "expired",
        //     step: 1,
        //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
        //     targetAddress: "0x6967a8d5b432862bee3c43c8196c952fe5139d9a",
        //     targetCurrency: {
        //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
        //       isAvailable: true,
        //       name: "Stratumblue",
        //       onlyAsset: false,
        //       precision: 6,
        //       symbol: "BLU",
        //       taxes: null,
        //       tradeMinimal: 2,
        //       withdrawMinimal: 0.01,
        //     },
        //     targetPrice: 0.16294389571789933,
        //     type: "purchase",
        //     updatedAt: "2022-03-04T18:12:04.459Z",
        //   },
        //   {
        //     createdAt: "2022-03-04T18:11:16.895Z",
        //     expiresIn: 7200000,
        //     id: "a16e705a-9bff-11ec-b585-a3e2e070ca2c",
        //     insertTime: "0001-01-01T00:00:00.000Z",
        //     ip: "187.49.237.178",
        //     lastUpdate: "0001-01-01T00:00:00.000Z",
        //     memberId: "d0868c22-852c-11ec-99bb-6b710ca8c37e",
        //     pinId: "00000000-0000-0000-0000-000000000000",
        //     sellerId: "b118d17a-b411-11eb-9450-47e1e1615544",
        //     settledAt: "0001-01-01T00:00:00.000Z",
        //     sourceAccountId: "04389204-852d-11ec-8c07-2f53be981bd9",
        //     sourceAmount: 0.0027622735849056603,
        //     sourceCurrency: {
        //       id: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
        //       isAvailable: true,
        //       marketPercent: 22.5,
        //       name: "Ethereum",
        //       onlyAsset: false,
        //       precision: 8,
        //       symbol: "ETH",
        //       taxes: [
        //         {
        //           bonusRefer: 1,
        //           charityReferred: 3,
        //           charitySimple: 1,
        //           createdAt: "2021-02-01T00:00:00.000Z",
        //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "e53001f0-6aff-11eb-b011-e7f585edc40d",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.25,
        //           rewardAmbassador: 2.75,
        //           rewardReferred: 2,
        //           startAt: "2021-02-01T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusRefer: 1,
        //           bonusReferrer: 1,
        //           charityReferred: 1,
        //           charitySimple: 3,
        //           createdAt: "2019-08-01T16:37:25.014Z",
        //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "a47cb226-b47a-11e9-9d96-73a1ce6e16f1",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 3,
        //           rewardReferred: 2,
        //           startAt: "2019-03-16T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusReferrer: 1,
        //           charityReferred: 1,
        //           charitySimple: 3,
        //           createdAt: "2021-02-09T15:27:01.495Z",
        //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 0.002,
        //           id: "a47cc2ac-b47a-11e9-9d97-cbb9a5578da5",
        //           math: "absolut",
        //           revenue: 2,
        //           rewardAmbassador: 3,
        //           startAt: "2018-11-01T00:00:00.000Z",
        //           type: "redeem",
        //         },
        //       ],
        //       tradeMinimal: 1e-7,
        //     },
        //     sourceFee: 0.0000552455,
        //     status: "done",
        //     step: 4,
        //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
        //     targetAddress: "0x79109ab0bc2062624e9f8685ac5013911bf0985c",
        //     targetAmount: 0.017303198489055288,
        //     targetCurrency: {
        //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
        //       isAvailable: true,
        //       name: "Stratumblue",
        //       onlyAsset: false,
        //       precision: 6,
        //       symbol: "BLU",
        //       taxes: null,
        //       tradeMinimal: 2,
        //       withdrawMinimal: 0.01,
        //     },
        //     targetPrice: 0.16283226980767818,
        //     tokenStatus: "done",
        //     tokenStep: "steps_done",
        //     tokenTxid:
        //       "0x7ec5e31b1203c8407df37ef459af88e65c1e80a9864aef18ea9d99f11163923b",
        //     type: "purchase",
        //     updatedAt: "2022-03-04T18:15:04.911Z",
        //   },
        //   {
        //     createdAt: "2022-03-04T18:26:30.432Z",
        //     expiresIn: 7200000,
        //     id: "c1f0eb3a-9c01-11ec-aa0c-731d6be8b07c",
        //     insertTime: "0001-01-01T00:00:00.000Z",
        //     ip: "187.49.237.178",
        //     lastUpdate: "0001-01-01T00:00:00.000Z",
        //     memberId: "daf65e90-4336-11ec-bb8f-cf793e3db15a",
        //     pinId: "00000000-0000-0000-0000-000000000000",
        //     sellerId: "b118d17a-b411-11eb-9450-47e1e1615544",
        //     settledAt: "0001-01-01T00:00:00.000Z",
        //     sourceAccountId: "e41ca790-4336-11ec-a15b-6f3fa2f6a17d",
        //     sourceAmount: 0.0035412641509433964,
        //     sourceCurrency: {
        //       id: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
        //       isAvailable: true,
        //       marketPercent: 22.5,
        //       name: "Ethereum",
        //       onlyAsset: false,
        //       precision: 8,
        //       symbol: "ETH",
        //       taxes: [
        //         {
        //           bonusRefer: 1,
        //           charityReferred: 3,
        //           charitySimple: 1,
        //           createdAt: "2021-02-01T00:00:00.000Z",
        //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "e53001f0-6aff-11eb-b011-e7f585edc40d",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.25,
        //           rewardAmbassador: 2.75,
        //           rewardReferred: 2,
        //           startAt: "2021-02-01T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusRefer: 1,
        //           bonusReferrer: 1,
        //           charityReferred: 1,
        //           charitySimple: 3,
        //           createdAt: "2019-08-01T16:37:25.014Z",
        //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "a47cb226-b47a-11e9-9d96-73a1ce6e16f1",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 3,
        //           rewardReferred: 2,
        //           startAt: "2019-03-16T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusReferrer: 1,
        //           charityReferred: 1,
        //           charitySimple: 3,
        //           createdAt: "2021-02-09T15:27:01.495Z",
        //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 0.002,
        //           id: "a47cc2ac-b47a-11e9-9d97-cbb9a5578da5",
        //           math: "absolut",
        //           revenue: 2,
        //           rewardAmbassador: 3,
        //           startAt: "2018-11-01T00:00:00.000Z",
        //           type: "redeem",
        //         },
        //       ],
        //       tradeMinimal: 1e-7,
        //     },
        //     sourceFee: 0.0000708253,
        //     status: "done",
        //     step: 4,
        //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
        //     targetAddress: "0x79109ab0bc2062624e9f8685ac5013911bf0985c",
        //     targetAmount: 0.02219746497434476,
        //     targetCurrency: {
        //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
        //       isAvailable: true,
        //       name: "Stratumblue",
        //       onlyAsset: false,
        //       precision: 6,
        //       symbol: "BLU",
        //       taxes: null,
        //       tradeMinimal: 2,
        //       withdrawMinimal: 0.01,
        //     },
        //     targetPrice: 0.16272531368415957,
        //     tokenStatus: "done",
        //     tokenStep: "steps_done",
        //     tokenTxid:
        //       "0xe8f450f065c5c5b7fbd9bc7811bc78c22cd07e7bdd81adccd870add697ccdd91",
        //     type: "purchase",
        //     updatedAt: "2022-03-04T18:30:26.868Z",
        //   },
        //   {
        //     createdAt: "2022-03-07T15:05:30.471Z",
        //     expiresIn: 7200000,
        //     id: "2ce23b4c-9e41-11ec-9940-37bb77382f49",
        //     insertTime: "0001-01-01T00:00:00.000Z",
        //     ip: "187.49.237.178",
        //     lastUpdate: "0001-01-01T00:00:00.000Z",
        //     memberId: "b118d17a-b411-11eb-9450-47e1e1615544",
        //     pinId: "00000000-0000-0000-0000-000000000000",
        //     settledAt: "0001-01-01T00:00:00.000Z",
        //     sourceAccountId: "c3b0db20-b411-11eb-a8c0-d792be390a4b",
        //     sourceAmount: 0.002,
        //     sourceCurrency: {
        //       id: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //       isAvailable: true,
        //       marketPercent: 22.5,
        //       name: "Bitcoin",
        //       onlyAsset: false,
        //       precision: 8,
        //       symbol: "BTC",
        //       taxes: [
        //         {
        //           bonusRefer: 1,
        //           charityReferred: 3,
        //           charitySimple: 1,
        //           createdAt: "2021-02-01T00:00:00.000Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "e52fa818-6aff-11eb-b00d-8ff92bf3258e",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.25,
        //           rewardAmbassador: 2.75,
        //           rewardReferred: 2,
        //           startAt: "2021-02-01T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusRefer: 1,
        //           charityReferred: 3,
        //           charitySimple: 1,
        //           createdAt: "2020-07-14T00:00:00.000Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "b520ae4a-d065-11ea-b9f2-ab57e2ffff62",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 2.4,
        //           rewardReferred: 2,
        //           startAt: "2020-07-14T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusRefer: 1,
        //           bonusReferrer: 1,
        //           charityReferred: 1,
        //           charitySimple: 3,
        //           createdAt: "2019-03-31T18:17:57.882Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "4f8c3baa-53e1-11e9-a9df-b77dd05ebe45",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 3,
        //           rewardReferred: 2,
        //           startAt: "2019-04-11T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusReferrer: 1,
        //           charityReferred: 1,
        //           charitySimple: 3,
        //           createdAt: "2019-06-19T01:14:00.371Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 0.0010000000474974513,
        //           id: "84fbc814-922f-11e9-9877-1fee431c43ef",
        //           math: "absolut",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 3,
        //           startAt: "2018-11-01T00:00:00.000Z",
        //           type: "redeem",
        //         },
        //       ],
        //       tradeMinimal: 0.002,
        //       withdrawMinimal: 0.02,
        //     },
        //     sourceFee: 0.00004,
        //     status: "done",
        //     step: 4,
        //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
        //     targetAddress: "1CFaRTSCmdvcBGZ1tDG8xV14hFXx11nHZJ",
        //     targetAmount: 0.18995459047257354,
        //     targetCurrency: {
        //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
        //       isAvailable: true,
        //       name: "Stratumblue",
        //       onlyAsset: false,
        //       precision: 6,
        //       symbol: "BLU",
        //       taxes: null,
        //       tradeMinimal: 2,
        //       withdrawMinimal: 0.01,
        //     },
        //     targetPrice: 0.010739408797254331,
        //     tokenStatus: "done",
        //     tokenStep: "steps_done",
        //     tokenTxid:
        //       "0x159e907e97513dbb7dde8232b09dd43285f1e50d14a8147c903f7aaa4b152751",
        //     type: "purchase",
        //     updatedAt: "2022-03-07T15:23:16.919Z",
        //   },
        //   {
        //     createdAt: "2022-03-04T18:10:41.769Z",
        //     expiresIn: 7200000,
        //     id: "8c7e54b2-9bff-11ec-8117-87b666c8a03e",
        //     insertTime: "0001-01-01T00:00:00.000Z",
        //     ip: "187.49.237.178",
        //     lastUpdate: "0001-01-01T00:00:00.000Z",
        //     memberId: "d0868c22-852c-11ec-99bb-6b710ca8c37e",
        //     pinId: "00000000-0000-0000-0000-000000000000",
        //     sellerId: "b118d17a-b411-11eb-9450-47e1e1615544",
        //     settledAt: "0001-01-01T00:00:00.000Z",
        //     sourceAccountId: "04389204-852d-11ec-8c07-2f53be981bd9",
        //     sourceCurrency: {
        //       id: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
        //       isAvailable: true,
        //       marketPercent: 22.5,
        //       name: "Ethereum",
        //       onlyAsset: false,
        //       precision: 8,
        //       symbol: "ETH",
        //       taxes: [
        //         {
        //           bonusRefer: 1,
        //           charityReferred: 3,
        //           charitySimple: 1,
        //           createdAt: "2021-02-01T00:00:00.000Z",
        //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "e53001f0-6aff-11eb-b011-e7f585edc40d",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.25,
        //           rewardAmbassador: 2.75,
        //           rewardReferred: 2,
        //           startAt: "2021-02-01T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusRefer: 1,
        //           bonusReferrer: 1,
        //           charityReferred: 1,
        //           charitySimple: 3,
        //           createdAt: "2019-08-01T16:37:25.014Z",
        //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "a47cb226-b47a-11e9-9d96-73a1ce6e16f1",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 3,
        //           rewardReferred: 2,
        //           startAt: "2019-03-16T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusReferrer: 1,
        //           charityReferred: 1,
        //           charitySimple: 3,
        //           createdAt: "2021-02-09T15:27:01.495Z",
        //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 0.002,
        //           id: "a47cc2ac-b47a-11e9-9d97-cbb9a5578da5",
        //           math: "absolut",
        //           revenue: 2,
        //           rewardAmbassador: 3,
        //           startAt: "2018-11-01T00:00:00.000Z",
        //           type: "redeem",
        //         },
        //       ],
        //       tradeMinimal: 1e-7,
        //     },
        //     status: "expired",
        //     step: 1,
        //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
        //     targetAddress: "0x5984ca9af2bb416fae50cb2c19e3d872badb21a4",
        //     targetCurrency: {
        //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
        //       isAvailable: true,
        //       name: "Stratumblue",
        //       onlyAsset: false,
        //       precision: 6,
        //       symbol: "BLU",
        //       taxes: null,
        //       tradeMinimal: 2,
        //       withdrawMinimal: 0.01,
        //     },
        //     targetPrice: 0.16294389571789933,
        //     type: "purchase",
        //     updatedAt: "2022-03-04T20:11:57.946Z",
        //   },
        //   {
        //     createdAt: "2022-03-04T18:10:45.512Z",
        //     expiresIn: 7200000,
        //     id: "8eb97fea-9bff-11ec-ab67-bf0f4aaed8c2",
        //     insertTime: "0001-01-01T00:00:00.000Z",
        //     ip: "187.49.237.178",
        //     lastUpdate: "0001-01-01T00:00:00.000Z",
        //     memberId: "d0868c22-852c-11ec-99bb-6b710ca8c37e",
        //     pinId: "00000000-0000-0000-0000-000000000000",
        //     sellerId: "b118d17a-b411-11eb-9450-47e1e1615544",
        //     settledAt: "0001-01-01T00:00:00.000Z",
        //     sourceAccountId: "04389204-852d-11ec-8c07-2f53be981bd9",
        //     sourceCurrency: {
        //       id: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
        //       isAvailable: true,
        //       marketPercent: 22.5,
        //       name: "Ethereum",
        //       onlyAsset: false,
        //       precision: 8,
        //       symbol: "ETH",
        //       taxes: [
        //         {
        //           bonusRefer: 1,
        //           charityReferred: 3,
        //           charitySimple: 1,
        //           createdAt: "2021-02-01T00:00:00.000Z",
        //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "e53001f0-6aff-11eb-b011-e7f585edc40d",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.25,
        //           rewardAmbassador: 2.75,
        //           rewardReferred: 2,
        //           startAt: "2021-02-01T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusRefer: 1,
        //           bonusReferrer: 1,
        //           charityReferred: 1,
        //           charitySimple: 3,
        //           createdAt: "2019-08-01T16:37:25.014Z",
        //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "a47cb226-b47a-11e9-9d96-73a1ce6e16f1",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 3,
        //           rewardReferred: 2,
        //           startAt: "2019-03-16T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusReferrer: 1,
        //           charityReferred: 1,
        //           charitySimple: 3,
        //           createdAt: "2021-02-09T15:27:01.495Z",
        //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 0.002,
        //           id: "a47cc2ac-b47a-11e9-9d97-cbb9a5578da5",
        //           math: "absolut",
        //           revenue: 2,
        //           rewardAmbassador: 3,
        //           startAt: "2018-11-01T00:00:00.000Z",
        //           type: "redeem",
        //         },
        //       ],
        //       tradeMinimal: 1e-7,
        //     },
        //     status: "expired",
        //     step: 1,
        //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
        //     targetAddress: "0xcda2a4350373262d6728936b01e1c297a4df3399",
        //     targetCurrency: {
        //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
        //       isAvailable: true,
        //       name: "Stratumblue",
        //       onlyAsset: false,
        //       precision: 6,
        //       symbol: "BLU",
        //       taxes: null,
        //       tradeMinimal: 2,
        //       withdrawMinimal: 0.01,
        //     },
        //     targetPrice: 0.16294389571789933,
        //     type: "purchase",
        //     updatedAt: "2022-03-04T20:11:54.034Z",
        //   },
        //   {
        //     createdAt: "2022-03-07T15:30:14.109Z",
        //     expiresIn: 7200000,
        //     id: "a1337684-9e44-11ec-96cf-af86fec21b1f",
        //     insertTime: "0001-01-01T00:00:00.000Z",
        //     ip: "187.49.237.178",
        //     lastUpdate: "0001-01-01T00:00:00.000Z",
        //     memberId: "daf65e90-4336-11ec-bb8f-cf793e3db15a",
        //     pinId: "00000000-0000-0000-0000-000000000000",
        //     sellerId: "b118d17a-b411-11eb-9450-47e1e1615544",
        //     settledAt: "0001-01-01T00:00:00.000Z",
        //     sourceAccountId: "e3f60928-4336-11ec-a1e4-8fe66e6e8235",
        //     sourceCurrency: {
        //       id: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //       isAvailable: true,
        //       marketPercent: 22.5,
        //       name: "Bitcoin",
        //       onlyAsset: false,
        //       precision: 8,
        //       symbol: "BTC",
        //       taxes: [
        //         {
        //           bonusRefer: 1,
        //           charityReferred: 3,
        //           charitySimple: 1,
        //           createdAt: "2021-02-01T00:00:00.000Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "e52fa818-6aff-11eb-b00d-8ff92bf3258e",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.25,
        //           rewardAmbassador: 2.75,
        //           rewardReferred: 2,
        //           startAt: "2021-02-01T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusRefer: 1,
        //           charityReferred: 3,
        //           charitySimple: 1,
        //           createdAt: "2020-07-14T00:00:00.000Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "b520ae4a-d065-11ea-b9f2-ab57e2ffff62",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 2.4,
        //           rewardReferred: 2,
        //           startAt: "2020-07-14T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusRefer: 1,
        //           bonusReferrer: 1,
        //           charityReferred: 1,
        //           charitySimple: 3,
        //           createdAt: "2019-03-31T18:17:57.882Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "4f8c3baa-53e1-11e9-a9df-b77dd05ebe45",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 3,
        //           rewardReferred: 2,
        //           startAt: "2019-04-11T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusReferrer: 1,
        //           charityReferred: 1,
        //           charitySimple: 3,
        //           createdAt: "2019-06-19T01:14:00.371Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 0.0010000000474974513,
        //           id: "84fbc814-922f-11e9-9877-1fee431c43ef",
        //           math: "absolut",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 3,
        //           startAt: "2018-11-01T00:00:00.000Z",
        //           type: "redeem",
        //         },
        //       ],
        //       tradeMinimal: 0.002,
        //       withdrawMinimal: 0.02,
        //     },
        //     status: "expired",
        //     step: 1,
        //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
        //     targetAddress: "18fk3cqJEMsoaGnHNww1NeSTHVrbfA28cj",
        //     targetCurrency: {
        //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
        //       isAvailable: true,
        //       name: "Stratumblue",
        //       onlyAsset: false,
        //       precision: 6,
        //       symbol: "BLU",
        //       taxes: null,
        //       tradeMinimal: 2,
        //       withdrawMinimal: 0.01,
        //     },
        //     targetPrice: 0.010715786027751698,
        //     type: "purchase",
        //     updatedAt: "2022-03-07T15:33:00.195Z",
        //   },
        //   {
        //     createdAt: "2022-03-07T15:32:26.850Z",
        //     expiresIn: 7200000,
        //     id: "f0520fd2-9e44-11ec-9216-efc45a12ccf2",
        //     insertTime: "0001-01-01T00:00:00.000Z",
        //     ip: "187.49.237.178",
        //     lastUpdate: "0001-01-01T00:00:00.000Z",
        //     memberId: "daf65e90-4336-11ec-bb8f-cf793e3db15a",
        //     pinId: "00000000-0000-0000-0000-000000000000",
        //     sellerId: "b118d17a-b411-11eb-9450-47e1e1615544",
        //     settledAt: "0001-01-01T00:00:00.000Z",
        //     sourceAccountId: "e3f60928-4336-11ec-a1e4-8fe66e6e8235",
        //     sourceAmount: 0.002,
        //     sourceCurrency: {
        //       id: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //       isAvailable: true,
        //       marketPercent: 22.5,
        //       name: "Bitcoin",
        //       onlyAsset: false,
        //       precision: 8,
        //       symbol: "BTC",
        //       taxes: [
        //         {
        //           bonusRefer: 1,
        //           charityReferred: 3,
        //           charitySimple: 1,
        //           createdAt: "2021-02-01T00:00:00.000Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "e52fa818-6aff-11eb-b00d-8ff92bf3258e",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.25,
        //           rewardAmbassador: 2.75,
        //           rewardReferred: 2,
        //           startAt: "2021-02-01T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusRefer: 1,
        //           charityReferred: 3,
        //           charitySimple: 1,
        //           createdAt: "2020-07-14T00:00:00.000Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "b520ae4a-d065-11ea-b9f2-ab57e2ffff62",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 2.4,
        //           rewardReferred: 2,
        //           startAt: "2020-07-14T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusRefer: 1,
        //           bonusReferrer: 1,
        //           charityReferred: 1,
        //           charitySimple: 3,
        //           createdAt: "2019-03-31T18:17:57.882Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "4f8c3baa-53e1-11e9-a9df-b77dd05ebe45",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 3,
        //           rewardReferred: 2,
        //           startAt: "2019-04-11T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusReferrer: 1,
        //           charityReferred: 1,
        //           charitySimple: 3,
        //           createdAt: "2019-06-19T01:14:00.371Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 0.0010000000474974513,
        //           id: "84fbc814-922f-11e9-9877-1fee431c43ef",
        //           math: "absolut",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 3,
        //           startAt: "2018-11-01T00:00:00.000Z",
        //           type: "redeem",
        //         },
        //       ],
        //       tradeMinimal: 0.002,
        //       withdrawMinimal: 0.02,
        //     },
        //     sourceFee: 0.00004,
        //     status: "done",
        //     step: 4,
        //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
        //     targetAddress: "18fk3cqJEMsoaGnHNww1NeSTHVrbfA28cj",
        //     targetAmount: 0.19057815344551501,
        //     targetCurrency: {
        //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
        //       isAvailable: true,
        //       name: "Stratumblue",
        //       onlyAsset: false,
        //       precision: 6,
        //       symbol: "BLU",
        //       taxes: null,
        //       tradeMinimal: 2,
        //       withdrawMinimal: 0.01,
        //     },
        //     targetPrice: 0.010704269944473054,
        //     tokenStatus: "done",
        //     tokenStep: "steps_done",
        //     tokenTxid:
        //       "0x8d755cef4ba4186230f437661b5e929f050740519adf1dad9e4aad8418a6e0aa",
        //     type: "purchase",
        //     updatedAt: "2022-03-07T15:35:34.406Z",
        //   },
        //   {
        //     createdAt: "2022-03-07T16:25:36.146Z",
        //     expiresIn: 7200000,
        //     id: "5d49e2a2-9e4c-11ec-bd9c-9713c1f5efa9",
        //     insertTime: "0001-01-01T00:00:00.000Z",
        //     ip: "187.49.237.178",
        //     lastUpdate: "0001-01-01T00:00:00.000Z",
        //     memberId: "8c5d50f8-43e6-11ec-916b-5b4b67b11c32",
        //     pinId: "00000000-0000-0000-0000-000000000000",
        //     sellerId: "b118d17a-b411-11eb-9450-47e1e1615544",
        //     settled: true,
        //     settledAt: "2022-03-08T09:56:00.219Z",
        //     sourceAccountId: "98f35876-43e6-11ec-8965-1b0530cda71a",
        //     sourceAmount: 0.0020188679245283017,
        //     sourceCurrency: {
        //       id: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //       isAvailable: true,
        //       marketPercent: 22.5,
        //       name: "Bitcoin",
        //       onlyAsset: false,
        //       precision: 8,
        //       symbol: "BTC",
        //       taxes: [
        //         {
        //           bonusRefer: 1,
        //           charityReferred: 3,
        //           charitySimple: 1,
        //           createdAt: "2021-02-01T00:00:00.000Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "e52fa818-6aff-11eb-b00d-8ff92bf3258e",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.25,
        //           rewardAmbassador: 2.75,
        //           rewardReferred: 2,
        //           startAt: "2021-02-01T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusRefer: 1,
        //           charityReferred: 3,
        //           charitySimple: 1,
        //           createdAt: "2020-07-14T00:00:00.000Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "b520ae4a-d065-11ea-b9f2-ab57e2ffff62",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 2.4,
        //           rewardReferred: 2,
        //           startAt: "2020-07-14T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusRefer: 1,
        //           bonusReferrer: 1,
        //           charityReferred: 1,
        //           charitySimple: 3,
        //           createdAt: "2019-03-31T18:17:57.882Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "4f8c3baa-53e1-11e9-a9df-b77dd05ebe45",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 3,
        //           rewardReferred: 2,
        //           startAt: "2019-04-11T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusReferrer: 1,
        //           charityReferred: 1,
        //           charitySimple: 3,
        //           createdAt: "2019-06-19T01:14:00.371Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 0.0010000000474974513,
        //           id: "84fbc814-922f-11e9-9877-1fee431c43ef",
        //           math: "absolut",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 3,
        //           startAt: "2018-11-01T00:00:00.000Z",
        //           type: "redeem",
        //         },
        //       ],
        //       tradeMinimal: 0.002,
        //       withdrawMinimal: 0.02,
        //     },
        //     sourceFee: 0.0000403774,
        //     status: "done",
        //     step: 4,
        //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
        //     targetAddress: "1Q7VTVWaoc4RYjmhYtvgs7BNrNAbq6Y3vU",
        //     targetAmount: 0.19248025178257636,
        //     targetCurrency: {
        //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
        //       isAvailable: true,
        //       name: "Stratumblue",
        //       onlyAsset: false,
        //       precision: 6,
        //       symbol: "BLU",
        //       taxes: null,
        //       tradeMinimal: 2,
        //       withdrawMinimal: 0.01,
        //     },
        //     targetPrice: 0.01069847584600213,
        //     tokenStatus: "done",
        //     tokenStep: "steps_done",
        //     tokenTxid:
        //       "0x02c491093f6e0c88f413f37706a7318e45aaeee3774fbfb6011324ad34bee350",
        //     type: "purchase",
        //     updatedAt: "2022-03-07T16:29:52.290Z",
        //   },
        //   {
        //     createdAt: "2022-03-08T13:50:36.500Z",
        //     expiresIn: 7200000,
        //     id: "e0ae9ed6-9eff-11ec-8c75-a7d63c98340c",
        //     insertTime: "0001-01-01T00:00:00.000Z",
        //     ip: "187.49.237.178",
        //     lastUpdate: "0001-01-01T00:00:00.000Z",
        //     memberId: "b118d17a-b411-11eb-9450-47e1e1615544",
        //     pinId: "00000000-0000-0000-0000-000000000000",
        //     settled: true,
        //     settledAt: "2022-03-08T16:50:59.878Z",
        //     sourceAccountId: "c3d2a25a-b411-11eb-bbe9-17219b0ca111",
        //     sourceAmount: 0.02830188679245283,
        //     sourceCurrency: {
        //       id: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
        //       isAvailable: true,
        //       marketPercent: 22.5,
        //       name: "Ethereum",
        //       onlyAsset: false,
        //       precision: 8,
        //       symbol: "ETH",
        //       taxes: [
        //         {
        //           bonusRefer: 1,
        //           charityReferred: 3,
        //           charitySimple: 1,
        //           createdAt: "2021-02-01T00:00:00.000Z",
        //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "e53001f0-6aff-11eb-b011-e7f585edc40d",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.25,
        //           rewardAmbassador: 2.75,
        //           rewardReferred: 2,
        //           startAt: "2021-02-01T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusRefer: 1,
        //           bonusReferrer: 1,
        //           charityReferred: 1,
        //           charitySimple: 3,
        //           createdAt: "2019-08-01T16:37:25.014Z",
        //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "a47cb226-b47a-11e9-9d96-73a1ce6e16f1",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 3,
        //           rewardReferred: 2,
        //           startAt: "2019-03-16T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusReferrer: 1,
        //           charityReferred: 1,
        //           charitySimple: 3,
        //           createdAt: "2021-02-09T15:27:01.495Z",
        //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 0.002,
        //           id: "a47cc2ac-b47a-11e9-9d97-cbb9a5578da5",
        //           math: "absolut",
        //           revenue: 2,
        //           rewardAmbassador: 3,
        //           startAt: "2018-11-01T00:00:00.000Z",
        //           type: "redeem",
        //         },
        //       ],
        //       tradeMinimal: 1e-7,
        //     },
        //     sourceFee: 0.0005660377,
        //     status: "done",
        //     step: 4,
        //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
        //     targetAddress: "0xcda2a4350373262d6728936b01e1c297a4df3399",
        //     targetAmount: 0.17913173802423613,
        //     targetCurrency: {
        //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
        //       isAvailable: true,
        //       name: "Stratumblue",
        //       onlyAsset: false,
        //       precision: 6,
        //       symbol: "BLU",
        //       taxes: null,
        //       tradeMinimal: 2,
        //       withdrawMinimal: 0.01,
        //     },
        //     targetPrice: 0.16115471669541365,
        //     tokenStatus: "done",
        //     tokenStep: "steps_done",
        //     tokenTxid:
        //       "0xf90c6b51a4569d32dd853a4c1f9537ea0d179dca89d47d9e9911ab502f098487",
        //     type: "purchase",
        //     updatedAt: "2022-03-08T13:55:56.044Z",
        //   },
        //   {
        //     createdAt: "2022-03-08T14:04:47.630Z",
        //     expiresIn: 7200000,
        //     id: "dbfe555a-9f01-11ec-ad32-ff8ff7f58250",
        //     insertTime: "0001-01-01T00:00:00.000Z",
        //     ip: "187.49.237.178",
        //     lastUpdate: "0001-01-01T00:00:00.000Z",
        //     memberId: "64295ab8-1b7b-11ea-9d70-9ba1b056b4f5",
        //     pinId: "00000000-0000-0000-0000-000000000000",
        //     sellerId: "b118d17a-b411-11eb-9450-47e1e1615544",
        //     settledAt: "0001-01-01T00:00:00.000Z",
        //     sourceAccountId: "cb9b6c04-1b7b-11ea-9d72-7b7a61a5f57a",
        //     sourceCurrency: {
        //       id: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
        //       isAvailable: true,
        //       marketPercent: 22.5,
        //       name: "Ethereum",
        //       onlyAsset: false,
        //       precision: 8,
        //       symbol: "ETH",
        //       taxes: [
        //         {
        //           bonusRefer: 1,
        //           charityReferred: 3,
        //           charitySimple: 1,
        //           createdAt: "2021-02-01T00:00:00.000Z",
        //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "e53001f0-6aff-11eb-b011-e7f585edc40d",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.25,
        //           rewardAmbassador: 2.75,
        //           rewardReferred: 2,
        //           startAt: "2021-02-01T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusRefer: 1,
        //           bonusReferrer: 1,
        //           charityReferred: 1,
        //           charitySimple: 3,
        //           createdAt: "2019-08-01T16:37:25.014Z",
        //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "a47cb226-b47a-11e9-9d96-73a1ce6e16f1",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 3,
        //           rewardReferred: 2,
        //           startAt: "2019-03-16T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusReferrer: 1,
        //           charityReferred: 1,
        //           charitySimple: 3,
        //           createdAt: "2021-02-09T15:27:01.495Z",
        //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 0.002,
        //           id: "a47cc2ac-b47a-11e9-9d97-cbb9a5578da5",
        //           math: "absolut",
        //           revenue: 2,
        //           rewardAmbassador: 3,
        //           startAt: "2018-11-01T00:00:00.000Z",
        //           type: "redeem",
        //         },
        //       ],
        //       tradeMinimal: 1e-7,
        //     },
        //     status: "expired",
        //     step: 1,
        //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
        //     targetAddress: "0xcda2a4350373262d6728936b01e1c297a4df3399",
        //     targetCurrency: {
        //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
        //       isAvailable: true,
        //       name: "Stratumblue",
        //       onlyAsset: false,
        //       precision: 6,
        //       symbol: "BLU",
        //       taxes: null,
        //       tradeMinimal: 2,
        //       withdrawMinimal: 0.01,
        //     },
        //     targetPrice: 0.16044588000319096,
        //     type: "purchase",
        //     updatedAt: "2022-03-08T14:06:14.298Z",
        //   },
        //   {
        //     createdAt: "2022-03-08T14:05:36.112Z",
        //     expiresIn: 7200000,
        //     id: "f8e40732-9f01-11ec-8cea-9b31dbceceb4",
        //     insertTime: "0001-01-01T00:00:00.000Z",
        //     ip: "187.49.237.178",
        //     lastUpdate: "0001-01-01T00:00:00.000Z",
        //     memberId: "64295ab8-1b7b-11ea-9d70-9ba1b056b4f5",
        //     pinId: "00000000-0000-0000-0000-000000000000",
        //     sellerId: "b118d17a-b411-11eb-9450-47e1e1615544",
        //     settled: true,
        //     settledAt: "2022-03-08T16:50:59.855Z",
        //     sourceAccountId: "cb6b3c5a-1b7b-11ea-a7bf-6311c9c3df90",
        //     sourceAmount: 0.0028301886792452833,
        //     sourceCurrency: {
        //       id: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //       isAvailable: true,
        //       marketPercent: 22.5,
        //       name: "Bitcoin",
        //       onlyAsset: false,
        //       precision: 8,
        //       symbol: "BTC",
        //       taxes: [
        //         {
        //           bonusRefer: 1,
        //           charityReferred: 3,
        //           charitySimple: 1,
        //           createdAt: "2021-02-01T00:00:00.000Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "e52fa818-6aff-11eb-b00d-8ff92bf3258e",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.25,
        //           rewardAmbassador: 2.75,
        //           rewardReferred: 2,
        //           startAt: "2021-02-01T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusRefer: 1,
        //           charityReferred: 3,
        //           charitySimple: 1,
        //           createdAt: "2020-07-14T00:00:00.000Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "b520ae4a-d065-11ea-b9f2-ab57e2ffff62",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 2.4,
        //           rewardReferred: 2,
        //           startAt: "2020-07-14T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusRefer: 1,
        //           bonusReferrer: 1,
        //           charityReferred: 1,
        //           charitySimple: 3,
        //           createdAt: "2019-03-31T18:17:57.882Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "4f8c3baa-53e1-11e9-a9df-b77dd05ebe45",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 3,
        //           rewardReferred: 2,
        //           startAt: "2019-04-11T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusReferrer: 1,
        //           charityReferred: 1,
        //           charitySimple: 3,
        //           createdAt: "2019-06-19T01:14:00.371Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 0.0010000000474974513,
        //           id: "84fbc814-922f-11e9-9877-1fee431c43ef",
        //           math: "absolut",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 3,
        //           startAt: "2018-11-01T00:00:00.000Z",
        //           type: "redeem",
        //         },
        //       ],
        //       tradeMinimal: 0.002,
        //       withdrawMinimal: 0.02,
        //     },
        //     sourceFee: 0.0000566038,
        //     status: "done",
        //     step: 4,
        //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
        //     targetAddress: "1DiSXSs5CTLzKHo8gNjitD93pRBRm617p",
        //     targetAmount: 0.27057970787361457,
        //     targetCurrency: {
        //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
        //       isAvailable: true,
        //       name: "Stratumblue",
        //       onlyAsset: false,
        //       precision: 6,
        //       symbol: "BLU",
        //       taxes: null,
        //       tradeMinimal: 2,
        //       withdrawMinimal: 0.01,
        //     },
        //     targetPrice: 0.010668917125868429,
        //     tokenStatus: "done",
        //     tokenStep: "steps_done",
        //     tokenTxid:
        //       "0xd04ca8b2958a401d9c9a1d0b401515bb1c23a0a53cf3ea070ecbad3d08a36bd8",
        //     type: "purchase",
        //     updatedAt: "2022-03-08T14:09:15.824Z",
        //   },
        //   {
        //     createdAt: "2022-03-08T14:18:40.603Z",
        //     expiresIn: 7200000,
        //     id: "cc7bdb3c-9f03-11ec-88f8-43db0310eda5",
        //     insertTime: "0001-01-01T00:00:00.000Z",
        //     ip: "187.49.237.178",
        //     lastUpdate: "0001-01-01T00:00:00.000Z",
        //     memberId: "404f1146-a6c1-11eb-952b-67d61dfa915c",
        //     pinId: "00000000-0000-0000-0000-000000000000",
        //     sellerId: "b118d17a-b411-11eb-9450-47e1e1615544",
        //     settledAt: "0001-01-01T00:00:00.000Z",
        //     sourceAccountId: "48fa41bc-a6c1-11eb-b559-cb2fe2effb5e",
        //     sourceCurrency: {
        //       id: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //       isAvailable: true,
        //       marketPercent: 22.5,
        //       name: "Bitcoin",
        //       onlyAsset: false,
        //       precision: 8,
        //       symbol: "BTC",
        //       taxes: [
        //         {
        //           bonusRefer: 1,
        //           charityReferred: 3,
        //           charitySimple: 1,
        //           createdAt: "2021-02-01T00:00:00.000Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "e52fa818-6aff-11eb-b00d-8ff92bf3258e",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.25,
        //           rewardAmbassador: 2.75,
        //           rewardReferred: 2,
        //           startAt: "2021-02-01T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusRefer: 1,
        //           charityReferred: 3,
        //           charitySimple: 1,
        //           createdAt: "2020-07-14T00:00:00.000Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "b520ae4a-d065-11ea-b9f2-ab57e2ffff62",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 2.4,
        //           rewardReferred: 2,
        //           startAt: "2020-07-14T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusRefer: 1,
        //           bonusReferrer: 1,
        //           charityReferred: 1,
        //           charitySimple: 3,
        //           createdAt: "2019-03-31T18:17:57.882Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "4f8c3baa-53e1-11e9-a9df-b77dd05ebe45",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 3,
        //           rewardReferred: 2,
        //           startAt: "2019-04-11T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusReferrer: 1,
        //           charityReferred: 1,
        //           charitySimple: 3,
        //           createdAt: "2019-06-19T01:14:00.371Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 0.0010000000474974513,
        //           id: "84fbc814-922f-11e9-9877-1fee431c43ef",
        //           math: "absolut",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 3,
        //           startAt: "2018-11-01T00:00:00.000Z",
        //           type: "redeem",
        //         },
        //       ],
        //       tradeMinimal: 0.002,
        //       withdrawMinimal: 0.02,
        //     },
        //     status: "expired",
        //     step: 1,
        //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
        //     targetAddress: "1BujobWrgiBDxLyvCey1VfeVGABatSQG76",
        //     targetCurrency: {
        //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
        //       isAvailable: true,
        //       name: "Stratumblue",
        //       onlyAsset: false,
        //       precision: 6,
        //       symbol: "BLU",
        //       taxes: null,
        //       tradeMinimal: 2,
        //       withdrawMinimal: 0.01,
        //     },
        //     targetPrice: 0.010669242247409063,
        //     type: "purchase",
        //     updatedAt: "2022-03-08T14:20:25.437Z",
        //   },
        //   {
        //     createdAt: "2022-03-08T14:20:17.680Z",
        //     expiresIn: 7200000,
        //     id: "06589d90-9f04-11ec-9269-974673111050",
        //     insertTime: "0001-01-01T00:00:00.000Z",
        //     ip: "187.49.237.178",
        //     lastUpdate: "0001-01-01T00:00:00.000Z",
        //     memberId: "404f1146-a6c1-11eb-952b-67d61dfa915c",
        //     pinId: "00000000-0000-0000-0000-000000000000",
        //     sellerId: "b118d17a-b411-11eb-9450-47e1e1615544",
        //     settled: true,
        //     settledAt: "2022-03-08T16:50:59.832Z",
        //     sourceAccountId: "496790aa-a6c1-11eb-b320-bb3daaad15cb",
        //     sourceAmount: 0.01905238679245283,
        //     sourceCurrency: {
        //       id: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
        //       isAvailable: true,
        //       marketPercent: 22.5,
        //       name: "Ethereum",
        //       onlyAsset: false,
        //       precision: 8,
        //       symbol: "ETH",
        //       taxes: [
        //         {
        //           bonusRefer: 1,
        //           charityReferred: 3,
        //           charitySimple: 1,
        //           createdAt: "2021-02-01T00:00:00.000Z",
        //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "e53001f0-6aff-11eb-b011-e7f585edc40d",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.25,
        //           rewardAmbassador: 2.75,
        //           rewardReferred: 2,
        //           startAt: "2021-02-01T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusRefer: 1,
        //           bonusReferrer: 1,
        //           charityReferred: 1,
        //           charitySimple: 3,
        //           createdAt: "2019-08-01T16:37:25.014Z",
        //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "a47cb226-b47a-11e9-9d96-73a1ce6e16f1",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 3,
        //           rewardReferred: 2,
        //           startAt: "2019-03-16T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusReferrer: 1,
        //           charityReferred: 1,
        //           charitySimple: 3,
        //           createdAt: "2021-02-09T15:27:01.495Z",
        //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 0.002,
        //           id: "a47cc2ac-b47a-11e9-9d97-cbb9a5578da5",
        //           math: "absolut",
        //           revenue: 2,
        //           rewardAmbassador: 3,
        //           startAt: "2018-11-01T00:00:00.000Z",
        //           type: "redeem",
        //         },
        //       ],
        //       tradeMinimal: 1e-7,
        //     },
        //     sourceFee: 0.0003810477,
        //     status: "done",
        //     step: 4,
        //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
        //     targetAddress: "0xcd8d921f32462a2c0064c543117e606474581b6f",
        //     targetAmount: 0.12161981705516148,
        //     targetCurrency: {
        //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
        //       isAvailable: true,
        //       name: "Stratumblue",
        //       onlyAsset: false,
        //       precision: 6,
        //       symbol: "BLU",
        //       taxes: null,
        //       tradeMinimal: 2,
        //       withdrawMinimal: 0.01,
        //     },
        //     targetPrice: 0.15978838780557175,
        //     tokenStatus: "done",
        //     tokenStep: "steps_done",
        //     tokenTxid:
        //       "0x0a30da8b9c213e5f67203e84d918b7ea524250cc48e2478abd0842609af2a810",
        //     type: "purchase",
        //     updatedAt: "2022-03-08T14:25:37.073Z",
        //   },
        //   {
        //     createdAt: "2022-03-08T15:26:11.414Z",
        //     expiresIn: 7200000,
        //     id: "3af490dc-9f0d-11ec-ac4d-2f8bdc393802",
        //     insertTime: "0001-01-01T00:00:00.000Z",
        //     ip: "187.49.237.178",
        //     lastUpdate: "0001-01-01T00:00:00.000Z",
        //     memberId: "b118d17a-b411-11eb-9450-47e1e1615544",
        //     pinId: "00000000-0000-0000-0000-000000000000",
        //     settled: true,
        //     settledAt: "2022-03-08T16:50:59.809Z",
        //     sourceAccountId: "c3b0db20-b411-11eb-a8c0-d792be390a4b",
        //     sourceAmount: 0.0010588235294117646,
        //     sourceCurrency: {
        //       id: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //       isAvailable: true,
        //       marketPercent: 22.5,
        //       name: "Bitcoin",
        //       onlyAsset: false,
        //       precision: 8,
        //       symbol: "BTC",
        //       taxes: [
        //         {
        //           bonusRefer: 1,
        //           charityReferred: 3,
        //           charitySimple: 1,
        //           createdAt: "2021-02-01T00:00:00.000Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "e52fa818-6aff-11eb-b00d-8ff92bf3258e",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.25,
        //           rewardAmbassador: 2.75,
        //           rewardReferred: 2,
        //           startAt: "2021-02-01T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusRefer: 1,
        //           charityReferred: 3,
        //           charitySimple: 1,
        //           createdAt: "2020-07-14T00:00:00.000Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "b520ae4a-d065-11ea-b9f2-ab57e2ffff62",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 2.4,
        //           rewardReferred: 2,
        //           startAt: "2020-07-14T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusRefer: 1,
        //           bonusReferrer: 1,
        //           charityReferred: 1,
        //           charitySimple: 3,
        //           createdAt: "2019-03-31T18:17:57.882Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "4f8c3baa-53e1-11e9-a9df-b77dd05ebe45",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 3,
        //           rewardReferred: 2,
        //           startAt: "2019-04-11T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusReferrer: 1,
        //           charityReferred: 1,
        //           charitySimple: 3,
        //           createdAt: "2019-06-19T01:14:00.371Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 0.0010000000474974513,
        //           id: "84fbc814-922f-11e9-9877-1fee431c43ef",
        //           math: "absolut",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 3,
        //           startAt: "2018-11-01T00:00:00.000Z",
        //           type: "redeem",
        //         },
        //       ],
        //       tradeMinimal: 0.002,
        //       withdrawMinimal: 0.02,
        //     },
        //     sourceFee: 0.0000211765,
        //     status: "done",
        //     step: 4,
        //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
        //     targetAddress: "18fk3cqJEMsoaGnHNww1NeSTHVrbfA28cj",
        //     targetAmount: 0.10015962799097962,
        //     targetCurrency: {
        //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
        //       isAvailable: true,
        //       name: "Stratumblue",
        //       onlyAsset: false,
        //       precision: 6,
        //       symbol: "BLU",
        //       taxes: null,
        //       tradeMinimal: 2,
        //       withdrawMinimal: 0.01,
        //     },
        //     targetPrice: 0.0107827879463473,
        //     tokenStatus: "done",
        //     tokenStep: "steps_done",
        //     tokenTxid:
        //       "0xf9e2f08cdbbfd54cecea9f051b3d56caf4f893e20ca37ede6d9bcb6591ba7031",
        //     type: "purchase",
        //     updatedAt: "2022-03-08T15:35:56.779Z",
        //   },
        //   {
        //     createdAt: "2022-03-09T17:14:16.694Z",
        //     expiresIn: 7200000,
        //     id: "7ee5a046-9fe5-11ec-9a33-b3b773af548b",
        //     insertTime: "0001-01-01T00:00:00.000Z",
        //     ip: "187.49.237.178",
        //     lastUpdate: "0001-01-01T00:00:00.000Z",
        //     memberId: "b118d17a-b411-11eb-9450-47e1e1615544",
        //     pinId: "00000000-0000-0000-0000-000000000000",
        //     settledAt: "0001-01-01T00:00:00.000Z",
        //     sourceAccountId: "c3d2a25a-b411-11eb-bbe9-17219b0ca111",
        //     sourceAmount: 0.02071772549019608,
        //     sourceCurrency: {
        //       id: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
        //       isAvailable: true,
        //       marketPercent: 22.5,
        //       name: "Ethereum",
        //       onlyAsset: false,
        //       precision: 8,
        //       symbol: "ETH",
        //       taxes: [
        //         {
        //           bonusRefer: 1,
        //           charityReferred: 3,
        //           charitySimple: 1,
        //           createdAt: "2021-02-01T00:00:00.000Z",
        //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "e53001f0-6aff-11eb-b011-e7f585edc40d",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.25,
        //           rewardAmbassador: 2.75,
        //           rewardReferred: 2,
        //           startAt: "2021-02-01T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusRefer: 1,
        //           bonusReferrer: 1,
        //           charityReferred: 1,
        //           charitySimple: 3,
        //           createdAt: "2019-08-01T16:37:25.014Z",
        //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "a47cb226-b47a-11e9-9d96-73a1ce6e16f1",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 3,
        //           rewardReferred: 2,
        //           startAt: "2019-03-16T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusReferrer: 1,
        //           charityReferred: 1,
        //           charitySimple: 3,
        //           createdAt: "2021-02-09T15:27:01.495Z",
        //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 0.002,
        //           id: "a47cc2ac-b47a-11e9-9d97-cbb9a5578da5",
        //           math: "absolut",
        //           revenue: 2,
        //           rewardAmbassador: 3,
        //           startAt: "2018-11-01T00:00:00.000Z",
        //           type: "redeem",
        //         },
        //       ],
        //       tradeMinimal: 1e-7,
        //     },
        //     sourceFee: 0.0004143545,
        //     status: "done",
        //     step: 4,
        //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
        //     targetAddress: "0x5984ca9af2bb416fae50cb2c19e3d872badb21a4",
        //     targetAmount: 0.12826366177861961,
        //     targetCurrency: {
        //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
        //       isAvailable: true,
        //       name: "Stratumblue",
        //       onlyAsset: false,
        //       precision: 6,
        //       symbol: "BLU",
        //       taxes: null,
        //       tradeMinimal: 2,
        //       withdrawMinimal: 0.01,
        //     },
        //     targetPrice: 0.16475500307070295,
        //     tokenStatus: "done",
        //     tokenStep: "steps_done",
        //     tokenTxid:
        //       "0xbb63f34d8d3c00398594aa36ccb78ba691bd1864cd1f0ee6538a1c9c9681d395",
        //     type: "purchase",
        //     updatedAt: "2022-03-09T17:17:47.312Z",
        //   },
        //   {
        //     createdAt: "2022-03-09T18:19:12.465Z",
        //     expiresIn: 7200000,
        //     id: "90f53e28-9fee-11ec-978e-5745c9b0b774",
        //     insertTime: "0001-01-01T00:00:00.000Z",
        //     ip: "187.49.237.178",
        //     lastUpdate: "0001-01-01T00:00:00.000Z",
        //     memberId: "daf65e90-4336-11ec-bb8f-cf793e3db15a",
        //     pinId: "00000000-0000-0000-0000-000000000000",
        //     sellerId: "b118d17a-b411-11eb-9450-47e1e1615544",
        //     settled: true,
        //     settledAt: "2022-03-09T20:27:57.282Z",
        //     sourceAccountId: "e41ca790-4336-11ec-a15b-6f3fa2f6a17d",
        //     sourceAmount: 0.019746725490196078,
        //     sourceCurrency: {
        //       id: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
        //       isAvailable: true,
        //       marketPercent: 22.5,
        //       name: "Ethereum",
        //       onlyAsset: false,
        //       precision: 8,
        //       symbol: "ETH",
        //       taxes: [
        //         {
        //           bonusRefer: 1,
        //           charityReferred: 3,
        //           charitySimple: 1,
        //           createdAt: "2021-02-01T00:00:00.000Z",
        //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "e53001f0-6aff-11eb-b011-e7f585edc40d",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.25,
        //           rewardAmbassador: 2.75,
        //           rewardReferred: 2,
        //           startAt: "2021-02-01T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusRefer: 1,
        //           bonusReferrer: 1,
        //           charityReferred: 1,
        //           charitySimple: 3,
        //           createdAt: "2019-08-01T16:37:25.014Z",
        //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "a47cb226-b47a-11e9-9d96-73a1ce6e16f1",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 3,
        //           rewardReferred: 2,
        //           startAt: "2019-03-16T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusReferrer: 1,
        //           charityReferred: 1,
        //           charitySimple: 3,
        //           createdAt: "2021-02-09T15:27:01.495Z",
        //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 0.002,
        //           id: "a47cc2ac-b47a-11e9-9d97-cbb9a5578da5",
        //           math: "absolut",
        //           revenue: 2,
        //           rewardAmbassador: 3,
        //           startAt: "2018-11-01T00:00:00.000Z",
        //           type: "redeem",
        //         },
        //       ],
        //       tradeMinimal: 1e-7,
        //     },
        //     sourceFee: 0.0003949345,
        //     status: "done",
        //     step: 4,
        //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
        //     targetAddress: "0x452d598056aa21c9388ee7543536fd9cd853cc9c",
        //     targetAmount: 0.12212344107997931,
        //     targetCurrency: {
        //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
        //       isAvailable: true,
        //       name: "Stratumblue",
        //       onlyAsset: false,
        //       precision: 6,
        //       symbol: "BLU",
        //       taxes: null,
        //       tradeMinimal: 2,
        //       withdrawMinimal: 0.01,
        //     },
        //     targetPrice: 0.16492869683392883,
        //     tokenStatus: "done",
        //     tokenStep: "steps_done",
        //     tokenTxid:
        //       "0xf9f38be161ef77db26cecee029894792bd6109bf7bedf930f1fa360160c64f71",
        //     type: "purchase",
        //     updatedAt: "2022-03-09T18:22:17.057Z",
        //   },
        //   {
        //     createdAt: "2022-03-09T19:08:42.196Z",
        //     expiresIn: 7200000,
        //     id: "7b0e5412-9ff5-11ec-a24a-d71fe968c3a5",
        //     insertTime: "0001-01-01T00:00:00.000Z",
        //     ip: "187.49.237.178",
        //     lastUpdate: "0001-01-01T00:00:00.000Z",
        //     memberId: "b118d17a-b411-11eb-9450-47e1e1615544",
        //     pinId: "00000000-0000-0000-0000-000000000000",
        //     settledAt: "0001-01-01T00:00:00.000Z",
        //     sourceAccountId: "a1add374-e32e-11eb-8160-d79ba51bf6fd",
        //     sourceCurrency: {
        //       id: "1820a89a-0745-11eb-9412-6ffc5759940f",
        //       isAvailable: true,
        //       name: "Tether",
        //       onlyAsset: false,
        //       precision: 8,
        //       symbol: "USDT",
        //       taxes: [
        //         {
        //           createdAt: "2022-02-01T12:12:40.394Z",
        //           currencyId: "1820a89a-0745-11eb-9412-6ffc5759940f",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 50,
        //           id: "407d59ce-8358-11ec-b72f-0b95b1c736fd",
        //           math: "absolut",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 3,
        //           startAt: "2022-01-30T00:00:00.000Z",
        //           type: "redeem",
        //         },
        //         {
        //           createdAt: "2022-02-01T12:12:40.394Z",
        //           currencyId: "1820a89a-0745-11eb-9412-6ffc5759940f",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 100,
        //           id: "407d530c-8358-11ec-b72e-775b917068b1",
        //           math: "rush",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 3,
        //           startAt: "2022-01-30T00:00:00.000Z",
        //           type: "redeem",
        //         },
        //         {
        //           createdAt: "2022-02-01T12:12:40.394Z",
        //           currencyId: "1820a89a-0745-11eb-9412-6ffc5759940f",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 1,
        //           id: "407d48b2-8358-11ec-b72d-5fb7bcf7f02a",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 3,
        //           startAt: "2022-01-30T00:00:00.000Z",
        //           type: "redeem",
        //         },
        //         {
        //           createdAt: "2022-01-28T11:26:32.367Z",
        //           currencyId: "1820a89a-0745-11eb-9412-6ffc5759940f",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 100,
        //           id: "a47cddb3-b47b-1139-9d8b-c79bcd37f815",
        //           math: "rush",
        //           startAt: "2022-01-20T00:00:00.000Z",
        //           type: "redeem",
        //         },
        //         {
        //           createdAt: "2022-01-28T11:26:27.948Z",
        //           currencyId: "1820a89a-0745-11eb-9412-6ffc5759940f",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 50,
        //           id: "a47cddbe-b47a-1139-9d8b-c79bcd37f815",
        //           math: "absolut",
        //           startAt: "2022-01-20T00:00:00.000Z",
        //           type: "redeem",
        //         },
        //         {
        //           createdAt: "2022-01-31T12:38:42.208Z",
        //           currencyId: "1820a89a-0745-11eb-9412-6ffc5759940f",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 1,
        //           id: "a47cddbe-b47a-11e9-9d9b-c79bcd37f815",
        //           math: "percent",
        //           startAt: "2022-01-20T00:00:00.000Z",
        //           type: "redeem",
        //         },
        //         {
        //           bonusReferrer: 1,
        //           charityReferred: 1,
        //           charitySimple: 3,
        //           createdAt: "2021-06-14T00:00:00.000Z",
        //           currencyId: "1820a89a-0745-11eb-9412-6ffc5759940f",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 0.001,
        //           id: "709de17e-cf7f-11eb-8b26-731f225dfe92",
        //           math: "absolut",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 3,
        //           startAt: "2021-06-14T00:00:00.000Z",
        //           type: "redeem",
        //         },
        //         {
        //           bonusRefer: 25,
        //           bonusReferrer: 50,
        //           charityReferred: 3,
        //           charitySimple: 50,
        //           createdAt: "2022-02-18T14:47:59.152Z",
        //           currencyId: "1820a89a-0745-11eb-9412-6ffc5759940f",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 2,
        //           id: "709d9746-cf7f-11eb-8b25-8f42d2b0e61d",
        //           math: "percent",
        //           revenue: 50,
        //           revenueAmbassador: 25,
        //           rewardAmbassador: 2.75,
        //           rewardReferred: 2,
        //           startAt: "2021-06-14T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //       ],
        //     },
        //     status: "expired",
        //     step: 1,
        //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
        //     targetAddress: "TJmHcNJM9SaNz7V3Zfmvgn9J9jqAFscY5z",
        //     targetCurrency: {
        //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
        //       isAvailable: true,
        //       name: "Stratumblue",
        //       onlyAsset: false,
        //       precision: 6,
        //       symbol: "BLU",
        //       taxes: null,
        //       tradeMinimal: 2,
        //       withdrawMinimal: 0.01,
        //     },
        //     targetPrice: 444.646229926697,
        //     type: "purchase",
        //     updatedAt: "2022-03-09T19:30:53.593Z",
        //   },
        //   {
        //     createdAt: "2022-03-09T18:44:38.181Z",
        //     expiresIn: 7200000,
        //     id: "1e5b0c54-9ff2-11ec-a35d-13a21b8c1827",
        //     insertTime: "0001-01-01T00:00:00.000Z",
        //     ip: "187.49.237.178",
        //     lastUpdate: "0001-01-01T00:00:00.000Z",
        //     memberId: "d0868c22-852c-11ec-99bb-6b710ca8c37e",
        //     pinId: "00000000-0000-0000-0000-000000000000",
        //     sellerId: "b118d17a-b411-11eb-9450-47e1e1615544",
        //     settled: true,
        //     settledAt: "2022-03-09T20:27:57.261Z",
        //     sourceAccountId: "03f6db3e-852d-11ec-af49-1fbd999ca8b4",
        //     sourceAmount: 0.000980392156862745,
        //     sourceCurrency: {
        //       id: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //       isAvailable: true,
        //       marketPercent: 22.5,
        //       name: "Bitcoin",
        //       onlyAsset: false,
        //       precision: 8,
        //       symbol: "BTC",
        //       taxes: [
        //         {
        //           bonusRefer: 1,
        //           charityReferred: 3,
        //           charitySimple: 1,
        //           createdAt: "2021-02-01T00:00:00.000Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "e52fa818-6aff-11eb-b00d-8ff92bf3258e",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.25,
        //           rewardAmbassador: 2.75,
        //           rewardReferred: 2,
        //           startAt: "2021-02-01T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusRefer: 1,
        //           charityReferred: 3,
        //           charitySimple: 1,
        //           createdAt: "2020-07-14T00:00:00.000Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "b520ae4a-d065-11ea-b9f2-ab57e2ffff62",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 2.4,
        //           rewardReferred: 2,
        //           startAt: "2020-07-14T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusRefer: 1,
        //           bonusReferrer: 1,
        //           charityReferred: 1,
        //           charitySimple: 3,
        //           createdAt: "2019-03-31T18:17:57.882Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "4f8c3baa-53e1-11e9-a9df-b77dd05ebe45",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 3,
        //           rewardReferred: 2,
        //           startAt: "2019-04-11T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusReferrer: 1,
        //           charityReferred: 1,
        //           charitySimple: 3,
        //           createdAt: "2019-06-19T01:14:00.371Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 0.0010000000474974513,
        //           id: "84fbc814-922f-11e9-9877-1fee431c43ef",
        //           math: "absolut",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 3,
        //           startAt: "2018-11-01T00:00:00.000Z",
        //           type: "redeem",
        //         },
        //       ],
        //       tradeMinimal: 0.002,
        //       withdrawMinimal: 0.02,
        //     },
        //     sourceFee: 0.0000196078,
        //     status: "done",
        //     step: 4,
        //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
        //     targetAddress: "1CFaRTSCmdvcBGZ1tDG8xV14hFXx11nHZJ",
        //     targetAmount: 0.09410477729431171,
        //     targetCurrency: {
        //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
        //       isAvailable: true,
        //       name: "Stratumblue",
        //       onlyAsset: false,
        //       precision: 6,
        //       symbol: "BLU",
        //       taxes: null,
        //       tradeMinimal: 2,
        //       withdrawMinimal: 0.01,
        //     },
        //     targetPrice: 0.010626452616058542,
        //     tokenStatus: "done",
        //     tokenStep: "steps_done",
        //     tokenTxid:
        //       "0x39fba4fe304ee1effea0c84b40a9d1e4de3129376bec60feaaf373dfeff7f306",
        //     type: "purchase",
        //     updatedAt: "2022-03-09T18:48:55.619Z",
        //   },
        //   {
        //     createdAt: "2022-03-09T19:30:44.093Z",
        //     expiresIn: 7200000,
        //     id: "8ef78f5e-9ff8-11ec-aad7-131501a29bb5",
        //     insertTime: "0001-01-01T00:00:00.000Z",
        //     ip: "187.49.237.178",
        //     lastUpdate: "0001-01-01T00:00:00.000Z",
        //     memberId: "b118d17a-b411-11eb-9450-47e1e1615544",
        //     pinId: "00000000-0000-0000-0000-000000000000",
        //     settled: true,
        //     settledAt: "2022-03-09T20:27:57.192Z",
        //     sourceAccountId: "c3b0db20-b411-11eb-a8c0-d792be390a4b",
        //     sourceAmount: 0.000980392156862745,
        //     sourceCurrency: {
        //       id: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //       isAvailable: true,
        //       marketPercent: 22.5,
        //       name: "Bitcoin",
        //       onlyAsset: false,
        //       precision: 8,
        //       symbol: "BTC",
        //       taxes: [
        //         {
        //           bonusRefer: 1,
        //           charityReferred: 3,
        //           charitySimple: 1,
        //           createdAt: "2021-02-01T00:00:00.000Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "e52fa818-6aff-11eb-b00d-8ff92bf3258e",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.25,
        //           rewardAmbassador: 2.75,
        //           rewardReferred: 2,
        //           startAt: "2021-02-01T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusRefer: 1,
        //           charityReferred: 3,
        //           charitySimple: 1,
        //           createdAt: "2020-07-14T00:00:00.000Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "b520ae4a-d065-11ea-b9f2-ab57e2ffff62",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 2.4,
        //           rewardReferred: 2,
        //           startAt: "2020-07-14T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusRefer: 1,
        //           bonusReferrer: 1,
        //           charityReferred: 1,
        //           charitySimple: 3,
        //           createdAt: "2019-03-31T18:17:57.882Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "4f8c3baa-53e1-11e9-a9df-b77dd05ebe45",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 3,
        //           rewardReferred: 2,
        //           startAt: "2019-04-11T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusReferrer: 1,
        //           charityReferred: 1,
        //           charitySimple: 3,
        //           createdAt: "2019-06-19T01:14:00.371Z",
        //           currencyId: "d590882c-f6f4-11e8-b39a-670973f8fec5",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 0.0010000000474974513,
        //           id: "84fbc814-922f-11e9-9877-1fee431c43ef",
        //           math: "absolut",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 3,
        //           startAt: "2018-11-01T00:00:00.000Z",
        //           type: "redeem",
        //         },
        //       ],
        //       tradeMinimal: 0.002,
        //       withdrawMinimal: 0.02,
        //     },
        //     sourceFee: 0.0000196078,
        //     status: "done",
        //     step: 4,
        //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
        //     targetAddress: "1DiSXSs5CTLzKHo8gNjitD93pRBRm617p",
        //     targetAmount: 0.09411989155921884,
        //     targetCurrency: {
        //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
        //       isAvailable: true,
        //       name: "Stratumblue",
        //       onlyAsset: false,
        //       precision: 6,
        //       symbol: "BLU",
        //       taxes: null,
        //       tradeMinimal: 2,
        //       withdrawMinimal: 0.01,
        //     },
        //     targetPrice: 0.010624746164667647,
        //     tokenStatus: "done",
        //     tokenStep: "steps_done",
        //     tokenTxid:
        //       "0x4fde6953b84d2a62dc023a07a4c2f1d78fe0cefbab120a55d6fde3da4b386060",
        //     type: "purchase",
        //     updatedAt: "2022-03-09T19:34:22.063Z",
        //   },
        //   {
        //     createdAt: "2022-03-09T20:57:09.038Z",
        //     expiresIn: 7200000,
        //     id: "a16f260e-a004-11ec-8a7a-0f11d8b26105",
        //     insertTime: "0001-01-01T00:00:00.000Z",
        //     ip: "187.49.237.178",
        //     lastUpdate: "0001-01-01T00:00:00.000Z",
        //     memberId: "404f1146-a6c1-11eb-952b-67d61dfa915c",
        //     pinId: "00000000-0000-0000-0000-000000000000",
        //     sellerId: "b118d17a-b411-11eb-9450-47e1e1615544",
        //     settledAt: "0001-01-01T00:00:00.000Z",
        //     sourceAccountId: "496790aa-a6c1-11eb-b320-bb3daaad15cb",
        //     sourceAmount: 0.0196078431372549,
        //     sourceCurrency: {
        //       id: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
        //       isAvailable: true,
        //       marketPercent: 22.5,
        //       name: "Ethereum",
        //       onlyAsset: false,
        //       precision: 8,
        //       symbol: "ETH",
        //       taxes: [
        //         {
        //           bonusRefer: 1,
        //           charityReferred: 3,
        //           charitySimple: 1,
        //           createdAt: "2021-02-01T00:00:00.000Z",
        //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "e53001f0-6aff-11eb-b011-e7f585edc40d",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.25,
        //           rewardAmbassador: 2.75,
        //           rewardReferred: 2,
        //           startAt: "2021-02-01T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusRefer: 1,
        //           bonusReferrer: 1,
        //           charityReferred: 1,
        //           charitySimple: 3,
        //           createdAt: "2019-08-01T16:37:25.014Z",
        //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "a47cb226-b47a-11e9-9d96-73a1ce6e16f1",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 3,
        //           rewardReferred: 2,
        //           startAt: "2019-03-16T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusReferrer: 1,
        //           charityReferred: 1,
        //           charitySimple: 3,
        //           createdAt: "2021-02-09T15:27:01.495Z",
        //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 0.002,
        //           id: "a47cc2ac-b47a-11e9-9d97-cbb9a5578da5",
        //           math: "absolut",
        //           revenue: 2,
        //           rewardAmbassador: 3,
        //           startAt: "2018-11-01T00:00:00.000Z",
        //           type: "redeem",
        //         },
        //       ],
        //       tradeMinimal: 1e-7,
        //     },
        //     sourceFee: 0.0003921569,
        //     status: "done",
        //     step: 4,
        //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
        //     targetAddress: "0xcd8d921f32462a2c0064c543117e606474581b6f",
        //     targetAmount: 0.12211576411648681,
        //     targetCurrency: {
        //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
        //       isAvailable: true,
        //       name: "Stratumblue",
        //       onlyAsset: false,
        //       precision: 6,
        //       symbol: "BLU",
        //       taxes: null,
        //       tradeMinimal: 2,
        //       withdrawMinimal: 0.01,
        //     },
        //     targetPrice: 0.16377901888389124,
        //     tokenStatus: "done",
        //     tokenStep: "steps_done",
        //     tokenTxid:
        //       "0x96906ba168b4b83d5dbaedc7a614216db26b5ecc07b70b8d9746d88142f36140",
        //     type: "purchase",
        //     updatedAt: "2022-03-09T21:00:50.802Z",
        //   },
        //   {
        //     createdAt: "2022-03-09T21:43:21.482Z",
        //     expiresIn: 7200000,
        //     id: "15f07c66-a00b-11ec-8405-1f4462f65d1d",
        //     insertTime: "0001-01-01T00:00:00.000Z",
        //     ip: "187.49.237.178",
        //     lastUpdate: "0001-01-01T00:00:00.000Z",
        //     memberId: "b118d17a-b411-11eb-9450-47e1e1615544",
        //     pinId: "00000000-0000-0000-0000-000000000000",
        //     settledAt: "0001-01-01T00:00:00.000Z",
        //     sourceAccountId: "a1add374-e32e-11eb-8160-d79ba51bf6fd",
        //     sourceAmount: 49.01960784313726,
        //     sourceCurrency: {
        //       id: "1820a89a-0745-11eb-9412-6ffc5759940f",
        //       isAvailable: true,
        //       name: "Tether",
        //       onlyAsset: false,
        //       precision: 8,
        //       symbol: "USDT",
        //       taxes: [
        //         {
        //           createdAt: "2022-02-01T12:12:40.394Z",
        //           currencyId: "1820a89a-0745-11eb-9412-6ffc5759940f",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 50,
        //           id: "407d59ce-8358-11ec-b72f-0b95b1c736fd",
        //           math: "absolut",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 3,
        //           startAt: "2022-01-30T00:00:00.000Z",
        //           type: "redeem",
        //         },
        //         {
        //           createdAt: "2022-02-01T12:12:40.394Z",
        //           currencyId: "1820a89a-0745-11eb-9412-6ffc5759940f",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 100,
        //           id: "407d530c-8358-11ec-b72e-775b917068b1",
        //           math: "rush",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 3,
        //           startAt: "2022-01-30T00:00:00.000Z",
        //           type: "redeem",
        //         },
        //         {
        //           createdAt: "2022-02-01T12:12:40.394Z",
        //           currencyId: "1820a89a-0745-11eb-9412-6ffc5759940f",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 1,
        //           id: "407d48b2-8358-11ec-b72d-5fb7bcf7f02a",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 3,
        //           startAt: "2022-01-30T00:00:00.000Z",
        //           type: "redeem",
        //         },
        //         {
        //           createdAt: "2022-01-28T11:26:32.367Z",
        //           currencyId: "1820a89a-0745-11eb-9412-6ffc5759940f",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 100,
        //           id: "a47cddb3-b47b-1139-9d8b-c79bcd37f815",
        //           math: "rush",
        //           startAt: "2022-01-20T00:00:00.000Z",
        //           type: "redeem",
        //         },
        //         {
        //           createdAt: "2022-01-28T11:26:27.948Z",
        //           currencyId: "1820a89a-0745-11eb-9412-6ffc5759940f",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 50,
        //           id: "a47cddbe-b47a-1139-9d8b-c79bcd37f815",
        //           math: "absolut",
        //           startAt: "2022-01-20T00:00:00.000Z",
        //           type: "redeem",
        //         },
        //         {
        //           createdAt: "2022-01-31T12:38:42.208Z",
        //           currencyId: "1820a89a-0745-11eb-9412-6ffc5759940f",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 1,
        //           id: "a47cddbe-b47a-11e9-9d9b-c79bcd37f815",
        //           math: "percent",
        //           startAt: "2022-01-20T00:00:00.000Z",
        //           type: "redeem",
        //         },
        //         {
        //           bonusReferrer: 1,
        //           charityReferred: 1,
        //           charitySimple: 3,
        //           createdAt: "2021-06-14T00:00:00.000Z",
        //           currencyId: "1820a89a-0745-11eb-9412-6ffc5759940f",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 0.001,
        //           id: "709de17e-cf7f-11eb-8b26-731f225dfe92",
        //           math: "absolut",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 3,
        //           startAt: "2021-06-14T00:00:00.000Z",
        //           type: "redeem",
        //         },
        //         {
        //           bonusRefer: 25,
        //           bonusReferrer: 50,
        //           charityReferred: 3,
        //           charitySimple: 50,
        //           createdAt: "2022-02-18T14:47:59.152Z",
        //           currencyId: "1820a89a-0745-11eb-9412-6ffc5759940f",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 2,
        //           id: "709d9746-cf7f-11eb-8b25-8f42d2b0e61d",
        //           math: "percent",
        //           revenue: 50,
        //           revenueAmbassador: 25,
        //           rewardAmbassador: 2.75,
        //           rewardReferred: 2,
        //           startAt: "2021-06-14T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //       ],
        //     },
        //     sourceFee: 0.9803921569,
        //     status: "done",
        //     step: 4,
        //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
        //     targetAddress: "TFH9ZYmYYxCF3qq1xeMHG99ZcJXT3TnT66",
        //     targetAmount: 0.11247538116212005,
        //     targetCurrency: {
        //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
        //       isAvailable: true,
        //       name: "Stratumblue",
        //       onlyAsset: false,
        //       precision: 6,
        //       symbol: "BLU",
        //       taxes: null,
        //       tradeMinimal: 2,
        //       withdrawMinimal: 0.01,
        //     },
        //     targetPrice: 444.5417253395935,
        //     tokenStatus: "done",
        //     tokenStep: "steps_done",
        //     tokenTxid:
        //       "0x603e355bd377c5b8adfc478b222d0b164fe659cb2c7a338325b67103018a2d99",
        //     type: "purchase",
        //     updatedAt: "2022-03-09T21:46:55.131Z",
        //   },
        //   {
        //     createdAt: "2022-03-09T21:28:38.101Z",
        //     expiresIn: 7200000,
        //     id: "07674474-a009-11ec-88a6-bf4d7e8c0b84",
        //     insertTime: "0001-01-01T00:00:00.000Z",
        //     ip: "187.49.237.178",
        //     lastUpdate: "0001-01-01T00:00:00.000Z",
        //     memberId: "64295ab8-1b7b-11ea-9d70-9ba1b056b4f5",
        //     pinId: "00000000-0000-0000-0000-000000000000",
        //     sellerId: "b118d17a-b411-11eb-9450-47e1e1615544",
        //     settledAt: "0001-01-01T00:00:00.000Z",
        //     sourceAccountId: "cb9b6c04-1b7b-11ea-9d72-7b7a61a5f57a",
        //     sourceAmount: 0.00980392156862745,
        //     sourceCurrency: {
        //       id: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
        //       isAvailable: true,
        //       marketPercent: 22.5,
        //       name: "Ethereum",
        //       onlyAsset: false,
        //       precision: 8,
        //       symbol: "ETH",
        //       taxes: [
        //         {
        //           bonusRefer: 1,
        //           charityReferred: 3,
        //           charitySimple: 1,
        //           createdAt: "2021-02-01T00:00:00.000Z",
        //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "e53001f0-6aff-11eb-b011-e7f585edc40d",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.25,
        //           rewardAmbassador: 2.75,
        //           rewardReferred: 2,
        //           startAt: "2021-02-01T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusRefer: 1,
        //           bonusReferrer: 1,
        //           charityReferred: 1,
        //           charitySimple: 3,
        //           createdAt: "2019-08-01T16:37:25.014Z",
        //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 6,
        //           id: "a47cb226-b47a-11e9-9d96-73a1ce6e16f1",
        //           math: "percent",
        //           revenue: 2,
        //           revenueAmbassador: 3.6,
        //           rewardAmbassador: 3,
        //           rewardReferred: 2,
        //           startAt: "2019-03-16T00:00:00.000Z",
        //           type: "purchase",
        //         },
        //         {
        //           bonusReferrer: 1,
        //           charityReferred: 1,
        //           charitySimple: 3,
        //           createdAt: "2021-02-09T15:27:01.495Z",
        //           currencyId: "d5908f20-f6f4-11e8-b39b-fbf72a71eb72",
        //           endAt: "2090-01-01T00:00:00.000Z",
        //           fee: 0.002,
        //           id: "a47cc2ac-b47a-11e9-9d97-cbb9a5578da5",
        //           math: "absolut",
        //           revenue: 2,
        //           rewardAmbassador: 3,
        //           startAt: "2018-11-01T00:00:00.000Z",
        //           type: "redeem",
        //         },
        //       ],
        //       tradeMinimal: 1e-7,
        //     },
        //     sourceFee: 0.0001960784,
        //     status: "done",
        //     step: 4,
        //     targetAccountId: "d63feaba-f6f4-11e8-b3c4-1b1e04815f47",
        //     targetAddress: "0x6967a8d5b432862bee3c43c8196c952fe5139d9a",
        //     targetAmount: 0.060918698487736234,
        //     targetCurrency: {
        //       id: "d590902e-f6f4-11e8-b39c-bf859d0767d0",
        //       isAvailable: true,
        //       name: "Stratumblue",
        //       onlyAsset: false,
        //       precision: 6,
        //       symbol: "BLU",
        //       taxes: null,
        //       tradeMinimal: 2,
        //       withdrawMinimal: 0.01,
        //     },
        //     targetPrice: 0.16415321103159464,
        //     tokenStatus: "done",
        //     tokenStep: "steps_done",
        //     tokenTxid:
        //       "0xb15824ad9e83614fbb341662178bd9f31fd70e28fdd20347f72861faa1ef8ddd",
        //     type: "purchase",
        //     updatedAt: "2022-03-09T21:33:34.252Z",
        //   },
        // ];

        // this.purchasesOnPage = teste;
      } catch (e) {
        console.log(e);
      }
    },

    sortByCreatedAt(array) {
      array.sort((a, b) => {
        if (new Date(a.createdAt) > new Date(b.createdAt)) return 1;
        if (new Date(a.createdAt) < new Date(b.createdAt)) return -1;
        return 0;
      });

      var today = new Date();
      this.filterEndDate = today;
      this.filterStartDate = array[0].createdAt;
      return array;
    },

    applyFilter() {
      let startDateOnInput = this.filterStartDate;
      let endDateOnInput = this.filterEndDate;

      let date1 = new Date(startDateOnInput);
      let date2 = new Date(endDateOnInput);

      let startDate = `${date1.getFullYear()}-${
        date1.getMonth() + 1 < 10
          ? "0" + (date1.getMonth() + 1)
          : date1.getMonth() + 1
      }-${
        date1.getDate() < 10 ? "0" + date1.getDate() : date1.getDate()
      }T00:00:00.000Z`;

      let endDate = `${date2.getFullYear()}-${
        date2.getMonth() + 1 < 10
          ? "0" + (date2.getMonth() + 1)
          : date2.getMonth() + 1
      }-${
        date2.getDate() < 10 ? "0" + date2.getDate() : date2.getDate()
      }T23:59:999Z`;

      this.filterRowByDate(startDate, endDate);
    },

    filterRowByDate(startDate, endDate) {
      this.purchasesOnPage = this.purchases;

      this.purchasesOnPage = this.purchasesOnPage.filter((item) => {
        return item.createdAt > startDate && item.createdAt < endDate;
      });

      if (this.statusFilter != "all") {
        this.purchasesOnPage = this.purchasesOnPage.filter((item) => {
          return item.status == this.statusFilter;
        });
      }
    },

    clearFilter() {
      let vm = this;
      this.purchasesOnPage = this.purchases;
      this.statusFilter = "all";
    },

    customSearch(row, col, cellValue, searchTerm) {
      let vm = this;
      if (String(cellValue).indexOf("" + searchTerm) >= 0) {
        vm.csv_data = vm.rowsOnPage;

        return cellValue;
      }
    },

    ajustTokenID(tokenID) {
      let str = tokenID;
      let res = str.substring(0, 15);

      return res + "... [+]";
    },

    async getCertificateByID(transcationId, transactionType) {
      let params = {
        type: "trade",
        id: transcationId,
      };

      try {
        let resp = await this.$store.dispatch("getCertificateByTypeId", params);
        const url = window.URL.createObjectURL(new Blob([resp.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "certificate_" + transcationId + ".pdf"); //or any other extension
        document.body.appendChild(link);
        link.click();
      } catch (e) {
        this.logError(e);
      }
    },

    getDetails(params) {
      // this.getTransactionDetails(params.type, params.id);
      console.log(params)

      this.transactionData = params
    },

    async getTransactionDetails(transactionType, transactionId) {
      let operation;
      operation =
        transactionType.charAt(0).toUpperCase() + transactionType.slice(1);
      try {
        let resp = await this.$store.dispatch(
          "get" + operation + "ById",
          transactionId
        );
        this.transactionData = resp.data;
      } catch (e) {
        this.logError(e);
      }
    },

    clearTransactionData() {
      this.transactionData = "";
    },

    async updateCancelled(id) {
      this.clearTransactionData();
      try {
        await this.$store.dispatch("putCancelPurchase", id);
        this.$emit("updateCancelled", id);
      } catch (e) {
        console.log(e);
      }
      this.getTransactions();
    },

    formatDate(value) {
      return spacetime(value).format("dd/MM/yyyy HH:mm:SS");
    },
  },
  computed: {},
  watch: {},
};
</script>



// WEBPACK FOOTER //
// src/components/private/transactions/TransactionTablePurchase.vue